import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { CustomDatePipe } from './../pipes/custom-date.pipe';
import { HttpClient } from '@angular/common/http';
import { Component, Renderer2, Input, OnInit, ViewChild, ViewEncapsulation, ElementRef, HostListener, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { api } from '../URL/api-url';
import Swal from 'sweetalert2';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TitleCasePipe } from '@angular/common';
import { PhoneNoFormatPipe } from '../pipes/phone-no-format.pipe';
import { saveAs } from 'file-saver';
import { SignaturePad } from 'angular2-signaturepad';
import { Observable, ReplaySubject } from 'rxjs';
import { Router, ActivatedRoute } from "@angular/router";
import { LoaderService } from 'src/app/services/loader.service';
import { adjustWith2DecimalsForUI, BackdatedReasons, sumBy } from "./../CommonFunctions/common-functions";
import { AuthorizeNetService } from '../services/authorize-net.service';
import SwiperCore, { Navigation, EffectCoverflow, Pagination, Swiper } from "swiper";
import { formatDate } from '@angular/common';
import Cookies from 'js-cookie'
import { ChangeDetectorRef } from '@angular/core';


import { SafeResourceUrl, DomSanitizer, SafeHtml } from "@angular/platform-browser";
import jsPDF from 'jspdf';

import moment from 'moment';
import { checkValidObject, invoiceFilter } from '../CommonFunctions/common-functions';
import { HeaderComponent } from '../header/header.component';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { BookingComponent } from '../booking/booking.component';
import { ApiCommonService } from '../services/api-common.service';
import { CONSTANTS } from '../constants';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { CommonService } from '@ideabytes/groupbenefitz_common_ui';
import { normalizeDateFields, parseDateOnly, toApiDate, toDisplayDate, toLegacyUsDate } from '../CommonFunctions/date-utils';

declare var Accept: any;

SwiperCore.use([Navigation, Pagination, EffectCoverflow]);

const BENEFICIARY_RELATIONSHIPS = [
  { value: 'SPOUSE', label: 'Spouse' },
  { value: 'CHILDREN', label: 'Child' },
  { value: 'COMMON_LAW', label: 'Common Law' },
  { value: 'OTHER', label: 'Other' },
];


@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css'],
  providers: [DatePipe, TitleCasePipe, DecimalPipe, PhoneNoFormatPipe, CustomDatePipe],
  encapsulation: ViewEncapsulation.None
})
export class OverviewComponent implements OnInit {
  planobjdataobj: any = {};
  addbenificaryData: any = []
  modifiedBlocksCoveredByCompany: any;
  modifiedBlocksPaidByCompany: any;
  mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = [];
  public specialplans: any;
  public specialpackages: any;
  public formData: any;
  public allFormData: any = {};
  public packagesInBlocks: any;
  public basepackages: any;
  public customerSelectedPlans: any;
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  public companypaidproductid: any = [];
  public disabledcompanypaidproductid: any = [];
  public removedisabledcompanypaidproductid: any = [];
  public adddisabledcompanypaidproductid: any = [];
  public isDisabledplan: boolean = false;
  isExecutiveCP: boolean = false;
public claimsDepositInfo: any = null;
public claimsform: FormGroup = new FormGroup({
  bankcode: new FormControl(''),
  transitNumber: new FormControl(''),
  accountNo: new FormControl(''),
  files: new FormControl(''),
});
public claimsUpdate: boolean = false;        // true -> "Update Claims", false -> "Add Claims"
public claimsBankVerified: boolean = false;
public claimsBankInfo: any;
public claimsAddress: any;
public claimsUploadCheque: boolean = false;
public claimsVoidCheque: any;
public claimsFileType: any;
public claimsImageDisplay: any;
public claimsPaymentMethodOption: string = ''; // 'same' | 'other'
public claimsResetButton: boolean = false;
public claimsVoidCheckImage: any;
public claimsLoading: boolean = true;

claimsPdfLoaded(event: any) {
  this.claimsLoading = false;
}
public isVikingCustomer: boolean = false;

  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;
  public alloptinplans: any = [];
  public showPaymenthMethod: boolean = false;
  public showPaymenthMethod1: boolean = true;
  public creditcardform: boolean = false;
  public bankpaymentmethod: any;
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public backdatedReasonsArr: any = [];

  public companySelectedPlans: any = [];
  public companyCoveredPlans: any = [];
  public EmployeeSelectedPlans: any = [];
  public allSelectedPlans: any = [];
  public companyDealingPlans: any = [];

  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  deltaCompanyTax: any;
  spouseDob: Date = new Date();
  beneficiaries: any = [];
  beneficiaries1: any = [];
  beneficiariesConst: any = [];
  beneficiary: any = {};
  hoverStates: {
    [index: number]: boolean
  } = {};
  currencySymbol: string = "$";
  currentBeneficiary: any = { customerType: '', type: '' };
  benficiaryIsMemberDetails: any = {};
  benficiaryIsSpouseDetails: any = {};
  beneficiaryReload: number = 0;

  addPlanForm: FormGroup = new FormGroup({
    planEnrollmentDate: new FormControl(''),
  });

  cancelPlanForm: FormGroup = new FormGroup({
    terminationDate: new FormControl(''),
  });
  provianceList: any;
  isBackdated: any = false;
  planChanges: any = false;
  addressform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    line1: new FormControl(''),
    line2: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
    province: new FormControl(''),
    postalCode: new FormControl(''),
  primaryPhone: new FormControl('', [RxwebValidators.pattern({ expression: { tenDigits: /^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/ } })]),
  secondaryPhone: new FormControl('', [RxwebValidators.pattern({ expression: { tenDigits: /^[0-9]{10}$|^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$|^\+1 \([0-9]{3}\)[0-9]{3}-[0-9]{4}$/ } })]),
    email: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    // Viking only
    initial: new FormControl(''),
    provinceHealthCareNumber: new FormControl(''),
    dateOfRetirement: new FormControl(''),
    poBox: new FormControl(''),
    previousEmployer: new FormControl(''),
    employerPhoneOrEmail: new FormControl(''),
    lastDayOfGroupBenefits: new FormControl(''),
    certificatePolicyNumber: new FormControl(''),
    previousBenefitProvider: new FormControl(''),
  });

  phoneform: FormGroup = new FormGroup({
  primaryPhone: new FormControl('', [RxwebValidators.pattern({ expression: { tenDigits: /^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/ } })]),
  secondaryPhone: new FormControl('', [RxwebValidators.pattern({ expression: { tenDigits: /^[0-9]{10}$|^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$|^\+1 \([0-9]{3}\)[0-9]{3}-[0-9]{4}$/ } })]),
});

  dependentTypeForm: FormGroup = new FormGroup({
    dependentType: new FormControl(''),
    marriageType: new FormControl(''),
    marriageDate: new FormControl(''),
    childrenCountData: new FormControl('0'),
    effectiveDate: new FormControl('')
  });
  dependentTypeForm1: FormGroup = new FormGroup({
    effectiveDate: new FormControl('')
  });

  spouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(toApiDate(this.spouseDob)),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    gender: new FormControl(''),
    upgradePlan: new FormControl(''),
    status: new FormControl('')
  });

  updatespouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(toApiDate(this.spouseDob)),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
    status: new FormControl('')
  });

  deletespouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(toApiDate(this.spouseDob)),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
    status: new FormControl(''),
    reason: new FormControl('')
  });



  deletedependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    effectiveDate: new FormControl(''),
  });

  dependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    effectiveDate: new FormControl(''),
  });

  pureDependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
  });

  paymentform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  ccform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    Id: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  padform: FormGroup = new FormGroup({
    bankcode: new FormControl(''),
    transitNumber: new FormControl(''),
    accountNo: new FormControl(''),
    bankdetails: new FormControl(''),
    file: new FormControl(''),
  });

  paymentMethodForm: FormGroup = new FormGroup({
    bankCode: new FormControl(''),
    branchCode: new FormControl(''),
    accountNumber: new FormControl(''),
    files: new FormControl(''),
    paymentmethod: new FormControl(''),
  });

  valisignform: FormGroup = new FormGroup({
    code: new FormControl(''),
  });
  dummyResources: any[] = [];
  selectedResource: any
  dynamicForm!: FormGroup;

  sanitizedFormUrl: SafeResourceUrl | null = null;

  invoicesList: any[] = [];
  hicList: any[] = [];
  @Input() customerId: any;
  customerData: any;
  form_typess: any;
  childrenInfo: any[] = [];
  childrenId: any;
  paymentMethod: any;
  spouseInsurer: any;
  roe: any;
  viewRoe: boolean = true;
  formConfiguration: any;
  beneficiaryValidations: any = [];
  selectedTab: any = 'tab1';
  healthCard: any = false;
  src: any;
  spouseCoverage: any;
  childCoverage: any;
  specialNeeds: any;
  postSecondaryStudent: any;
  graduationDate = true;
  coverage: any = 'open';
  isDependentPlanChange: any = true;
  dependentCoverage = 'close';
  bookletList: any[] = [];
  bookletList1: any[] = [];
  isDeleteDisabled: any = true;
  displayStyle = 'none';
  displayBooklet = 'none';
  roeUrl: any;
  secondaryPhone: any;
  invalidpostalcodeprivince: boolean = false;
  configprovinceres: any;
  openUpdatePaymentForm: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  postalvalue: any;
  resetButton = false;
  resetbutton = false;
  uploadCheque = false;
  bankInfo: any;
  bank: any;
  bankAddress: any[] = [];
  displayTimer: any;
  showTimer: any;
  startTimer: any;
  customerid: any;
  accessToken: any;
  invoiceResponse: any;
  creditCardNo: any;
  expire: any;
  bookletLink: any;
  booklet_link: any;
  support_link: any;
  health_card: any;
  hidebooklet: any = false;
  upcomingInvoice: any;
  spouseId: any;
  fusebillId: any;
  advisor: any;
  corporateDetails: any;
  paymentVoidCheque: any;
  imagedisplay: any;
  address: any;
  fileExtension: any;
  signatureImg: any;
  encBank: any;
  showIAFG: any;
  iafgSubscriptionPendingNotification: any;
  iafgSubscriptionConfirmation: any;
  medicalQuestionaireStatus: any;
  pendingMedicalQuestionaire: any;
  pendingMedicalQuestionaireCoverage: any;
  inviteEmails: any = [];
  iafg: any;
  @ViewChild(SignaturePad) signaturePad!: SignaturePad;
signaturePadOptions: Object = {
  'minWidth': 2,
  'canvasWidth': 400,
  'canvasHeight': 150
};
  deleteBenfIds: any = [];
  deleteBenfIds1: any = [];
  spouseData: any;
  spouseUpdate: any;
  spouseStatus: any;
  spouseInfo: any;
  dependentData: any;
  dependentUpdate: any;
  dependentStatus: any;
  currentDeleteMember: any = "spouse";
  selectedBase64: any;
  expireMonth: any;
  expireYear: any;
  invalidExpiration = false;
  showImage = false;
  bankDetails = false;
  bankinfo = false;
  cheque = false;
  additionalDetails: any;
  pad: any;
  iafgplansCheck: any = [];
  signedPad: any;
  PADdetails: any;
  bankCode: any;
  transitNumber: any;
  accountNumber: any;
  banknameres: any;
  items: any = 1;
  cardNumber: any;
  currentIndex = 1;
  link: any;
  showconfirm: any = false;
  selectedLanguage: any;
  latestPaymentStatus: string | null = null;

@ViewChild('bookingRef')
bookingComp?: BookingComponent;
  @ViewChild('closePhonemodal') closePhonemodal: any;
  @ViewChild('closeAddressmodal') closeAddressmodal: any;
  @ViewChild('closeSpousemodal') closeSpousemodal: any;
  @ViewChild('closeDependentmodal') closeDependentmodal: any;
  @ViewChild('closePaymentmodal') closePaymentmodal: any;
  @ViewChild('openRoe') openRoe: any;
  @ViewChild('videoPopup') openPopup: any;
  @ViewChild('iframePopup') openiframe: any;
  @ViewChild('equitablePopup') openequitable: any;
  @ViewChild('supportPopup') opensupport: any;
  @ViewChild('closePaymenttoPAD') closePaymenttoPAD: any;
  @ViewChild('closeClaimsmodal') closeClaimsmodal: any;
  signatureImage: string = '';
  filename: any;
  padfilename: any;
  ext: any;
  mimetype: any;
  previewbutton: boolean = false;
  updatepreviewbutton: boolean = false;
  changetopad: boolean = false;
  invoicedraftData: any;
  paymentUri: any;
  paymentsuccessuri: any;
  publicapikey: any;
  paymentform2: any;
  recaptchaResponse: any;
  fusbillinfocaptchavalue: any;
  fullName: any;
  voidCheque1: any;
  voidCheque2: any;
  bankinformation: any;
  paymentMethodId: any;
  padAgreement: any;
  existVoid: any;
  review: any;
  fuseBillKey: any;
  voidCheckImage: any;
  voidCheckFileType: any;
  ccDetails: any;
  stateId: any;
  countryId: any;
  customerID: any;
  card: any;
  spouse: any;
  index: any = 1;
  lang: any = {};
  lang1: any = {};
  gender: any;
  dependentBackgroundColor: any[] = [];
  plans: any;
  benefits: any;
  unlistener: any;
  videoLink: any;
  videoTitle: any;
  videoPopup: any = 'none';
  iframeLink: any;
  iframeTitle: any;
  customerInvoices: any[] = [];
  registrationDate: any;
  iafgDays: any;

  currentIndexOfSwipperDependents: any = 1;

  currentIndexOfSwipperDownload: any = 1;

  currentIndexOfSwipperPlan: any = 1;

  currentIndexOfSwipperBenifits: any = 1;
  @ViewChild('videoPlayer') videoplayer: any;

  public startedPlay: boolean = false;

  public show: boolean = false;
  logo: any;
  bookingInformation: any[] = [];
  editSpouse: boolean = true;
  editChild: boolean = false;
  logoimage: any;
  headerName: any;
  voidCheckPdf: any;
  url: any;
  minDate: any;
  maxDate: any;
  isViking: boolean = false;
  addressFormOldValues: any = {};
  // Beneficiary edit (ported from admin portal)
  benficiaryForm!: FormGroup;
  stagingBeneficiaryData: any[] = [];
  originalBeneficiaries: any[] = [];
  showBenificiaryForm: boolean = true;
  addeditbenficiary: boolean = false;
  BenficairyModalAddAndUpdateButton: string = '';
  beneficiaryRelationships = BENEFICIARY_RELATIONSHIPS;
  editBenficiaryIndex: any;
  trusteeCheck: boolean = false;
  childmaxDate: Date = new Date();
  benficiaryCount: boolean = false;
  benficiaryCountMessage: any;
  minDatechild: any;
  minDateHire: any;
  maxDatechild: any;
  memberportalgreensShildCheck: any;
  memberportalEquitabelCheck: any;
  secondaryphonecheck: boolean = false;
  failedsignature: any;
  showinvoiceMessage: any;
  isCorporateAccount: any;
  invoiceslink: any;
  getCustomerDraftDetails: any;
  getCustomerDraftDate: any;
  showViewPlansLoading: boolean = true;
  loading: boolean = true;
  showROES: any[] = [];
  waddelCustomer: any;
  showupdatesignatue: boolean = true;
  memberDOB: any;
  cardType: string = '';
  public invalidcreditcard: boolean = false;
  invalidcreditcarddetails: boolean = false;
  customerFinalInvoices: any[] = [];
  customerFinalInvoicesIGBMS: any[] = [];
  allCustomerFinalInvoices: any = [];
  allCustomerFinalInvoicesIGBMS: any = [];
  getCustomerDraftDate1: any = "";
  filterDateSelection: any = "";
  filteredInvoices: any = [];
  filterInvoice: any = "All";
  planLevelId: number = 0;
  maxDateForPicker: Date = new Date();
  @Input() formConfig!: any;
  currentYear: any;
  @ViewChild(HeaderComponent) header!: HeaderComponent;
  @ViewChild(SideBarComponent) sidebar!: SideBarComponent;

  criticalInsurance: any = [{
    title: 'Subscription Details',
    logo: 'img_link',
    data: '30 days'
  },
  {
    title: 'Questions Details',
    logo: 'img_link',
    data: 'questions data'
  }
  ]
  normalSpouseRegistration: any;
  noReason: any = ''
  normalDependentRegistration: any;
  dependentType: any;
  isMarried: any;
  isCommonLaw: any;
  showDependent: any;
  dummyDependentData: any;
  marriageType: any;
  isInsuranceCheck: boolean = false;
  childCount: any = 0;
  showChildForm: boolean = false;
  childrenDetails: any = [];
  editChildUpdate: boolean = false;
  childIndex: any = 0;
  mode: any;
  dummyPlanAndPriceChangeData: any;
  validateCheck: any = true;
  showValidatePlans: boolean = false;
  combinedPlanAndPriceChangeData: any;
  customerRegisteredServices: any = [];
  todayDate: any;
  validatePlansData: any;
  displayPackage: any;
  role: any = '';
  plansError: boolean = false;
  cartcheckvalue: any;
  plansObj: any;
  warningsData: any;
  addPlanEnrollmentDate: any;
  unselected: any = [];
  selectedPlans_: any = [];
  downgradePlans: any = [];
  unSelectedPlans_: any = [];
  newlySelectedPlans: any = [];
  planobjdata!: { packageId: any; packageName: any; planproductname: any; groupid: any; groupName: any; id: any; name: any; planLevel: any; planLevelParent: any; fusebillPlanID: any; planFrequencyID: any; isBundle: any; coverage: any; planCoverage: any; bundledProducts: any[]; products: any[]; };
  planssummaryopt: any;
  planAmount: any;
  plansskumain: any = [];
  planssummarymain: any;
  plandetailsobjvalue: any;
  optionstitle: any;
  showoptions: any;
  showPlanDetails: any = false;
  showSpouseInfo: any = false;
  maritalStatus: any;
  handlePlanUpgrade: any;
  priceChangeText: any;
  coverageChangeText: any;
  provisioningSites: any;
  coverageChange: any;
  hasSpouse: any = false;
  hasChildren: any = false;
  planEnrollmentDates: any;
  showROAS: any[] = [];
  addDependentWithSpouse: boolean = false;
  dependentChildCoverage: string = 'undefined';
  plansSummaryObj: any = [];
  firstColumn = ['Plan Name', 'Coverage', 'Price', 'Tax']
  signaturecheckvalue1cc: any;
  signaturePadIsEmpty: boolean = true;
  public signaturemessagecc: boolean = false;
  public signaturecheckvaluecc: boolean = false;
  public signaturecheckcc: boolean = true;
  spouseCovered: any = false;
  childCovered: any = false;
  totalCount: number = 0;
  totalSummaryPrice: any = 0;
  oldExistingPlans: any = [];
  selectedTrues: any = [];
  isSpouseExists: any = false;
  isUpgradeOrDowngrade: any = '';
  productobj: any = {};
  selectedDependentDetails: any = {};
  customerPlans: any;
  upgradeorDowngradeplans: any = []
  upgradeorDowngradeplansSelected: any = []
  isCorpCustomer: boolean = false;
  Displayproducts: any;

  applicantSpousename: any;
  applicantfirstname: any;
  applicantChildrenname: any;
  lecHistory: any = [];
  marriedDate: any;
  padView: any;
  ccExpiryTitle: any = '';
  ccExpiryColor: any = '';
  isReauth: boolean = false;
  isRetryPayment: boolean = false;
  paymentPlatform: any;
  migratingFromStaxbill: any = false;
  authorizenetCustomerId: any;
  enrollmentdate: any;
  filteredPlans: any = [];
  relationType: any = '';
  lifePlansData: any = [];
  aupeLifePlansData: any = [];
  iafgLifePlansData: any = [];
  formAttr: any = '';
  signatureOrCanvas: any = 'signature-pad';
  totalPages: any = 0;
  page: any = 1;
  hideSidebarMenus: boolean = false;
  lifeGroupedPlans: any = {
    LIFE: [],
    AUPE: []
  };
  groupedPlansArray: any = [];
  orderedCoverages: ('self' | 'spouse')[] = [];

  eqationStaffing: boolean = false;
  copiedText: string | null = null;
  session: Record<string, string> = {};
  currClient: any = '';

  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public elementRef: ElementRef,
    private _decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private titleCase: TitleCasePipe,
    private phoneNoFormat: PhoneNoFormatPipe,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private renderer2: Renderer2,
    private router: Router,
    public _LoaderService: LoaderService,
    private _CustomDatePipe: CustomDatePipe,
    private authorizeNetService: AuthorizeNetService,
    private apiCommonService: ApiCommonService,
    private cdr: ChangeDetectorRef,
    private commonSerivce: CommonService
  ) {

  }
  @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  disabledelement: any;

  eligibility: any = null;
  disableOrderButton: boolean = false;
  nextAvailableDate: string | null = null;
  lastOrdered: string | null = null;
  eligibilityMessage: string = '';
  modalEligibility:any;

  hasMedcanMembership = false;   
  api = api;
private checkOrderServicesEligibility() {
  this.http
    .get(`${this.api.url}/customer/v3/${this.customerid}/plans/false`, {
      headers: { Authorization: 'Bearer ' + this.accessToken },
    })
    .subscribe({
      next: (response: any) => {
  console.log('checkOrderServicesEligibility response:', response);
  if (response.status == 200) {
    this.planLevelId = response?.data?.executivePlanOptionsApplicable ? 18 : 0;
    this.hasMedcanMembership = response?.data?.hasMedcanMembership ?? false;
    console.log('planLevelId set to:', this.planLevelId, 'hasMedcanMembership:', this.hasMedcanMembership);
  }
},
      error: (err) => console.error('checkOrderServicesEligibility failed', err),
    });
}
  ngOnInit() {
    let customerId = this.getSession('customerId');
    let client = sessionStorage.getItem('currClient');
    if(client){
      this.currClient = client
    }
    let customerName = this.getSession('customerName');
    this.apiCommonService.getAndSubmitCookies('Home', true, { customerId, customerName });
    this.apiCommonService.getAndSubmitCookies('Error', true, { customerId, customerName });
    setTimeout(() => {
      this.setSession('pageName', 'Dashboard');
    }, 100);
    console.log(this.formConfig);
  setTimeout(() => {
  console.log('ABOUT TO CALL loadMedcanEligibility, customerData:', this.customerData);
  this.loadMedcanEligibility();
}, 1000);
    this.getLanguageTokens();

    this.showDependent = false;

    this.planEnrollmentDates = [
      moment().subtract(1, 'months').startOf('month').format('MMM-DD-YYYY'), // Previous month
      moment().startOf('month').format('MMM-DD-YYYY'),
      moment().add(1, 'months').startOf('month').format('MMM-DD-YYYY'),
      moment().add(2, 'months').startOf('month').format('MMM-DD-YYYY')
    ]
    this.currentYear = Number(new Date().getFullYear());

    setTimeout(() => {
      this.sigPadElement = this.sigPad?.nativeElement;
      if (this.sigPadElement) {
        this.context = this.sigPadElement.getContext('2d');
        this.context.strokeStyle = 'black';
      }
    }, 10000);
    this.minDate = moment().subtract(100, "years").calendar();
    this.maxDate = moment().subtract(16, "years").calendar();

    this.minDate = new Date(this.minDate);

    this.maxDate = new Date(this.maxDate);

    this.minDateHire = moment().subtract(60, "years").calendar();

    this.minDatechild = new Date(this.minDateHire);
    this.maxDatechild = new Date();
    this.getFormConfiguration('en');
    this.dependentBackgroundColor = ["#E6D1FF",
      "#FFE2FB",
      "#E2F1FF",
      "#E6D1FF",]
    this.customerid = this.getSession('customerId');
    this.accessToken = this.getSession('accessToken');
    this.checkOrderServicesEligibility();
    this.getCustomerData();

    this.getHealthBooklets();
    this.getPlanes();
    this.route.queryParams.subscribe(params => {
    })
    this.logoimage = this.getSession("logo")
    this.unlistener = this.renderer2.listen("document", "click", event => {
      let element = event.target
      var attribute = element.getAttribute("href");
      var heading = element.innerText;
      if (event.target.className == 'video') {
        event.preventDefault();
        this.videoLink = attribute;
        this.videoTitle = heading;
        var video = document.getElementsByTagName('video')[0];

        this.openVideoPopup();
        video.load();
        video.play();
      }
      if (event.target.className == 'shortlink') {
        this.openSupportPopup();
        this.support_link = this.sanitizer.bypassSecurityTrustResourceUrl(attribute);
        event.preventDefault();
      }
      if (event.target.className == 'booklet') {
        this.openequitablePopup();
        event.preventDefault();
        this.booklet_link = element.getAttribute("href");
        console.log('1235 element', element);
        console.log('1235 booklet_link', this.booklet_link);
      }
      if (event.target.className == 'healthcard') {
        this.health_card = element.getAttribute("href");
        console.log('element', element);
        this.downloadCard();
        event.preventDefault();
      }
      if (event.target.classList.contains('closevideo')) {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'closevideo') {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'drugsmart') {
        event.preventDefault();
        window.open("https://drugsmart-pharmacy.myshopify.com/account/register",
          "Register Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.className == 'bedrugsmart') {
        event.preventDefault();
        window.open("https://bedrugsmart.ca/pages/direct2u",
          "Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.classList.contains('site')) {
        if (attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions') {
          attribute = 'https://www.myfriendlylawyer.com/subscriptions';
        }
        this.iframeLink = this.sanitizer.bypassSecurityTrustResourceUrl(attribute)
        this.iframeTitle = heading;
        if (this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://groupbenefitz.lifespeak.com' && this.iframeLink.changingThisBreaksApplicationSecurity != 'http://my.norton.com/' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://clients.cowangroup.ca/') {
          this.openiframePopup();
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en') {
          window.open("https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en", "CloudMDKii", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://groupbenefitz.lifespeak.com') {
          window.open("https://groupbenefitz.lifespeak.com", "LifeSpeak", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'http://my.norton.com/') {
          window.open("http://my.norton.com/", "Norton", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }

        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://clients.cowangroup.ca/') {
          window.open("https://clients.cowangroup.ca/", "Cowin", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        event.preventDefault();
      }







    });

    this.fusbillinfocaptchavalue = '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11';
    this.url = window.origin + "/";
    this.paymentUri = this.url + "home";

    this.paymentsuccessuri = this.url + "home";



    this.customerid = this.getSession("customerId");


    this.phoneform = this.formBuilder.group({
     primaryPhone: ['', [RxwebValidators.pattern({ expression: { tenDigits: /^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/ } })]],
     secondaryPhone: ['', [RxwebValidators.pattern({ expression: { tenDigits: /^[0-9]{10}$|^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$|^\+1 \([0-9]{3}\)[0-9]{3}-[0-9]{4}$/ } })]],
    });

    this.dependentTypeForm = this.formBuilder.group({
      dependentType: ['', [Validators.required]],
      marriageType: ['', [Validators.required]],
      marriageDate: ['', [Validators.required]],
      childrenCountData: [{ value: 0, disabled: true }],
      effectiveDate: ['', [Validators.required]]
    })
    this.dependentTypeForm1 = this.formBuilder.group({
      effectiveDate: ['', [Validators.required]]
    })

    this.addressform = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      line1: ['', [Validators.required]],
      line2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      province: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      primaryPhone: ['', [Validators.required, RxwebValidators.pattern({ expression: { tenDigits: /^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/ } })]],
      secondaryPhone: ['', [RxwebValidators.pattern({ expression: { tenDigits: /^[0-9]{10}$|^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$|^\+1 \([0-9]{3}\)[0-9]{3}-[0-9]{4}$/ } })]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9._%+-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
          ),
        ],
      ],
      provinceHealthCareNumber: [''],
      apt: [''],
      poBox: [''],
      initial: [''],
      dateOfRetirement: [''],
      smoker: [false],
      previousEmployer: [''],
      employerPhoneOrEmail: [''],
      lastDayOfGroupBenefits: [''],
      certificatePolicyNumber: [''],
      previousBenefitProvider: [''],
    });

    this.spouseform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      healthPlan: ['', [Validators.required]],
      insurer: ['', [Validators.required]],
      martialStatus: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      status: [''],
    });

    this.updatespouseform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      healthPlan: ['', [Validators.required]],
      insurer: ['', [Validators.required]],
      martialStatus: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      status: [''],
    });

    this.deletespouseform = this.formBuilder.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      dob: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      coveredByAnotherPlan: [{ value: '', disabled: true }],
      healthPlan: [{ value: '', disabled: true }],
      insurer: [{ value: '', disabled: true }],
      martialStatus: [{ value: '', disabled: true }],
      effectiveDate: [{ value: '', disabled: true }],
      gender: [{ value: '', disabled: true }],
      status: [{ value: '', disabled: true }],
      reason: [{ value: '' }]
    });

    this.deletedependentform = this.formBuilder.group({
      firstName: [{ disabled: true }],
      lastName: [{ disabled: true }],
      dob: [{ disabled: true }],
      email: [{ disabled: true }],
      coveredByAnotherPlan: [{ disabled: true }],
      carrierName: [{ disabled: true }],
      postSecondaryStudent: [{ disabled: true }],
      effectiveDate: [{ disabled: true }],
      gender: [{ disabled: true }],
      age: [{ disabled: true }],
      phoneNum: [{ disabled: true }],
      graduationDate: [{ disabled: true }],
    });

    if (this.dependentType === 'child' && this.showChildForm) {
      this.pureDependentform = this.formBuilder.group({
        firstName: ['', [Validators.required, Validators.minLength(1)]],
        lastName: ['', [Validators.required, Validators.minLength(1)]],
        gender: ['', [Validators.required]],
        dob: ['', [Validators.required]],
        age: [''],
        phoneNum: [''],
        coveredByAnotherPlan: ['', [Validators.required]],
        graduationDate: [''],
        carrierName: ['', [Validators.required]],
        specialNeeds: [''],
        postSecondaryStudent: [''],
        effectiveDate: ['', [Validators.required]],
      });
    }
    this.dependentform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      gender: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      age: [''],
      phoneNum: [''],
      coveredByAnotherPlan: ['', [Validators.required]],
      graduationDate: [''],
      carrierName: ['', [Validators.required]],
      specialNeeds: [''],
      postSecondaryStudent: [''],
      effectiveDate: ['', [Validators.required]],
    });

    // Subscribe to value changes of effectiveDate
    this.dependentTypeForm1.get('effectiveDate')?.valueChanges.subscribe((newDate) => {
      console.log(newDate);
      if (newDate) {
        this.handleContinue('remove');
      }
    });

    
    this.paymentform = this.formBuilder.group({
      cutomerId: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: ["", Validators.compose([Validators.required, Validators.pattern('^(?!\\s)[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      recaptchaReactive: ["", Validators.required],
    })

    this.ccform = this.formBuilder.group({
      cutomerId: [""],
      Id: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: [""],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      nameonthecard: [""],
      aptcheck: [""],
      streetaddress: [""],
      streetaddressline2: [""],
      city: [""],
      countryId: [""],
      stateId: [""],
      postalcode: [""],
      recaptchaReactive: ["", Validators.required],
    });

    this.padform = this.formBuilder.group({
      bankcode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      transitNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      bankdetails: [''],
      file: [''],
    })
    this.claimsform = this.formBuilder.group({
  bankcode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
  transitNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
  accountNo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
  files: [''], // NOT required — void cheque is optional for claims
});

    this.paymentMethodForm = this.formBuilder.group({
      bankCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      branchCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      files: [''],
      paymentmethod: [''],
    })

    this.benficiaryForm = this.formBuilder.group({
      id: [null],
      type: ['PRIMARY', Validators.required],
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      email: ['', [Validators.pattern('^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      phoneNumber: ['', [Validators.minLength(17), Validators.maxLength(17)]],
      relationship: ['null', Validators.required],
      relationshipSpecific: [''],
      dob: ['', Validators.required],
      gender: ['null', Validators.required],
      isMinor: [''],
      trusteeFirstName: [''],
      trusteeLastName: [''],
      trusteeRelation: [''],
      percentage: ['', [Validators.required, this.nonZeroValidator]],
    });

    this.valisignform = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(6)]],
    })

  }
  get filteredFields() {
    return this.selectedResource?.fields?.filter(field => field.type !== 'signature');
  }
private fetchEligibilityBatchForOverview() {
  const url = `${this.api.url}/bookings/eligibility-batch/${this.customerData.id}`;

  this.http.get(url, { headers: { Authorization: 'Bearer ' + this.accessToken } }).subscribe({
    next: (res: any) => {
      const results = res?.results ?? {};
      const newEligibilityMap: any = {};

      for (const typeOfForm of Object.keys(results)) {
        const normalizedType = typeOfForm.trim().toLowerCase();
        newEligibilityMap[normalizedType] = {};

        for (const coverageType of Object.keys(results[typeOfForm])) {
          const item = results[typeOfForm][coverageType];
          item.canOrder = !!item.canOrder;
          item.canCancel = !!item.canCancel;

          if (item.nextAvailableDate) {
            item.nextAvailableDate = parseDateOnly(item.nextAvailableDate);
          }
          if (item.orderDate) {
            item.orderDate = parseDateOnly(item.orderDate);
          }

          newEligibilityMap[normalizedType][coverageType] = item;
        }
      }

      this.eligibilityMap = newEligibilityMap;
    },
    error: (err) => console.error('fetchEligibilityBatchForOverview failed', err),
  });
}
hasActiveBooking(item: any): boolean {
  const key = item.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key];

  if (!e) return false;

  return !!(
    e.self?.canCancel || e.spouse?.canCancel || e.both?.canCancel ||
    e.self?.orderDate || e.spouse?.orderDate || e.both?.orderDate
  );
}


getNextEligibleDate(
  item: any,
  coverage: 'self' | 'spouse' | 'both' | 'children'
): Date | null {
  const key = item.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key]?.[coverage];

  // show if there's a nextAvailableDate regardless of canCancel
  if (!e?.orderDate) return null;

  return e?.nextAvailableDate ? parseDateOnly(e.nextAvailableDate) : null;
}

getChildrenEligibility(item: any): { name: string; orderDate: Date | null; nextEligibleDate: Date | null }[] {
  const key = item.typeOfForm?.trim().toLowerCase();
  if (!key.includes('food sensitivity')) return [];

  const children = this.customerData?.dependents?.childrens ?? [];
  const results: any[] = [];

  children.forEach((child: any, index: number) => {
    const coverageKey = `child_${child.id || index}`;
    const e = this.eligibilityMap?.[key]?.[coverageKey];
    results.push({
      name: `${child.firstName} ${child.lastName}`.trim() || `Child ${index + 1}`,
      orderDate: e?.orderDate ? parseDateOnly(e.orderDate) : null,
      nextEligibleDate: e?.nextAvailableDate ? parseDateOnly(e.nextAvailableDate) : null,
    });
  });

  return results;
}

  showCancelModal = false;
  showFullPageLoader = false;
  isCancelling = false;
  selectedCancelItem: any = null;
  selectedCancelCoverage: 'self' | 'spouse' | 'both' | null = null;
  
openCancelCoverageModal(item: any, coverage?: 'self' | 'spouse' | 'both') {
  console.log('openCancelCoverageModal called', item); // ← ADD
  this.selectedCancelItem = item;
  this.selectedCancelCoverage = coverage || null; 

  const key = item.typeOfForm?.trim().toLowerCase();
  this.modalEligibility = this.eligibilityMap?.[key];
  
  console.log('modalEligibility:', this.modalEligibility); // ← ADD
  console.log('showCancelModal before:', this.showCancelModal); // ← ADD

  this.showCancelModal = true;
  
  console.log('showCancelModal after:', this.showCancelModal); // ← ADD
}
  get cancelKey(): string | null {
    return this.selectedCancelItem?.typeOfForm
      ? this.selectedCancelItem.typeOfForm.trim().toLowerCase()
      : null;
  }

confirmCancel(coverage: 'self' | 'spouse' | 'both') {
  if (!this.selectedCancelItem) return;
  this.cancelBooking(this.selectedCancelItem, coverage);
}
isBlockedDueToArrears(): boolean {

  const invoices = this.allCustomerFinalInvoices;
  if (!invoices || invoices.length === 0) return false;

  // Filter out draft invoices
  const nonDraftInvoices = invoices.filter((inv: any) =>
    inv.status?.toLowerCase() !== 'draft'
  );

  if (nonDraftInvoices.length === 0) return false;

  // Check if any unpaid invoice is more than 30 days old
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  const hasOverdueUnpaid = nonDraftInvoices.some((inv: any) => {
const status = inv.status?.toLowerCase();
if (['paid', 'void', 'draft', 'write-off'].includes(status)) return false;

    const invoiceDate = new Date(inv.invoiceDate ?? inv.dueDate);
    return invoiceDate < thirtyDaysAgo;
  });

  return hasOverdueUnpaid;
}
  modalTitle: string = '';



  canCancelOrder: boolean = false;
  eligibilityMap: { [typeOfForm: string]: { self?: any; spouse?: any; both?: any } } = {};
  private eligibilityRequestVersion: { [key: string]: number } = {};




//     //  SAFETY: if no coverage selected yet, just open modal
//     // (coverage selection happens inside modal)
//     // if (!coverageType) {
//     //   // this.bookingComp.eligibilityMap = this.eligibilityMap; // sync
//     //   this.bookingComp.typeOfForm = resource.typeOfForm;























openResourceModal(
  resource: any,
  coverageType?: 'self' | 'spouse' | 'both' | 'children'
) {
  console.log('openResourceModal called', resource?.typeOfForm);
  console.log('isBlockedDueToArrears:', this.isBlockedDueToArrears());
  const customerId = this.customerData?.id;

  if (!customerId || !resource?.typeOfForm) {
    return;
  }
  if (!this.bookingComp) {
    console.error('bookingComp is undefined');
    return;
  }

  const normalizedType = resource.typeOfForm
    .trim()
    .toLowerCase();

  if (!coverageType) {
    this.bookingComp.typeOfForm = resource.typeOfForm;
    this.bookingComp.openResourceModal(resource);
    setTimeout(() => { this.bookingComp?.['cdRef'].detectChanges(); }, 50);
    return;
  }

  const normalizedCoverage =
    coverageType.toLowerCase().trim() as
      | 'self'
      | 'spouse'
      | 'both'
      | 'children';

  let eligibility =
    this.eligibilityMap?.[normalizedType]?.[normalizedCoverage];

  console.log('Checking eligibility:', normalizedType, normalizedCoverage, eligibility);

  if (eligibility) {
    console.log('Using cached eligibility:', eligibility);

    if (!eligibility.canOrder) {
      this.showInfoPopup(
        eligibility.message || 'You are not eligible to order this service.'
      );
      return;
    }
    if (eligibility.canCancel === true) {
      this.showInfoPopup(
        `You already have an active booking for ${normalizedCoverage}. Please cancel it before ordering again.`
      );
      return;
    }

    this.bookingComp.eligibilityMap = this.eligibilityMap;
    this.bookingComp.openResourceModal(resource, coverageType);
    setTimeout(() => { this.bookingComp?.['cdRef'].detectChanges(); }, 50);
    return;
  }

  const url = `${api.url}/bookings/eligibility/${customerId}/${encodeURIComponent(resource.typeOfForm.trim())}/${normalizedCoverage}`;

  console.log('Calling eligibility API:', url);

  this.http.get(url).subscribe({
    next: (res: any) => {
      console.log('Eligibility API response:', res);

      const normalizedRes = {
        ...res,
        canOrder: !!res.canOrder,
        canCancel: !!res.canCancel,
      };

      this.eligibilityMap[normalizedType] = {
        ...this.eligibilityMap[normalizedType],
        [normalizedCoverage]: normalizedRes,
      };

      if (!normalizedRes.canOrder) {
        this.showInfoPopup(
          normalizedRes.message || 'You are not eligible to order this service.'
        );
        return;
      }

      if (normalizedRes.canCancel === true) {
        this.showInfoPopup(
          `You already have an active booking for ${normalizedCoverage}. Please cancel it before ordering again.`
        );
        return;
      }

      if (!this.bookingComp) {
        console.error('bookingComp is undefined');
        return;
      }

      this.bookingComp.eligibilityMap = this.eligibilityMap;
      this.bookingComp.openResourceModal(resource, coverageType);
      setTimeout(() => { this.bookingComp?.['cdRef'].detectChanges(); }, 50);
    },

    error: (err) => {
      console.error('Eligibility API error:', err);
      this.showInfoPopup(
        err?.error?.message || 'Unable to check eligibility.'
      );
    },
  });
}
checkAndRedirectExternalForm(item: any) {
  if (this.isBlockedDueToArrears()) {
    const message = this.isCorporateAccount
      ? 'Your request cannot be completed at this time. Please ask your company plan administrator to contact admin@groupbenefitz.ca.'
      : 'Your premiums must be paid before any services can be booked.';
    this.showInfoPopup(message);
    return;
  }
  this.redirectToExternalForm(item);
}



showInfoPopup(message: string) {
  Swal.fire({
    title: 'Info',
    text: message || 'You are not eligible to order at this time.',
    confirmButtonText: 'OK',
    width: '400px',
    confirmButtonColor: '#1a2e4a',
    customClass: {
      confirmButton: 'btn btn-sm order-btn',
    },
    buttonsStyling: true
  });
}

  cancelBooking(item: any, coverageType: 'self' | 'spouse' | 'both') {
    const customerId = this.customerData?.id;
    const typeOfForm = item.typeOfForm?.trim();
    if (!customerId || !typeOfForm) return;

    const key = typeOfForm.toLowerCase();

    const url = `${api.url}/bookings/cancel/${customerId}/${encodeURIComponent(typeOfForm)}/${coverageType}`;

         this.showCancelModal = false;
         this.showFullPageLoader = true;


    this.http.delete(url).subscribe({
      next: (res: any) => {
        console.log('Cancel API response:', res);
        console.log('Cancel API status:', res?.success)

        //  TRUST LOCAL STATE FOR UI
this.eligibilityMap = {
  ...this.eligibilityMap,
  [key]: {
    ...this.eligibilityMap[key],
    [coverageType]: {
      canOrder: true,
      canCancel: false,
      orderDate: null,
      nextAvailableDate: null,
      message: 'Eligible to order'
    },
    // Also clear 'both' when cancelling self or spouse
    both: {
      canOrder: true,
      canCancel: false,
      orderDate: null,
      nextAvailableDate: null,
      message: 'Eligible to order'
    }
  }
};

        const nextDate = res.nextAvailableDate
  ? toDisplayDate(res.nextAvailableDate)
  : 'Sep-01-2026';

this.showFullPageLoader = false;

Swal.fire({
  title: 'Cancelled',
  text: 'Your request has been cancelled.',
  confirmButtonText: 'OK',
  confirmButtonColor: '#1a2e4a',
  width:'300px',
}).then(() => {
  this.checkEligibility(customerId, typeOfForm);
});
      },
      error: (err) => {
        this.showFullPageLoader = false;
        Swal.fire('Error', err?.error?.message || 'Failed to cancel booking');
      },
    });
  }

onChildBookingCreated(event: {
  customerId: number;
  typeOfForm: string;
  coverageType: 'self' | 'spouse' | 'both' | 'children';
}) {
    if (!event?.typeOfForm || !event?.customerId) return;

    console.log('Booking created, refreshing eligibility:', event);

    //  THIS IS THE KEY LINE
    this.checkEligibility(event.customerId, event.typeOfForm);
  }

canOrder: boolean = true;
  currentFormFields: any[] = [];

  hasSpouseInfo(): boolean {
    return (
      this.customerData?.dependents?.spouseInfo &&
      Object.keys(this.customerData.dependents.spouseInfo).length > 0
    );
  }
isFamilyPlan(): boolean {
  const maritalStatus = this.customerData?.maritalStatus?.toLowerCase();
  const hasChildren = (this.customerData?.dependents?.childrens ?? []).length > 0;
  return maritalStatus === 'family' || hasChildren;
}

getEligibleChildrenForBooking(): any[] {
  const children = this.customerData?.dependents?.childrens ?? [];
  const today = new Date();
  const cutoffDate = new Date(today.getFullYear() - 6, today.getMonth(), today.getDate());

  return children.filter((child: any) => {
    if (!child?.dob) return false;
    const dob = parseDateOnly(child.dob);
    return !!dob && dob <= cutoffDate;
  });
}
  public ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const dob = control.value;
      if (!dob) {
        return null; // No DOB provided
      }

      const today = new Date();
      const birthDate = parseDateOnly(dob);
      if (!birthDate) {
        return null;
      }
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age < minAge ? { 'ageError': true } : null; // Return an error if under 18
    };
  }

  public handleContinue(slug: any = '') {
    this.showPlanDetails = true;
    console.log(this.dependentType, "slug889")
    this.dependentType = this.dependentType ?? 'spouse'
    console.log(this.dependentTypeForm.get('effectiveDate')?.value)
    console.log(this.dependentform.get('effectiveDate')?.value)
    let effectiveDate: any;

    let endPoint: any
    if (slug == 'remove') {

      effectiveDate = this.dependentTypeForm1.get('effectiveDate')?.value

      if (this.isCorpCustomer) {
        endPoint = `/customer/v2/${this.customerid}/customerPlans/${this.dependentType ?? 'spouse'}/${slug}`
      } else {
        endPoint = `/customer/${this.customerid}/customerPlans/${this.dependentType ?? 'spouse'}/${slug}`
      }
    } else {

      if (this.isCorpCustomer) {
        endPoint = `/customer/v2/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
      } else {
        endPoint = `/customer/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
      }
    }
    console.log('this.dependentCoverage990', this.childrenDetails)
    let childCovered = 'none';
    let childCoveredCount = 0;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      for (const cd of this.childrenDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.childrenDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    let payload = {
      "enrollmentDate": slug == 'remove' ? effectiveDate : this.dependentTypeForm.get('effectiveDate')?.value,
      "removeRoleBasedPlans": false,
      spouseCovered: this.spouseCovered,
      childCovered: childCovered,
      totalCount: this.childrenDetails.length
    }
    console.log({ payload })

    this.removeSession("plansummarymain")
    this.removeSession("plansskumain");
    this.removeSession("plansummaryopt");
    this.removeSession("plansummary");
    this.removeSession("selectedPlans");
    this.removeSession("totalAmount");
    this.removeSession("totalAmountUI");
    this.http.post(api.url + endPoint, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200 && !this.isCorpCustomer) {
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }
        this.provisioningSites = prsStatus.toString() ?? ""


        console.log("calledoooo")
        let data__ = response?.data?.packages
        this.customerPlans = response?.data?.customerPlans;

        console.log(this.customerPlans, "custplans889")
        setTimeout(() => {
          this.customerPlans.forEach(element => {
            const dom: HTMLElement = this.elementRef.nativeElement;

            if (slug == 'remove') {
              console.log(element)
              if (element.isBundle) {

                let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
                let clicked = false;
                if ($("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).length == 0) {
                  for (const cov of coverages) {
                    console.log($("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()))
                    if ($("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()).length > 0 && !clicked) {
                      $("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()).click()
                      $("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()).prop("disabled", true);
                      clicked = true;
                    }
                  }
                } else {
                  $("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()
                  $("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
                }
              }
              else {
                if (element.coverage) {
                  const plan: any = dom.querySelector("#plancheck2" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                  console.log($("#plancheck2" + element.planSelectionId2))
                  $("#plancheck2" + element.planSelectionId2).click()
                  $("#plancheck2" + element.planSelectionId2).prop("disabled", true);
                }
                else {
                  console.log($("#plancheck2" + element.planSelectionId2))
                  $("#plancheck2" + element.planSelectionId2).click()
                  $("#plancheck2" + element.planSelectionId2).prop("disabled", true);

                }
              }
            } else {
              console.log(element, "jiihhsh")
              if (element.isBundle) {

                let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
                let clicked = false;
                if ($("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).length == 0) {
                  for (const cov of coverages) {
                    console.log($("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()))
                    if ($("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()).length > 0 && !clicked) {
                      $("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()).click()
                      $("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()).prop("disabled", true);
                      clicked = true;
                    }
                  }
                } else {
                  $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()
                  $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
                }

              }
              else {
                console.log(element?.coverage1, "after else")
                if (element?.coverage1 && element?.coverage1 != '-') {

                  console.log("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase())
                  $("#plancheck" + element.planSelectionId2).click()
                  $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
                }
                else {
                  console.log($("#plancheck" + element.planSelectionId2))
                  $("#plancheck" + element.planSelectionId2).click()
                  $("#plancheck" + element.planSelectionId2).prop("disabled", true);

                }
              }
            }


          });
        }, 1000);

        this.selectedPlans_ = [];
        this.oldExistingPlans = []
        this.selectedTrues = []
        this.unSelectedPlans_ = []
        this.totalSummaryPrice = 0;


        for (let package_ of data__) {
          console.log(package_, 'asdaas2');

          let groupKeys_ = Object.keys(package_.groups);
          for (let i = 0; i < groupKeys_.length; i++) {
            let groups = groupKeys_[i];

            for (let j = 0; j < package_.groups[groups].length; j++) {
              let group = package_.groups[groups][j];

              for (let k = 0; k < group.plans.length; k++) {
                let plan = group.plans[k];
                let pan = plan.productAddonssNames;
                console.log(plan.isBundle, "bundled")

                for (let product of pan) {
                  if (plan.productAddonss[product]) {
                    const paon = plan.productAddonss[product];

                    const selectedAddons = paon.filter((item: any) => item.selected);

                    if (selectedAddons && selectedAddons.length > 0) {
                      const unSelectedAddon = paon.find((item: any) => !item.selected);

                      console.log(unSelectedAddon)
                      if (!!unSelectedAddon && plan.selected) {
                        this.upgradeorDowngradeplans.push({
                          'name': unSelectedAddon?.name,
                          'addon': unSelectedAddon,
                          'isBundle': plan.isBundle
                        })
                      }
                      if (!unSelectedAddon && plan.selected) {
                        for (const selectedAddon of selectedAddons) {
                          const customerPlan = this.customerPlans.find((item: any) => (item.planId == selectedAddon.planId && (item.terminationDate == null || item.terminationDate == "")))
                          console.log(customerPlan, selectedAddon)
                          if (customerPlan.coverage1.toUpperCase() == selectedAddon.planCoverage) {
                            this.upgradeorDowngradeplans.push({
                              'name': selectedAddon?.name,
                              'addon': selectedAddon,
                              'isBundle': plan.isBundle
                            })
                          }
                        }
                      }
                      if (plan.selected) {
                        //check for the termination date
                        for (const selectedAddon of selectedAddons) {
                          this.upgradeorDowngradeplansSelected.push({
                            'name': selectedAddon?.name,
                            'addon': selectedAddon,
                            'isBundle': plan.isBundle
                          })

                        }
                      }
                    }
                    // Loop over the addonss for the plan
                    for (const paon_ of paon) {
                      console.log(paon_, '12345');

                      if (paon_.selected === true) {
                        // We can call the onCheckboxChange

                        this.selectedTrues.push({
                          id: paon_.id,
                          productId: paon_.productId,
                          planId: paon_.planId
                        });

                        paon_['checked'] = true;  // Mark the plan as checked
                        this.totalSummaryPrice += paon_.calculatedTax.total;
                        this.selectedPlans_.push(paon_);
                        this.oldExistingPlans.push(paon_);
                      } else {
                        this.unSelectedPlans_.push(paon_);
                      }
                    }
                  }
                }
              }
            }
          }

          console.log(this.selectedPlans_, 'asd2342');
          console.log(this.unSelectedPlans_, 'asd23421');

          this.getPlanSummaryObject();
        }

        console.log('selectedTrues', this.selectedTrues)

        this.specialpackages = data__ ?? []
      }

      if (response.status == 200 && this.isCorpCustomer) {

        this.setSession(
          "customerTierId",
          response.data.customer.customerTierId
        );
        this.setSession("employeeshare", "0");
        this.mainarray = [];
        this.mainarrayValues = [];
        this.mainarrayFinal = [];
        this.modifiedBlocksPaidByCompany = '',
          this.modifiedBlocksCoveredByCompany = '',

          this.setSession("planDetailsArrayBlock", "[]");
        this.effectiveEmployeeTotalContibution = 0;
        this.setSession("totalAmount", "0");
        this.setSession("totalAmountUI", "0");

        this.setSession("allSelectedPlans", "[]");

        this.setSession("plansummary", "[]");
        this.setSession("selectedPlans", "{}");
        this.setSession("selectedPlansLife", "{}");
        this.setSession("plansummarymain", "[]");
        this.setSession("plansummaryopt", "[]");
        this.removeSession("Spousesignature")

        this.addbenificaryData = []
        this.allFormData = {}
        this.formData = {}
        this.setSession('plansummaryLife', '[]');
        this.setSession('planssummarymainLife', '[]');

        ///here
        this.removeSession("paymentfail");
        this.companypaidproductid = [];
        this.disabledcompanypaidproductid = [];
        this.removedisabledcompanypaidproductid = [];
        this.adddisabledcompanypaidproductid = [];

        console.log(response)
        this.specialpackages = [];
        this.packagesInBlocks = response.data.blocks;
        this.basepackages = response.data.packages;
        this.customerSelectedPlans = response.data.customerPlans

        let companyplans = this.convertpackagesToPlans2(
          this.packagesInBlocks
        )[1];
        let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
        this.calculateBasePlanDeltasforCCplans(
          this.packagesInBlocks.coveredByCompany,
          baseplans,
          companyplans
        );
        this.calculateBasePlanCPplans(
          this.packagesInBlocks.paidByCompany,
          baseplans,
          companyplans
        );

        this.mainarrayValues = this.cobminedcommonfunction(
          this.modifiedBlocksPaidByCompany,
          this.modifiedBlocksCoveredByCompany,
          this.packagesInBlocks.paidByEmployee
        );

        let allPackages: any = [];
        for (let key in this.mainarrayValues) {
          allPackages.push(this.mainarrayValues[key]);
        }

        console.log(allPackages)

        let filteredMainArray = allPackages
          .map((element: any) => {
            // Map the groups
            let filteredGroups = element.groups.map((group: any) => {
              // Map the plans
              let filteredPlans = group.plans.map((plan: any) => {
                // Filter the productAddonss


                let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                  (acc: any, key) => {

                    // Filter the products where display is true
                    let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                      product.hasOwnProperty('display') && product.display
                    );
                    const containsOnlyEmptyObjects = filteredProducts.every(
                      (product: any) => Object.keys(product).length === 0
                    );

                    if (containsOnlyEmptyObjects) {
                      console.log("filteredProducts contains only empty objects.");
                    } else {
                      acc[key] = filteredProducts;
                      console.log("filteredProducts contains non-empty objects.");
                    }
                    return acc;
                  },
                  {}
                );
                return {
                  ...plan,
                  productAddonss: filteredProductAddonss,
                };
              }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

              return {
                ...group,
                plans: filteredPlans,
              };
            }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

            return {
              ...element,
              groups: filteredGroups,
            };
          })
          .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


        console.log(filteredMainArray)

        this.mainarrayFinal = filteredMainArray

        console.log(this.mainarrayFinal)

        // this code needs to comment for single single in
        this.mainarrayFinal.forEach((element: any) => {
          element.groups.forEach((group: any) => {
            group.plans.forEach((plan: any) => {
              if (plan.productAddonss) {
                Object.keys(plan.productAddonss).forEach((key) => {
                  const keys = ['planCoverage'];
                  const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                    self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                  );
                  plan.productAddonss[key] = filteredData
                });
              }
            });

          });
        });

        this.mainarrayFinal.forEach((element: any) => {
          element.groups.forEach((group: any) => {
            if (group.categorization.paidByCompany == 1) {
              group.plans.forEach((plan: any) => {
                let pl = { ...plan, ...group.categorization }
                Object.keys(plan.productAddonss).forEach((key) => {
                  let productLength = plan.productAddonss[key]?.display
                  let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length

                  plan.productAddonss[key].forEach((product: any) => {

                    if (pl.isBundle) {
                      this.companypaidproductid.push(pl);
                    }
                    else {
                      this.companypaidproductid.push(product.planlevel);
                    }


                    const dom: HTMLElement = this.elementRef.nativeElement;

                    const plan: any = dom.querySelector("#plancheck" + product.id);

                    if (plan) {
                      plan.checked = false;
                    }
                  });
                });
              });
            }

            setTimeout(() => {
              if (group.categorization.coveredByCompany == 1) {
                group.plans.forEach((plan: any) => {
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      const dom: HTMLElement = this.elementRef.nativeElement;

                      const plan: any = dom.querySelector("#plancheck" + product.id);

                      if (plan) {
                        plan.checked = false;
                      }
                    });
                  });
                });
              }
              if (group.categorization.paidByEmployee == 1) {
                group.plans.forEach((plan: any) => {

                  if (plan.productAddonss) {
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        const dom: HTMLElement = this.elementRef.nativeElement;

                        const plan: any = dom.querySelector("#plancheck" + product.id);

                        if (plan) {
                          plan.checked = false;
                        }
                      });
                    });
                  }
                });
              }
            }, 1000);




          });
        });


        this.mainarrayFinal.forEach((element: any) => {
          let coveragerray: any = []
          element.groups.forEach((group: any) => {

            group.plans.forEach((plan: any) => {
              let pl = { ...plan, ...group.categorization }
              Object.keys(plan.productAddonss).forEach((key) => {

                plan.productAddonss[key].forEach((product: any) => {
                  coveragerray.push(product.planCoverage)

                  if (pl.isBundle) {

                    setTimeout(() => {
                      const dom: HTMLElement = this.elementRef.nativeElement;
                      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + pl.id);
                      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + pl.id);
                      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + pl.id);
                      // //console.log(plan)


                      if (
                        coveragerray.includes("SINGLE") &&
                        coveragerray.includes("COUPLE") &&
                        coveragerray.includes("FAMILY")
                      ) {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                      }
                      else if (
                        coveragerray.includes("SINGLE") &&
                        coveragerray.includes("COUPLE")
                      ) {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                      }
                      else if (
                        coveragerray.includes("SINGLE") &&
                        coveragerray.includes("FAMILY")
                      ) {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                      }
                      else if (
                        coveragerray.includes("COUPLE") &&
                        coveragerray.includes("FAMILY")
                      ) {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                      }
                      else if (product.planCoverage === "SINGLE") {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                      }
                      else if (product.planCoverage === "COUPLE") {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                      }
                      else if (product.planCoverage === "FAMILY") {
                        if (plan) {
                          plan.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                        if (plan2) {
                          plan2.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'none';
                          });
                        }
                        if (plan3) {
                          plan3.forEach((elem: any) => {
                            (elem as HTMLElement).style.display = 'block';
                          });
                        }
                      } else {
                        // Default case - hide all plans if coverage doesn't match expected
                      }



                    }, 1000);

                  }
                  else {
                  }


                });
              });
            });
          });
        });

        this.planAmount = ''

        this.setSession("stateid", response.data.province.id);


        this.setSession(
          "planDetailsArray",
          JSON.stringify(this.specialpackages)
        );
        this.setSession(
          "planDetailsArrayBlock",
          JSON.stringify(this.mainarrayFinal)
        );
      }
      else {
      }
    }, (error) => {
    });
    if (this.specialpackages && this.specialpackages.length > 0) {
      let filteredPackages_: any = [];
      console.log("called")
      //filter the repeated packages for medcan care
      for (let package_ of this.specialpackages) {
        console.log(package_, 'asdaas2')
        let groupKeys_ = Object.keys(package_.groups);
        for (let groups of groupKeys_) {
          for (let group of package_.groups[groups]) {
            for (let plan of group.plans) {
              let pan = plan.productAddonssNames
              for (let product of plan.productAddonssNames) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product]
                  for (const paon_ of paon) {
                    if (paon_.selected == true) {
                      this.selectedPlans_.push(paon_);
                    }
                  }
                }
              }

            }
          }
        }
        console.log(this.selectedPlans_, 'asd2342')
        if (package_.id == 5) {
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {

                  // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                  if (filteredPackages_[product]) {
                    if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                      let index = pan.indexOf(product);
                      if (index !== -1) {
                        pan.splice(index, 1);
                      }
                    }
                  } else {
                    filteredPackages_[product] = { 'planProductIds': [] }
                    filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                  }

                  console.log(plan.productAddonss, product);

                }

                plan.productAddonssNames = pan;
              }
            }
          }
        }
      }

    }
  }

  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;


        modifiedCPgroup.plans = [];
        let baseplans: any = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
          let selectedCPplanProductarray: any = CPplan.productAddonss[CPplan.name];


          /* this is filtering other products which are not to be displayed */
          selectedCPplanProductarray = selectedCPplanProductarray.filter((prop: any) => prop.display)



          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans




            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

              }
              else {

                // Direct Coverage Method



                // Selective single Coverage Method


                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct: any = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }
              else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)



              if (selectedBaseplanProduct.name == 'NA') {
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };



              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)



            }

          }
          else {




            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                let products = selectedBasePlan.productAddonss[planname];
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                } else {
                }
              }
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
              } else {
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              if (selectedBaseplanProduct.name == 'NA') {
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

    }
  }
  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        pckg.groups = pckg.groupsCC;


        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }
  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }
  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    let modifiedCCplanPackages: any = [];
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"


        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        let CCplans = CCplangroup.plans;

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {

            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });


            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];



            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            if (selectedBasePlan) {
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2: any = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            if (selectedCompnayPlan) {
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2: any = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

              }
              else {

                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)




              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );



              if (selectedBaseplanProduct.name == 'NA') {
                companyTax = 0  ////when there is no base planproduct
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };


              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });


            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    if (selectedBaseplanProduct.name == 'NA') {
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );



      if (selectedBaseplanProduct.name == 'NA') {
        companyTax = 0  ////when there is no base planproduct
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };


      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

    }

    return modifiedCCplan
  }

  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {


        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }

    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }

    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);


      }

    }
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public handleGenerateNotes(plansData: any = [], approvalStatus: any, event: any, eventType: any, marriedDate: any) {
    let notesObj = {
      plans: plansData, // old plans and new plans data
      status: approvalStatus, // will be the approval stauts
      event: event,
      eventType: eventType,
      marriedDate: marriedDate
    }

    return notesObj;
  }

  public handleShowText(product: any, coverage: any) {
    if (coverage == 'STC') {
      this.coverageChangeText = 'Plan coverage will change from SINGLE to COUPLE'
    }
    if (coverage == 'CTS') {
      this.coverageChangeText = 'Plan coverage will change from COUPLE to SINGLE'
    }
    this.priceChangeText = `old price - $${product.oldPrice} | new price - $${product.newPrice} | change in amount - ${product.newPrice - product.oldPrice < 0 ? '- $' + Math.abs(product.newPrice - product.oldPrice) : '$' + (product.newPrice - product.oldPrice)}`
    return this.coverageChangeText + '\n' + this.priceChangeText;
  }

  public onCheckboxChange_v3(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called1", e)

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId

      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;

        if (element.checked) {
          element.checked = false;
          this.unselectplan_v3(elem);

        }
      }
      e.target.checked = true
      e.target.disabled = true
    } else {
    }





    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );



      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');


        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])




        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan_v3(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }

            }
          }
        }
      }
    }

    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)

    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);



    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan_v3(elem)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan_v3(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan_v3(e.target);
      }
    }, 10);
  }

  public selectplan_v3(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(options)

    if (options && options.length > 0) {
      this.setSession('options', JSON.stringify(options));
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? toLegacyUsDate(
          this.dependentTypeForm.get('effectiveDate')?.value
        )
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);

    this.addtoplansummary_v3(obj, obj1);
  }

  public addtoplansummary_v3(obj: any, obj1: any) {
    console.log("summary3 called", obj, obj1)
    let planSummary = JSON.parse(this.getSession('plansummary') || '[]');


    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;


    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');


    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    this.setSession('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    this.setSession(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    this.setSession(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    this.setSession('plansummary', JSON.stringify(planSummary));
    let planSummaryData = JSON.parse(this.getSession('plansummaryLife') || '[]');


    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        this.getSession('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {

          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck2792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
              }, 1000);
            }
            break;
          }
          else {

            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck2792" + ".coverage" + obj.coverage);

            console.log(plan)
            setTimeout(() => {
              plan.click()
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }


      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      this.setSession('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }




      // here we can call the select plans one sudeep
    }, 100);
  }

  public capitalizeFirstLetter(str: string): string {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    return ''; // Return an empty string if the input is falsy (null, undefined, or empty)
  }

  public addtosum(amount: any) {

    let selectedPlansAmount = parseFloat(
      this.getSession('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    this.setSession(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );

    this.setSession(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      this.getSession('totalAmount')?.replace(/,/g, '') ?? '0'
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    this.setSession(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );
    this.setSession(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');
    return selectedPlansAmount;
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      this.getSession('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    this.setSession('selectedPlans', JSON.stringify(selectedPlans));
  }


  public getslectedplans(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      this.getSession('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }


  public handleDisableCheckAndUnCheck_v2(unchecked: any, checked: any, obj: any) {
    console.log(obj)

    let planSummary = JSON.parse(this.getSession('plansummary') || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }


    if (planSummary && planSummary.length > 0) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      console.log(index)
      console.log(planSummary)

      if (index > -1) {
        let element = planSummary[index];
        if (element.isBundle) {

          $("#plancheck2" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          console.log($("#2" + element.id + ".coverage" + element.coverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element?.coverage, "after else")
          if (element?.coverage) {

            $("#plancheck2" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          }
          else {
            // check here once
            $("#plancheck2" + element.id).prop("disabled", false);

          }
        }

      } else {
        return;
      }
    }

  }

  public unselectplan_v3(elementcv: any) {


    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? toLegacyUsDate(this.dependentTypeForm.get('effectiveDate')?.value)
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }
    this.handleDisableCheckAndUnCheck_v2(true, false, obj)
    this.removeplansummary_v3(obj);
  }

  public removeplansummary_v3(obj: any) {
    let planSummary = JSON.parse(this.getSession('plansummary') || '[]');

    console.log(obj);


    this.getPlanSummaryObject()
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        planSummary.splice(index, 1);

      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        this.getSession('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      this.setSession('selectedPlans', JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      console.log("setting here2");

      this.setSession(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      this.setSession(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      this.setSession('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(this.getSession('plansummaryLife') || '[]');

      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {



      this.planssummarymain = JSON.parse(
        this.getSession('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      this.setSession('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck2${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
  }

  public isGroupsNotEmpty(groups: any): boolean {
    if (Object.keys(groups).length > 0) {
      Object.keys(groups).forEach(element => {

        if (groups[element].length > 0) {
          groups[element].map(ele => {

            if (ele.plans?.length > 0) {
              this.displayPackage = true;
              return this.displayPackage
            }
          });
        }
      })
    }

    return this.displayPackage
  }

  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }


  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }
  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name, plan) {
    // console.log(published, restricted, name, plan)
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }


  public covergages = ['SINGLE', 'COUPLE', 'FAMILY']

  pauseVideo(videoplayer: any) {
    videoplayer.nativeElement.play();

    setTimeout(() => {
      videoplayer.nativeElement.pause();

      if (videoplayer.nativeElement.paused) {
        this.show = !this.show;
      }
    }, 5000);
  }

ngAfterViewInit() {
     if (this.bookingComp) {
    this.bookingComp['cdRef'].detectChanges();
  }
   let slideChangeTimeout: any;
const observer = new MutationObserver(() => {
  clearTimeout(slideChangeTimeout);
  slideChangeTimeout = setTimeout(() => {
    this.onSlideChanged();
  }, 300);
});
const swiperContainer = document.querySelector('.order-services-slider .swiper-wrapper');
    if (swiperContainer) {
      observer.observe(swiperContainer, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }
onSlideChanged() {
  const activeSlide = document.querySelector('.order-services-slider .swiper-slide-active') as HTMLElement;
  if (!activeSlide) return;

  const index = activeSlide.getAttribute('data-swiper-slide-index');
  if (index === null) return;

  const item = this.bookingInformation[+index];
  if (!item) return;

  const type = item.typeOfForm?.trim().toLowerCase();

  console.log("Slide changed → Checking eligibility for:", type);

  this.checkEligibility(this.customerData.id, type);
}

  get plansVisible() {
    let selectedPlans: any = this.getSession("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }
    return selectedPlans.length > 0
  }

  get phoneForm() {
    return this.phoneform.controls;
  }

  get addressForm() {
    return this.addressform.controls;
  }

  get spouseForm() {
    return this.spouseform.controls;
  }

  get deletespouseForm() {
    return this.deletespouseform.controls;
  }

  get updatespouseForm() {
    return this.updatespouseform.controls;
  }

  get deletedependentForm() {
    return this.deletedependentform.controls;
  }

  get dependentForm() {
    return this.dependentform.controls;
  }

  get dependentPureForm() {
    return this.pureDependentform.controls;
  }

  get paymentMethodControls() {
    return this.paymentMethodForm.controls;
  }

  get valisignControls() {
    return this.valisignform.controls;
  }

  get paymentForm() {
    return this.paymentform.controls;
  }

  get ccForm() {
    return this.ccform.controls;
  }

  get padForm() {
    return this.padform.controls;
  }
  get claimsForm() {
  return this.claimsform.controls;
}

  getFormConfiguration(lang: any) {


  }


checkEligibility(
  customerId: number,
  typeOfForm: string,
  coverage?: 'self' | 'spouse' | 'both' | 'children'
) {
    const normalizedType = typeOfForm.trim().toLowerCase();

     this.eligibilityRequestVersion[normalizedType] = (this.eligibilityRequestVersion[normalizedType] || 0) + 1;
    const requestVersion = this.eligibilityRequestVersion[normalizedType];


  const isgutChek = normalizedType.includes('food sensitivity');
const childKeys = isgutChek
  ? (this.customerData?.dependents?.childrens ?? []).map((child: any, index: number) => `child_${child.id ?? index}`)
  : [];
const coverageTypes: string[] =
  coverage ? [coverage as any] : isgutChek
    ? ['self', 'spouse', 'both', 'children', ...childKeys]
    : ['self', 'spouse', 'both'];
      

    if (!this.eligibilityMap[normalizedType]) {
      this.eligibilityMap[normalizedType] = {};
    }

    coverageTypes.forEach((coverageType) => {
      const url = `${api.url}/bookings/eligibility/${this.customerData.id}/${encodeURIComponent(typeOfForm.trim())}/${coverageType}`;
      console.log('Checking eligibility', { type: normalizedType, coverage: coverageType, url });

      this.http.get(url).subscribe({
        next: (res: any) => {
            if (this.eligibilityRequestVersion[normalizedType] !== requestVersion) {
    return; // a newer request has superseded this one — ignore stale response
  }


          res.canOrder = !!res.canOrder;
          res.canCancel = !!res.canCancel;

          if (res.nextAvailableDate) {
            res.nextAvailableDate = parseDateOnly(res.nextAvailableDate);
          }
          if (res.orderDate) {
            res.orderDate = parseDateOnly(res.orderDate);
          }

          console.log('Eligibility response for', normalizedType, coverageType, res);
          this.eligibilityMap = {
            ...this.eligibilityMap,
            [normalizedType]: {
              ...this.eligibilityMap[normalizedType],
              [coverageType]: res,
            },
          };
        },
        error: (err) => {
          console.error('Eligibility check failed', { type: normalizedType, coverage: coverageType, error: err });
          // Ensure map entry exists even on error so UI can react
          this.eligibilityMap = {
            ...this.eligibilityMap,
            [normalizedType]: {
              ...this.eligibilityMap[normalizedType],
              [coverageType]: null,
            },
          };
        },
      });
    });
  }

  private eligibilityLoaded = false;


ngOnChanges(changes: SimpleChanges) {
  if (changes['formConfig'] && changes['formConfig'].currentValue) {

    this.formConfiguration = this.formConfig;
    console.log('overview', this.formConfiguration)
    this.logo = this.formConfiguration?.customerTiles;
this.bookingInformation = this.formConfiguration?.form_typess || [];


    setTimeout(() => {
      this.getcoverflow()
    }, 1000)

    let tokens = this.formConfiguration?.language_details.languageTokens;
    for (let token of tokens) {
      this.lang1[token.key] = token.value;
    }
    this.provianceList = this.formConfiguration.states.filter((list) => {
      if (list.countryId == 1)
        return list
    });
    this.configprovinceres = this.formConfig.states.sort(
      (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    );
    this.beneficiaryValidations = this.formConfiguration.validations.beneficiaries
    console.log('beneficiaryValidations', this.beneficiaryValidations)

    this.loadMedcanEligibility(); 
  }
  if (changes['customerData'] && changes['customerData'].currentValue) {
    this.loadMedcanEligibility();
  }
}

  getCustomerData(customer?: any) {
    let customerDataEndpoint = '/customer/' + this.customerid + '/details';


    this.isViking = sessionStorage.getItem('currClient') ? sessionStorage.getItem('currClient') === 'viking' ? true : false : false; 
    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.isSpouseExists = Object.keys(response?.data?.dependents?.spouseInfo ?? {}).length > 0 ? true : false;
        this.customerData = response?.data;
        this.loadMedcanEligibility(); 


const vikingBrokerIdOld = this.customerData?.additionalDetails?.viking_input_data?.brokerId;
const vikingBrokerIdNew = this.customerData?.fillSignupData?.form?.brokerId;
this.isVikingCustomer = 
  vikingBrokerIdOld == 981 || vikingBrokerIdOld == 3405 ||
  vikingBrokerIdNew == 981 || vikingBrokerIdNew == 3405;

          this.isViking = response?.data?.viking ?? false;
        if (this.isViking) {
          this.minDate = new Date(moment().subtract(80, "years").calendar());
        }
        const stateName = this.customerData?.homeProvinceDetails?.state;

        if (stateName && this.provianceList?.length) {
          const matchedProvince = this.provianceList.find(
            (p: any) => p.name?.toLowerCase() === stateName.toLowerCase()
          );

          if (matchedProvince) {
            //  store shortName
            this.customerData.province = matchedProvince.shortName;
            this.customerData.homeProvinceDetails.province = matchedProvince.shortName;
          }
        }
        this.authorizenetCustomerId = response?.data?.authorizenetCustomerId ?? ""
        this.isCorpCustomer = response?.data?.customerType == "CORP" ? true : false;
        this.maritalStatus = response?.data?.maritalStatus ?? 'Single';
        this.enrollmentdate = response?.data?.policyStartDate ?? "";

        this.eqationStaffing = response.data?.fillSignupData?.form?.brokerId == 940 || response.data?.tierInfo?.brokerId == 940;

        // specific payment
        if (!!response.data.formAttr) {
          this.formAttr = response.data.formAttr
        }
        if (response.data?.paymentPlatform != 'Staxbill' && !!this.authorizenetCustomerId) {
          this.paymentPlatform = 'AuthorizeNet'
          this.migratingFromStaxbill = false;
        } else {
          this.paymentPlatform = 'Staxbill';
          this.migratingFromStaxbill = true;
        }
        this.setSession('paymentPlatform', this.paymentPlatform)

        if (response?.data.secondaryPhone == null) {
          this.customerData.secondaryPhone = ""
        }
        this.gender = this.customerData.gender;
        this.fuseBillKey = this.customerData.fuseBillKey;
        this.stateId = this.customerData.stateFusebillId;

        this.showIAFG = this.customerData?.showIAFG;
        this.iafg = this.customerData?.iafg;
        this.iafgSubscriptionPendingNotification = this.customerData?.iafg?.iafgSubscriptionPendingNotification; // true ---> iafg- plans are available but not chosen
        this.iafgSubscriptionConfirmation = this.customerData?.iafg?.iafgSubscriptionConfirmation; // false --> iafg- plans are available and chosen
        this.medicalQuestionaireStatus = this.customerData.medicalQuestionaireStatus
        this.pendingMedicalQuestionaire = this.customerData?.iafg?.pendingMedicalQuestionaire;
        this.pendingMedicalQuestionaireCoverage = this.customerData?.iafg?.pendingMedicalQuestionaireCoverage?.toUpperCase().includes('SPOUSE'); // null --> MEMBER or MEMBER-SPOUSE
        this.setSession('isSpouse', this.pendingMedicalQuestionaireCoverage);

        this.registrationDate = this.formatDate1(this.customerData?.registrationDate ? this.customerData.registrationDate : new Date());

        const today = new Date();
        this.latestPaymentStatus = this.customerData?.latestPaymentStatus;
        if (this.latestPaymentStatus === 'Failed') {
          if (this.customerData?.latestPaymentDetails?.captureDate < today) {
            this.isReauth = true;
          }
          else {
            this.isRetryPayment = true;
          }
        }

        console.log('this.registrationDate', this.registrationDate)

        this.beneficiaries = this.customerData?.beneficiaries ? this.customerData?.beneficiaries : [];
        this.beneficiariesConst = this.customerData?.beneficiaries ? this.customerData?.beneficiaries : [];
        if (this.beneficiaries !== null && this.beneficiaries !== undefined && this.beneficiaries.length > 0) {
          this.beneficiaries?.forEach(beneficiary => {
            if (beneficiary.trusteeDetails == null) {
              beneficiary.trusteeDetails = { firstName: "", lastName: "" };
            }
            if (beneficiary.contactDetails == null || Object.keys(beneficiary.contactDetails).length === 0) {
              beneficiary.contactDetails = { contingentBeneficiary: { firstName: '', lastName: '' } };
            } else {
              // Ensure contactDetails contains the necessary keys
              if (!beneficiary.contactDetails.hasOwnProperty('contingentBeneficiary')) {
                beneficiary.contactDetails.contingentBeneficiary = { firstName: '', lastName: '' };
              }
            }
          });
          this.beneficiaries1 = this.beneficiaries;
        }
        console.log('this.beneficiaries', this.beneficiaries)


        for (let i = 0; i < this.beneficiaries.length; i++) {
          if (this.beneficiaries[i].customerType.toLowerCase() == "spouse") {
            this.benficiaryIsSpouseDetails = { firstName: this.beneficiaries[i].firstName, lastName: this.beneficiaries[i].lastName }
          }
          if (this.beneficiaries[i].customerType.toLowerCase() == "member") {
            this.benficiaryIsMemberDetails = { firstName: this.beneficiaries[i].firstName, lastName: this.beneficiaries[i].lastName }
          }
        }

        this.countryId = this.customerData.countryFusebillId;
        console.log('claims debug - full response.data:', JSON.stringify(response?.data?.claimsDepositInfo));
        this.paymentMethod = this.customerData.paymentMethod;
        this.claimsDepositInfo = response?.data?.claimsDepositInfo?.data ?? null;
this.claimsUpdate = !!(this.claimsDepositInfo && Object.keys(this.claimsDepositInfo).length > 0);
        this.paymentMethodId = this?.customerData?.authorizenetPaymentId ?? this?.customerData?.paymentMethodId;
        this.memberportalgreensShildCheck = response?.data.serviceType.greenShildCustomer;
        this.memberportalEquitabelCheck = response?.data.serviceType.equitableCustomer

        this.waddelCustomer = response?.data.serviceType.waddelCustomer

        this.setSession("waddelCustomer", this.waddelCustomer)
        this.showinvoiceMessage = response?.data.showEmployeeNoInvoiceMessage
        this.isCorporateAccount = response?.data.isCorporateAccount
        this.showROES = response?.data.newroes
        this.showROAS = response?.data?.newroas && response?.data?.newroas.length > 0 && [response?.data?.newroas[0]]
        this.lecHistory = response?.data?.lifeEventChanges ?? []
        console.log('newroes', this.showROES)

        this.setSession("GreenShild", this.memberportalgreensShildCheck)
        this.setSession("Equitable", this.memberportalEquitabelCheck)

        this.setSession("FailedROE", this.customerData.ROE)

        this.failedsignature = this.customerData.failedDocs

        let checkValid = checkValidObject(response.data.dependents.spouseInfo)
        console.log(checkValid)
        let commonObj = {
          "id": 0,
          "firstName": "",
          "lastName": "",
          "dob": "",
          "gender": "",
          "age": "",
          "phoneNum": "",
          "email": "",
          "status": "",
          "coveredByAnotherPlan": true,
          "carrierName": "",
          "specialNeeds": false,
          "postSecondaryStudent": false,
          "graduationDate": "",
          "relationType": "",
          "maritalType": ""
        };

        // If there is a spouse and checkValid is true
        if (checkValid) {
          this.hasSpouse = true;
          let spData = response.data.dependents.spouseInfo;

          // Create a new object for the spouse so it doesn't overwrite the commonObj
          let spouseObj = { ...commonObj };
          console.log(spData, "spadata009")
          // Fill in the spouse-specific details
          spouseObj['firstName'] = spData?.firstName ?? "";
          spouseObj['lastName'] = spData?.lastName ?? "";
          spouseObj['dob'] = spData?.dob ?? "";
          spouseObj['gender'] = spData?.gender ?? "";
          spouseObj['age'] = spData?.age ?? "";
          spouseObj['phoneNum'] = spData?.phoneNum ?? "";
          spouseObj['email'] = spData?.email ?? "";
          spouseObj['status'] = spData?.status ?? "";
          spouseObj['coveredByAnotherPlan'] = spData?.coveredByAnotherPlan ?? true;
          spouseObj['carrierName'] = spData?.insurer ?? spData?.carrierName ?? "";
          spouseObj['specialNeeds'] = spData?.specialNeeds ?? false;
          spouseObj['postSecondaryStudent'] = spData?.postSecondaryStudent ?? false;
          spouseObj['graduationDate'] = spData?.graduationDate ?? "";
          spouseObj['id'] = spData?.id ?? 0;
          spouseObj['relationType'] = spData?.relationType
          spouseObj['maritalType'] = spData?.maritalType

          // Push the spouse data to the childrenInfo array
          this.childrenInfo.push(spouseObj);
        }

        // If there are children, process each one
        if (response.data.dependents.childrens && response.data.dependents.childrens.length > 0) {
          for (const child of response.data.dependents.childrens) {
            this.hasChildren = true;

            // Create a new object for each child to avoid reference issues
            let childObj = { ...commonObj };

            // Fill in the child-specific details
            childObj['firstName'] = child?.firstName ?? "";
            childObj['lastName'] = child?.lastName ?? "";
            childObj['dob'] = child?.dob ?? "";
            childObj['gender'] = child?.gender ?? "";
            childObj['age'] = child?.age ?? "";
            childObj['phoneNum'] = child?.phoneNum ?? "";
            childObj['email'] = child?.email ?? "";
            childObj['status'] = child?.status ?? "";
            childObj['coveredByAnotherPlan'] = child?.coveredByAnotherPlan ?? true;
            childObj['carrierName'] = child?.carrierName ?? "";
            childObj['specialNeeds'] = child?.specialNeeds ?? false;
            childObj['postSecondaryStudent'] = child?.postSecondaryStudent ?? false;
            childObj['graduationDate'] = child?.graduationDate ?? "";
            childObj['id'] = child?.id ?? "";

            // Push the child's data to the childrenInfo array
            this.childrenInfo.push(childObj);
          }
        }

        console.log(this.childrenInfo, 'childingo', response.data.dependents)

        for (let children of this.childrenInfo) {
          console.log(children.relationType, "nkkiiiilll")
          if (children.relationType == "") {
            children['relationType'] = 'child';
          } else {
            children['relationType'] = 'spouse';
          }
        }
        this.getbenefits();

        setTimeout(() => {
          this.getInvoices();
          this.getAdhocInvoices();
          this.getcoverflow() // pagination for tiles
        }, 1000);
        this.spouseInfo = response.data.dependents.spouseInfo;
        if (Object.keys(this.spouseInfo).length != 0) {
          this.spouseInfo['relationType'] = 'spouse';
        }
        else {
          this.editSpouse = false;
          this.editChild = true;
        }
        this.hicList = this.customerData.healthCards_v2.cards;
        this.roeUrl = this.customerData.ROE;
        console.log('this.paymentMethod', this.paymentMethod)
        if (this.paymentMethod === 'ACH') {
  this.getPADdetails();
  this.getCreditcard();
}
else if (this.paymentMethod === 'CREDIT_CARD') {
  this.getCreditcard();
}

        if (this.roeUrl != "") {
          this.roe = this.roeUrl
        }

        if (this.customerData.advisor.type == "CORPORATE") {
          this.advisor = this.customerData.advisor.parent;
          this.corporateDetails = this.customerData.advisor

        } else {
          this.advisor = this.customerData.advisor;
          this.corporateDetails = null

        }
        this.fusebillId = parseInt(this.customerData.id);
        this.customerID = this.fusebillId;

        this.spouseId = this.spouseInfo.id;
        this.secondaryPhone = this.customerData.secondaryPhone;
        if (JSON.stringify(this.spouseInfo) !== '{}') {
          this.spouseInfo.firstName = this.titleCase.transform(this.spouseInfo.firstName)
          this.spouseInfo.lastName = this.titleCase.transform(this.spouseInfo.lastName)
          this.spouseInfo.dob = toDisplayDate(this.spouseInfo.dob)
          this.spouse = 1;
        }
        else {
          this.spouse = 0;
        }
        let children = this.customerData.dependents.childrens.length;
        for (let i = 0; i < children; i++) {
          this.customerData.dependents.childrens[i].firstName = this.titleCase.transform(this.customerData.dependents.childrens[i].firstName)
          this.customerData.dependents.childrens[i].lastName = this.titleCase.transform(this.customerData.dependents.childrens[i].lastName)
          this.customerData.dependents.childrens[i].dob = toDisplayDate(this.customerData.dependents.childrens[i].dob)

        }
        this.customerData.primaryPhone = this.phoneNoFormat.transform(this.customerData.primaryPhone)
        this.customerData.secondaryPhone = this.phoneNoFormat.transform(this.customerData.secondaryPhone)
        this.customerData.line1 = this.titleCase.transform(this.customerData.line1)
        this.customerData.line2 = this.titleCase.transform(this.customerData.line2)
        this.customerData.city = this.titleCase.transform(this.customerData.city)
        for (let i = 0; i < this.childrenInfo.length; i++) {
          this.childrenInfo[i].dob = toDisplayDate(this.childrenInfo[i].dob)
          this.childrenInfo[i].graduationDate = toDisplayDate(this.childrenInfo[i].graduationDate)
        }
        this.cardNumber = this.childrenInfo.length + this.spouse;

        this.header?.getCustomerData(this.customerData);
        this.sidebar?.getCustomerData(this.customerData);
setTimeout(() => {
  this.fetchEligibilityBatchForOverview();
}, 1000);
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  navigateToQuestions(route) {
    this.setSession('isSpouse', route)
    this.router.navigate([`questions`]);
  }

  navigateToUpgradePlans() {
    this.setSession('isSpouse', this.pendingMedicalQuestionaireCoverage)
    this.router.navigate([`upgrade-plans`]);
  }


  get dependenttypeForm() {
    return this.dependentTypeForm.controls;
  }

  getPADdetails() {
    let endPoint = '/customer/' + this.customerid + '/achDetails'
    this.http.get(api.url + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log(response)
        if (response.data?.achDetails?.error && response.data?.achDetails?.error.length > 0) {
          return;
        }
        this.PADdetails = response?.data?.achDetails?.data || '';
        if (this.PADdetails?.padAgreement) {
          this.padAgreement = this.PADdetails?.padAgreement;
        }
        this.voidCheckImage = this.PADdetails?.voidCheckImage;
        const doc = new jsPDF();
        doc.addImage(this.voidCheckImage, 'JPEG', 10, 10, 190, 100);
        const pdfFile = doc.output('blob');
        this.voidCheckPdf = new File([pdfFile], 'voidCheque.pdf', { type: 'application/pdf' });
        this.voidCheckFileType = this.PADdetails?.voidCheckFileType;
        if (this.padAgreement != null) {
          this.existVoid = true;
        }
        this.bankCode = this.PADdetails?.bankCode;
        this.transitNumber = this.PADdetails?.transitNumber;
        this.accountNumber = this.PADdetails?.accountNumber;
        this.claimsDepositInfo = response?.data?.claimsDepositInfo?.data ?? null;
this.claimsUpdate = !!(this.claimsDepositInfo && Object.keys(this.claimsDepositInfo).length > 0);
        this.getcoverflow();
        this.getBankDetails();
      }
      else {
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.error?.message })
    })
  }
claimsUpdatePreview() {
  this.claimsLoading = true;
  setTimeout(() => {
    this.claimsVoidCheckImage = this.claimsImageDisplay;
  }, 1000);
}
openClaimsModal() {
  this.claimsPaymentMethodOption = this.paymentMethod === 'ACH' ? '' : 'other';
  this.claimsUploadCheque = false;
  this.claimsVoidCheque = null;
  this.claimsImageDisplay = null;
  this.claimsResetButton = false;

if (this.claimsUpdate && this.claimsDepositInfo) {
  // Update Claims flow — auto-populate, same as PAD's "Update PAD" screen
  this.claimsform.patchValue({
    bankcode: this.claimsDepositInfo.bankCode,
    transitNumber: this.claimsDepositInfo.transitNumber,
    accountNo: this.claimsDepositInfo.accountNumber,
  });
this.claimsBankInfo = {
  address: this.claimsDepositInfo.bankDetails?.address ?? '',
  bank: { name: this.claimsDepositInfo.bankDetails?.bank?.name ?? '' },
  formattedAddress: (this.claimsDepositInfo.bankDetails?.bank?.name ?? '') + "\n" + (this.claimsDepositInfo.bankDetails?.address?.split(",").join("\n") ?? '')
};
  this.claimsBankVerified = true;
} else {
    // Add Claims flow — empty, Bank ID not auto-populated
    this.claimsform.reset();
    this.claimsBankVerified = false;
  }
}
selectClaimsPaymentOption(option: 'same' | 'other') {
  this.claimsPaymentMethodOption = option;

  if (option === 'same') {
    // Auto-populate from the member's existing PAD/bank payment method, no manual entry
    this.claimsform.patchValue({
      bankcode: this.bankCode,
      transitNumber: this.transitNumber,
      accountNo: this.accountNumber,
    });
    this.claimsBankInfo = { address: this.bankinformation ?? '' };
    this.claimsBankVerified = true;
    this.claimsResetButton = false; // auto-populated, nothing to "clear" back to
  } else {
    // Other — manual entry required
    this.claimsform.reset();
    this.claimsBankVerified = false;
    this.claimsResetButton = false;
  }
}
verifyClaimsBank() {
  if (this.claimsform.invalid) {
    this.claimsform.markAllAsTouched();
    return;
  }
  let data: any = {
    bankCode: this.claimsform.get('bankcode')?.value,
    branchCode: this.claimsform.get('transitNumber')?.value,
    accountNumber: this.claimsform.get('accountNo')?.value,
  };
  const Endpoint = '/customer/bank/verify';
  this.http.post(api.url + Endpoint, data, {
    headers: {
      Authorization: 'Bearer ' + this.accessToken,
      'Content-Type': 'application/json',
    }
  }).subscribe((response: any) => {
if (response.status == 200) {
  this.claimsBankInfo = response?.data;
  this.claimsBankInfo.formattedAddress = response?.data?.bank?.name + "\n" + response?.data?.address?.split(",").join("\n");
  this.claimsAddress = this.claimsBankInfo?.address;
  this.claimsBankVerified = true;
      this.claimsUploadCheque = true; // upload shown, but NOT mandatory
      this.claimsResetButton = true;
    } else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
    }
  }, (error) => {
    Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.error?.message });
  });
}
onClaimsFileSelect(event: any) {
  const file = event.target.files[0];
  if (!file) return;

  const ext = "." + file.name.split(".").pop();
  this.claimsFileType = ext.toLowerCase() === '.pdf' ? 'application/pdf' : 'image/jpeg';

  const allowedMimes = ["image/jpeg", "image/pjpeg", "image/png", "application/pdf"];
  const fileSize = this.getSession("fileSize");

  if (!allowedMimes.includes(file.type)) {
    Swal.fire({
      allowOutsideClick: false,
      title: this.lang?.Error,
      html: this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed,
    });
    this.claimsform.get('files')?.reset();
    return;
  }
  if (file.size > 1000 * (Number(fileSize) ?? 5) * 1024) {
    Swal.fire({
      allowOutsideClick: false,
      title: this.lang?.Error,
      html: (this.lang?.File_Size_Too_Large_Max_File_Size_Is ?? 'File size is too large, maximum file size is') + ' ' + fileSize + 'MB',
    });
    this.claimsform.get('files')?.reset();
    return;
  }

  this.claimsVoidCheque = file;
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => { this.claimsImageDisplay = reader.result; };
}

clearClaimsForm() {
  this.claimsform.reset();
  this.claimsBankVerified = false;
  this.claimsUploadCheque = false;
  this.claimsVoidCheque = null;
  this.claimsImageDisplay = null;
  this.claimsResetButton = false;
}
submitClaims() {
  if (this.claimsPaymentMethodOption !== 'same' && this.claimsform.invalid) {
    this.claimsform.markAllAsTouched();
    return;
  }

  const formData: any = new FormData();
  formData.append('firstName', this.titleCase.transform(this.customerData?.firstName ?? ''));
  formData.append('lastName', this.titleCase.transform(this.customerData?.lastName ?? ''));

  if (this.claimsPaymentMethodOption === 'same') {
    // Don't send masked bank numbers — backend copies the real PAD record internally
    formData.append('sameAsPad', 'true');
  } else {
    let inputData1 = {
      bankCode: this.claimsform.get('bankcode')?.value,
      branchCode: this.claimsform.get('transitNumber')?.value,
      accountNumber: this.claimsform.get('accountNo')?.value,
      customerId: this.customerid
    };
    const encBank = btoa(JSON.stringify(inputData1));

    let bankAddress = this.claimsBankInfo?.address ?? '';
    let bankName = this.claimsBankInfo?.bank?.name ?? '';
    let addressLine1 = this.claimsBankInfo?.bank?.address?.split(',')[0] ?? '';

    let bankAddressArr = bankAddress.split(',');
    let bankCity = bankAddressArr[bankAddressArr.length - 2]?.trim().replace(' ', '');
    let provincePostal = bankAddressArr[bankAddressArr.length - 1];
    let provincePostalArr = provincePostal?.trim().split(' ') ?? [];
    let bankProvince = provincePostalArr[provincePostalArr.length - 3];
    let bankPostalCode = provincePostalArr[provincePostalArr.length - 2] + ' ' + provincePostalArr[provincePostalArr.length - 1];

    const bankobject = {
      name: bankName,
      address: addressLine1,
      city: bankCity,
      province: bankProvince,
      postalCode: bankPostalCode,
    };

    formData.append('bank', JSON.stringify(bankobject));
    formData.append('session', encBank);

    if (this.claimsVoidCheque) {
      const ext = '.' + this.claimsVoidCheque.name.split('.').pop();
      formData.append('files', this.claimsVoidCheque, 'Claims_' + Date.now() + ext.toLowerCase());
    }
  }

  formData.append('timestamp', new Date().getTime().toString());

  this.http.post(api.url + '/customer/' + this.customerid + '/claimsDepositInfo', formData, {
    headers: { Authorization: 'Bearer ' + this.accessToken }
  }).subscribe((response: any) => {
    if (response.status == 200) {
     Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message ?? (this.lang?.Claims_Deposit_Info_Saved_Successfully ?? 'Claims deposit info saved successfully.') });
      this.closeClaimsmodal?.nativeElement.click();
      this.getCustomerData();
    } else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
    }
  }, (error) => {
    Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.error?.message ?? (this.lang?.Something_Went_Wrong ?? 'Something went wrong.') });
  });
}

  formatDate1(date) {
    const date1 = parseDateOnly(date);
    if (!date1) {
      return '';
    }

    const futureDate: any = new Date(date1);
    futureDate.setDate(date1.getDate() + 30);
    const today: any = new Date();
    const diffInMs: any = futureDate - today;

    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    this.iafgDays = diffInDays;
    console.log(date, this.iafgDays)
    return toDisplayDate(date1);
  }

  /** Beneficiary payload date. Wire format, not display format. */
  formatDate(input) {
    return toLegacyUsDate(input);
  }

  removeUnderscores(input) {
    return input.replace('_', ' ').toLowerCase()
  }

  // ==== Beneficiary edit (ported from admin portal) ====
  get b() {
    return this.benficiaryForm.controls;
  }

  openBeneficiaryListModal(): void {
    this.originalBeneficiaries = JSON.parse(JSON.stringify(this.beneficiaries ?? []))
    this.stagingBeneficiaryData = (this.beneficiaries ?? []).map((b: any) => ({
      ...b,
      // bsDatepicker needs a local-midnight Date, not the API's date string.
      dob: parseDateOnly(b.dob),
      trusteeFirstName: b.trusteeDetails?.firstName ?? '',
      trusteeLastName: b.trusteeDetails?.lastName ?? '',
      trusteeRelation: b.trusteeDetails?.relationship ?? '',
      email: b.additionalDetails?.email ?? b.email ?? '',
      phoneNumber: b.additionalDetails?.phoneNumber ?? b.phoneNumber ?? '',
    }));
    this.benficiaryCount = false;
    this.showBenificiaryForm = this.stagingBeneficiaryData.length === 0;
    if (this.showBenificiaryForm) {
      this.addnewbenficiary();
    }
  }

  onClose(): void {
    this.stagingBeneficiaryData = [];
    this.benficiaryCount = false;
  }

  addnewbenficiary() {
    this.addeditbenficiary = true;
    this.showBenificiaryForm = true;
    this.BenficairyModalAddAndUpdateButton = 'Add';
    this.editBenficiaryIndex = undefined;
    this.benficiaryForm.reset({ type: 'PRIMARY', id: null });

    const usedPrimary = this.stagingBeneficiaryData
      .filter(b => b.type?.toUpperCase() === 'PRIMARY')
      .reduce((sum, b) => sum + (Number(b.percentage) || 0), 0);
    const remainingPercentage = 100 - usedPrimary;
    this.benficiaryForm.patchValue({
      percentage: remainingPercentage > 0 ? remainingPercentage : 0
    });
  }

  public savebenficiary(value: any) {
    if (this.benficiaryForm.invalid) {
      this.benficiaryForm.markAllAsTouched();
      return;
    }

    const rawRelationship = (value?.relationship ?? '').toString().trim();
    const isOtherRel = rawRelationship.toUpperCase() === 'OTHER';

    const obj: any = {
      id: value.id ?? undefined,
      customerId: this.customerData?.id,
      customerType: 'MEMBER',
      type: value.type ?? 'PRIMARY',
      firstName: this.capitalize(value.firstName ?? ''),
      lastName: this.capitalize(value.lastName ?? ''),
      dob: toApiDate(value.dob),
      relationship: isOtherRel
        ? ('OTHER-' + (value?.relationshipSpecific ?? '').toString().trim())
        : rawRelationship.toUpperCase(),
      percentage: parseFloat(value.percentage ?? '0'),
      gender: value.gender,
      trusteeDetails: {
        firstName: value.trusteeFirstName ? this.capitalize(value.trusteeFirstName) : '',
        lastName: value.trusteeLastName ? this.capitalize(value.trusteeLastName) : '',
        relationship: value.trusteeRelation ? this.capitalize(value.trusteeRelation) : '',
      },
      additionalDetails: {
        email: (value.email ?? '').trim(),
        phoneNumber: value.phoneNumber ?? '',
      },
      trusteeFirstName: value.trusteeFirstName ? this.capitalize(value.trusteeFirstName) : '',
      trusteeLastName: value.trusteeLastName ? this.capitalize(value.trusteeLastName) : '',
      trusteeRelation: value.trusteeRelation ? this.capitalize(value.trusteeRelation) : '',
      email: (value.email ?? '').trim(),
      phoneNumber: value.phoneNumber ?? '',
    };
    obj.isMinor = rawRelationship.toUpperCase() === 'CHILDREN' ? !this.adult(value.dob) : false;

    if (this.BenficairyModalAddAndUpdateButton === 'Update' && this.editBenficiaryIndex !== undefined) {
      obj.id = this.stagingBeneficiaryData[this.editBenficiaryIndex]?.id ?? obj.id;
      this.stagingBeneficiaryData[this.editBenficiaryIndex] = obj;
    } else {
      this.stagingBeneficiaryData.push(obj);
    }

    this.benficiaryForm.reset();
    this.showBenificiaryForm = false;
  }

  public editbenficiary(e: any, i: any, broker: any) {
    this.editBenficiaryIndex = i;
    this.addeditbenficiary = true;
    this.showBenificiaryForm = true;
    this.BenficairyModalAddAndUpdateButton = 'Update';

    const rel = (broker.relationship ?? '').toString().trim();
    const relUpper = rel.toUpperCase();
    const isOther = relUpper.startsWith('OTHER');

    const KNOWN = ['SPOUSE', 'CHILDREN', 'COMMON_LAW'];
    const relationshipValue = isOther
      ? 'OTHER'
      : (KNOWN.includes(relUpper) ? relUpper : (relUpper.startsWith('CHILD') ? 'CHILDREN' : relUpper));

    const relationshipSpecificValue = isOther
      ? (rel.split('-').slice(1).join('-').trim())
      : '';

    this.isChildCheck({ target: { value: relationshipValue } });

    if (relationshipValue === 'CHILDREN' && !this.adult(broker.dob)) {
      this.trusteeCheck = true;
    }

    this.benficiaryForm.patchValue({
      ...broker,
      relationship: relationshipValue,
      relationshipSpecific: relationshipSpecificValue,
      dob: broker.dob ? parseDateOnly(broker.dob) : null,
      trusteeFirstName: broker.trusteeDetails?.firstName ?? broker.trusteeFirstName ?? '',
      trusteeLastName: broker.trusteeDetails?.lastName ?? broker.trusteeLastName ?? '',
      trusteeRelation: broker.trusteeDetails?.relationship ?? broker.trusteeRelation ?? '',
      email: broker.additionalDetails?.email ?? broker.email ?? '',
      phoneNumber: broker.additionalDetails?.phoneNumber ?? broker.phoneNumber ?? '',
    });
  }

  public deleteBenficiaryPopup(license: any, i: number) {
    Swal.fire({
      title: 'Info',
      text: 'Are you sure you want to delete the existing beneficiary?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
      showConfirmButton: true
    }).then((submit: any) => {
      if (submit.isConfirmed) {
        this.deleteBenficiary(license, i);
      }
    })
  }

  public deleteBenficiary(license: any, i: number) {
    this.stagingBeneficiaryData.splice(i, 1);
    if (this.stagingBeneficiaryData.length === 0) this.showBenificiaryForm = true;
  }

  public isChildCheck(value: any) {
    this.trusteeCheck = false;
    this.benficiaryForm.get('trusteeFirstName')?.reset();
    this.benficiaryForm.get('trusteeLastName')?.reset();
    this.benficiaryForm.get('trusteeRelation')?.reset();
    const isChild = value.target.value === 'CHILDREN';
    ['trusteeFirstName', 'trusteeLastName', 'trusteeRelation'].forEach(k => {
      if (isChild) this.benficiaryForm.get(k)?.setValidators(Validators.required);
      else this.benficiaryForm.get(k)?.clearValidators();
      this.benficiaryForm.get(k)?.updateValueAndValidity();
    });

    const isOther = value.target.value === 'OTHER';
    if (isOther) {
      this.benficiaryForm.get('relationshipSpecific')?.setValidators(Validators.required);
    } else {
      this.benficiaryForm.get('relationshipSpecific')?.clearValidators();
    }
    this.benficiaryForm.get('relationshipSpecific')?.updateValueAndValidity();
  }

  public onDateChange(evnt: any) {
    if (this.isInitialLoad) { this.isInitialLoad = false; return; }
    this.trusteeCheck = false;
    if (this.benficiaryForm.value.relationship === 'CHILDREN' && evnt) {
      if (!this.adult(evnt)) {
        this.trusteeCheck = true;
        ['trusteeFirstName', 'trusteeLastName', 'trusteeRelation'].forEach(k =>
          this.benficiaryForm.get(k)?.setValidators(Validators.required)
        );
      } else {
        ['trusteeFirstName', 'trusteeLastName', 'trusteeRelation'].forEach(k => {
          this.benficiaryForm.get(k)?.clearValidators();
          this.benficiaryForm.get(k)?.updateValueAndValidity();
        });
      }
    }
  }

  public adult(date: any): boolean {
    const givenDate = parseDateOnly(date);
    if (!givenDate) {
      return false;
    }
    const currentDate = new Date();
    const age = currentDate.getFullYear() - givenDate.getFullYear();
    const monthDiff = currentDate.getMonth() - givenDate.getMonth();
    const dayDiff = currentDate.getDate() - givenDate.getDate();
    return age > 18 || (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)));
  }

  public checkDateOfBirthMinor(event: any) {
    if (event.type === 'input' && event.target.value === '') {
      this.benficiaryForm.controls['dob'].reset();
      this.benficiaryForm.controls['dob'].markAsTouched();
    }
  }

  public checkpercentagevalue(event: any) {
    if (parseFloat(event.target.value) > 100) {
      this.benficiaryForm.controls['percentage'].reset();
      this.benficiaryForm.controls['percentage'].markAsTouched();
    }
  }

  getBenRelation(rel: any) {
    return BENEFICIARY_RELATIONSHIPS.filter((r: any) => r?.value?.toLowerCase() == rel?.toLowerCase())[0]?.label || rel;
  }

  phoneFormatBeneficiary(event: any) {
    const inputValue = this.benficiaryForm.get('phoneNumber')?.value ?? '';
    this.benficiaryForm.get('phoneNumber')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }

  finalbenificiarySubmit() {
    const primaryBens = this.stagingBeneficiaryData.filter(d => d.type?.toUpperCase() === 'PRIMARY');
    const contingentBens = this.stagingBeneficiaryData.filter(d => d.type?.toUpperCase() === 'CONTINGENT');

    const primaryTotal = primaryBens.reduce((acc, d) => acc + parseFloat(d.percentage), 0);
    const contingentTotal = contingentBens.reduce((acc, d) => acc + parseFloat(d.percentage), 0);

    if (primaryBens.length === 0) {
      this.benficiaryCount = true;
      this.benficiaryCountMessage = 'At least one Primary beneficiary is required';
      return;
    }
    if (primaryTotal !== 100) {
      this.benficiaryCount = true;
      Swal.fire({ title: 'Info', text: 'Primary beneficiary percentages must equal to 100' })
      return;
    }
    if (contingentBens.length > 0 && contingentTotal !== 100) {
      this.benficiaryCount = true;
      Swal.fire({ title: 'Info', text: 'Contingent beneficiary percentages must equal to 100' })
      return;
    }

    this.benficiaryCount = false;

    const changes = this.buildBeneficiaryChanges();

    if (changes.length === 0) {
      // nothing changed — just close
      this.beneficiaries = JSON.parse(JSON.stringify(this.stagingBeneficiaryData));
      this.stagingBeneficiaryData = [];
      this.clsBeneficiaryModal();
      return;
    }

    const endPoint = '/customer/' + this.customerid + '/importDetails/0';
    this.http.put(api.url + endPoint, { changes }, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((res: any) => {
      this.stagingBeneficiaryData = [];
      this.originalBeneficiaries = [];
      this.getCustomerData();
      Swal.fire({ title: 'Info', text: res?.message || 'Benificiary details updated successfully' }).then(() => {
        this.clsBeneficiaryModal();
      })
    }, (err) => {
      Swal.fire({ title: 'Info', text: err?.error?.error?.message || err?.error?.message || 'Error updating beneficiaries details' });
    });
  }

  private clsBeneficiaryModal(): void {
    const modalEl = document.getElementById('beneficiaryListModal');
    if (!modalEl) return;
    if ((window as any).bootstrap) {
      (window as any).bootstrap.Modal.getInstance(modalEl)?.hide();
    } else {
      ($(modalEl as any) as any)?.modal('hide');
    }
  }

  private buildBeneficiaryChanges(): any[] {
    const changes: any[] = [];
    let changeIndex = 1;

    const originalById = new Map<number, any>(
      this.originalBeneficiaries
        .filter(b => b.id != null)
        .map(b => [b.id, b])
    );

    const stagingIds = new Set(
      this.stagingBeneficiaryData.filter(b => b.id != null).map(b => b.id)
    );

    // 1. Deletes: in original but missing from staging
    for (const orig of this.originalBeneficiaries) {
      if (orig.id != null && !stagingIds.has(orig.id)) {
        const normalized = JSON.stringify(this.normalizeForDiff(orig));
        changes.push({
          key: `beneficiaryInfo_${changeIndex++}`,
          label: 'Beneficiary',
          category: 'Beneficiary Information',
          categoryKey: 'beneficiaryInfo',
          fieldId: orig.id,
          customerId: this.customerData?.id,
          type: 'delete',
          oldValue: normalized,
          newValue: normalized
        });
      }
    }

    // 2. Adds & Changes: iterate staging
    for (const staged of this.stagingBeneficiaryData) {
      if (staged.id == null) {
        changes.push({
          key: `beneficiaryInfo_${changeIndex++}`,
          label: 'Beneficiary',
          category: 'Beneficiary Information',
          categoryKey: 'beneficiaryInfo',
          fieldId: 0,
          customerId: this.customerData?.id,
          type: 'add',
          oldValue: JSON.stringify({}),
          newValue: JSON.stringify(this.normalizeForDiff(staged)),
        });
        continue;
      }

      const orig = originalById.get(staged.id);
      if (!orig) {
        changes.push({
          key: `beneficiaryInfo_${changeIndex++}`,
          label: 'Beneficiary',
          category: 'Beneficiary Information',
          categoryKey: 'beneficiaryInfo',
          fieldId: 0,
          customerId: this.customerData?.id,
          type: 'add',
          oldValue: null,
          newValue: JSON.stringify(this.normalizeForDiff(staged)),
        });
        continue;
      }

      const oldNorm = JSON.stringify(this.normalizeForDiff(orig));
      const newNorm = JSON.stringify(this.normalizeForDiff(staged));
      if (oldNorm !== newNorm) {
        changes.push({
          key: `beneficiaryInfo_${changeIndex++}`,
          label: 'Beneficiary',
          category: 'Beneficiary Information',
          categoryKey: 'beneficiaryInfo',
          fieldId: staged.id,
          customerId: this.customerData?.id,
          type: 'change',
          oldValue: oldNorm,
          newValue: newNorm,
        });
      }
    }

    return changes;
  }

  private normalizeForDiff(b: any): any {
    if (!b) return null;

    const relationship = (b.relationship ?? '').toString().trim().toUpperCase();

    return {
      firstName: (b.firstName ?? '').toString().trim(),
      lastName: (b.lastName ?? '').toString().trim(),
      dob: b.dob ? this.toISODateOnly(b.dob) : null,
      relationship,
      percentage: this.toNumber(b.percentage),
      gender: (b.gender ?? '').toString().trim(),
      type: (b.type ?? '').toString().trim().toUpperCase(),
      isMinor: this.toBool(b.isMinor),
      trusteeDetails: {
        firstName: (b.trusteeDetails?.firstName ?? '').toString().trim(),
        lastName: (b.trusteeDetails?.lastName ?? '').toString().trim(),
        relationship: (b.trusteeDetails?.relationship ?? '').toString().trim(),
      },
      additionalDetails: {
        email: (b.additionalDetails?.email ?? b.email ?? '').toString().trim(),
        phoneNumber: (b.additionalDetails?.phoneNumber ?? b.phoneNumber ?? '').toString().trim(),
      },
    };
  }

  private toNumber(v: any): number {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  private toBool(v: any): boolean {
    if (typeof v === 'boolean') return v;
    return v === 'true' || v === true;
  }

  private nonZeroValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value === '' || control.value === null || control.value === undefined) {
      return null;
    }
    return parseFloat(control.value) <= 0 ? { zeroPercentage: true } : null;
  }

  private toISODateOnly(v: any): string | null {
    return toApiDate(v);
  }

  alphabatesOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (event.currentTarget.value.length == 0) {
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
  }

  numbersOnly(event: any) {
    const key = event.key || String.fromCharCode(event.keyCode);
    if (/(^[0-9 \-]+$)/.test(key)) {
      return true;
    } else {
      return false;
    }
  }

  addBeneficiary(num, customerType) {
    this.beneficiaries = [...this.beneficiariesConst];
    this.beneficiaries1 = [...this.beneficiaries];
    this.deleteBenfIds = [];
    this.deleteBenfIds1 = [];
    this.beneficiaries = this.beneficiaries.filter(ben => ben.customerType.toLowerCase() == customerType)
    this.beneficiaries1 = this.beneficiaries1.filter(ben => ben.customerType.toLowerCase() == customerType)
    this.currentBeneficiary.customerType = customerType
    this.currentBeneficiary.type = 'PRIMARY'
  }

  checkMinor(beneficiary: any, index) {
    if (!beneficiary.isMinor) {
      this.beneficiaries[index].trusteeDetails.firstName = '';
      this.beneficiaries[index].trusteeDetails.lastName = '';
    }
  }


  addDependentForm() {
    this.dependentTypeForm.get('dependentType')?.setValue('')
    this.functionClearSettings();
    this.dependentType = '';
    this.removeSession("plansummarymain")
    this.removeSession("plansskumain");
    this.removeSession("plansummaryopt");
    this.removeSession("plansummary");
    this.removeSession("selectedPlans");
    this.removeSession("totalAmount");
    this.removeSession("totalAmountUI");
    this.totalSummaryPrice = 0
    this.dependentform.get('effectiveDate')?.setValue('')

    const dependentType = this.dependentTypeForm.value.dependentType
    this.addDependentWithSpouse = false;
    console.log('this.dependentCoverage', this.dependentCoverage)
    this.totalCount = 0;
    this.childCoverage = '';
  }

  changeDependent(e: any) {
    this.functionClearSettings()
    this.dependentType = e.target.value;
    if (this.dependentType == 'spouse' || this.dependentType == 'multiple')
      this.dependentTypeForm.get('marriageType')?.setValue('')
    if (this.dependentType == 'spouse') {
      this.dependentTypeForm.get('marriageDate')?.setValue('')
    }
    this.dependentTypeForm.get('childrenCountData')?.setValue('')
    this.dependentform.get('effectiveDate')?.setValue('')
    this.removeSession("plansummarymain")
    this.removeSession("plansskumain");
    this.removeSession("plansummaryopt");
    this.removeSession("plansummary");
    this.removeSession("selectedPlans");
    this.removeSession("totalAmount");
    this.removeSession("totalAmountUI");
  }

  changeMode(e: any) {
    this.functionClearSettings();
    this.mode = e.target.value;
  }

  momentDateformat(date: any) {
    return toDisplayDate(date);
  }

  handleChildDetails_v2() {
    console.log(this.pureDependentform, this.dependentform, this.addDependentWithSpouse)
    if (this.addDependentWithSpouse) {
      const spouseData_ = this.dependentTypeForm.value
      console.log(spouseData_, 'effectiveDate')
      this.dependentform.get('effectiveDate')?.setValue(spouseData_.effectiveDate, { emitEvent: false })
      if (this.dependentChildCoverage == 'close') {
        this.dependentform.get('carrierName')?.setValue(false, { emitEvent: false })
        this.dependentform.get('coveredByAnotherPlan')?.setValue(false, { emitEvent: false })
      }
    }

    if (this.dependentform.valid) {
      console.log("accessed", this.dependentform.valid, this.dependentform, this.specialNeeds)
      this.showChildForm = false;
      this.addDependentWithSpouse = false;
      if (this.editChildUpdate) {
        const updatedData = this.childrenDetails.map((item, index) => {
          if (index === this.childIndex) {
            return this.dependentform.value // Replace with new value
          }
          return item; // Return the original object for all other indices
        });
        this.childrenDetails = updatedData;
      } else {
        this.childrenDetails.push(this.dependentform.value)
      }
      if (this.dependentform.value.coveredByAnotherPlan == true) {
        this.childCovered = true
      }
      console.log('this.dependentCoverage', this.dependentCoverage)
      this.totalCount = this.totalCount + 1;
      this.handleContinue();
      let childrenName = this.dependentform.value.firstName + ' ' + this.dependentform.value.lastName;
      let effectiveDate = toDisplayDate(this.dependentform.value.effectiveDate)
      if (this.dependentform.value.specialNeeds) {
        Swal.fire({ title: 'Info', text: `Your child ${childrenName} has Special needs, and needs be processed before ${effectiveDate} can be covered. Please check with you advisor on the status of enrollment.` })
      } else {
        Swal.fire({ title: 'Info', text: this.editChildUpdate ? 'Child info has been updated successfully.' : 'Children has been added successfully' })
      }
      this.addDependentWithSpouse = false;
      this.dependentform.reset();
    } else {
      this.dependentform.markAllAsTouched();
      return;
    }

    this.dependentChildCoverage = 'close'
    this.postSecondaryStudent = false;
    this.dependentform.reset();
  }

  closeHandleChildDetails() {
    this.functionClearSettings()
    this.showChildForm = false;
  }

  getPlanSummaryObject() {
    console.log(this.oldExistingPlans);

    let selectedPlans: any = this.getSession("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }

    let object_: any = []

    console.log('selectedPlans', selectedPlans)
    for (const i of selectedPlans) {
      let oldPlanObj = this.oldExistingPlans.find(item => (item.planlevel.packageId == i.packageId && item.planlevel.parentId == i.planLevelParent))
      let obj = {
        packageName: oldPlanObj?.description ?? "",
        oldPlan: {
          plan: oldPlanObj?.name + ' ' + `(${oldPlanObj?.planCoverageUI})`,
          coverage: oldPlanObj?.planCoverageUI ?? "",
          tax: oldPlanObj?.calculatedTax?.tax ?? 0,
          price: oldPlanObj?.calculatedTax?.price ?? 0,
          total: oldPlanObj?.calculatedTax?.total ?? 0,
        },
        newPlan: {
          packageName: i?.packagename ?? "",
          plan: i.name + ' ' + `(${i.coverage})`,
          coverage: i?.planCoverageUI ?? "",
          tax: i?.tax ?? 0,
          price: i?.amount ?? 0,
          total: i?.total ?? 0,
        }
      }
      object_.push(obj)
    }

    console.log(object_)
    this.plansSummaryObj = object_;
  }

  handlePrepareNotes() {
    let notes: any = [];
    if (this.newlySelectedPlans && this.newlySelectedPlans.length > 0) {
      for (const nsp of this.newlySelectedPlans) {
        let newPlanName = nsp.name + '(' + nsp?.planCoverage + ')' || '';
        let oldPlanName = this.unSelectedPlans_ && this.unSelectedPlans_.length > 0 ? this.unSelectedPlans_[0]['name'] + '(' + this.unSelectedPlans_[0]['planCoverage'] + ')' : '';
        let coverageChange = this.coverageChange
        let coverageScenario = this.coverageChange
        let newPrice = nsp.price
        let oldPrice = this.unSelectedPlans_ && this.unSelectedPlans_.length > 0 ? this.unSelectedPlans_[0]['price'] : nsp.price
        let service = this.provisioningSites
        let dependent = this.dependentType
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"

        if (this.dependentType == 'child') {
          for (const child of this.childrenDetails) {
            if (child.specialNeeds) {
              approvalStatus = "pending"
            } else {
              approvalStatus = this.normalDependentRegistration ? "normal" : "proceed"
            }
          }
        }


        let noteString = { planChange: oldPlanName + '-' + newPlanName, coverageChange: coverageChange, coverageScenario: coverageScenario, priceChange: oldPrice + '-' + newPrice, service: service, dependent: dependent, approvalStatus: approvalStatus }
        notes.push(noteString)
      }
    }

    return notes;
  }

  handleDeletePrepareNotes() {
    let notes: any = [];
    if (this.unSelectedPlans_ && this.unSelectedPlans_.length > 0) {
      for (const nsp of this.unSelectedPlans_) {
        let newPlanName = nsp.name + '(' + nsp?.planCoverage + ')' || '';
        let oldPlanName = this.newlySelectedPlans[0]['name'] + '(' + this.newlySelectedPlans[0]['planCoverage'] + ')';
        let coverageChange = this.coverageChange
        let coverageScenario = this.coverageChange
        let newPrice = nsp.price
        let oldPrice = this.newlySelectedPlans[0]['price']
        let service = this.provisioningSites
        let dependent = this.dependentType
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"

        if (this.dependentType == 'child') {
          for (const child of this.childrenDetails) {
            if (child.specialNeeds) {
              approvalStatus = "pending"
            } else {
              approvalStatus = this.normalDependentRegistration ? "normal" : "proceed"
            }
          }
        }


        let noteString = { planChange: oldPlanName + '-' + newPlanName, coverageChange: coverageChange, coverageScenario: coverageScenario, priceChange: oldPrice + '-' + newPrice, service: service, dependent: dependent, approvalStatus: approvalStatus }
        notes.push(noteString)
      }
    }

    return notes;
  }

  functionClearSettings() {
    this.dependentform.reset();
    this.validateCheck = true;
    this.spouseform.reset();
    this.isMarried = false;
    this.childCount = 0;
    this.showValidatePlans = false;
    this.showPlanDetails = false;
    this.showSpouseInfo = false;
    this.specialpackages = []
    this.plansSummaryObj = []
    this.childCoverage = false;
    this.isCommonLaw = false;
    this.showChildForm = false;
    this.childrenDetails = []
    this.normalSpouseRegistration = true;
    this.normalDependentRegistration = false;
  }

  addBenficiaryRow() {
    let obj = {
      "_id": Math.random() * 100,
      "firstName": "",
      "lastName": "",
      "type": "PRIMARY",
      "customerType": this.currentBeneficiary.customerType,
      "relationship": "",
      "dob": "",
      "isMinor": false,
      "percentage": "",
      "contactDetails": { contingentBeneficiary: { firstName: "", lastName: '' } },
      "trusteeDetails": { firstName: "", lastName: "" },
      "age": "",
      "gender": ""
    }
    this.beneficiaries.push(obj)
    this.beneficiaries1.push(obj)

    let seenIds = new Set();
    this.beneficiaries = this.beneficiaries.filter(beneficiary => {
      if (!seenIds.has(beneficiary._id)) {
        seenIds.add(beneficiary._id);
        return true;
      }
      if (!seenIds.has(beneficiary.id)) {
        seenIds.add(beneficiary.id);
        return true;
      }
      return false;
    });

    seenIds = new Set();
    this.beneficiaries1 = this.beneficiaries1.filter(beneficiary => {
      if (!seenIds.has(beneficiary._id)) {
        seenIds.add(beneficiary._id);
        return true;
      }
      if (!seenIds.has(beneficiary.id)) {
        seenIds.add(beneficiary.id);
        return true;
      }
      return false;
    });
  }

  checkValid(data, error) {
    if (data == "" || data == null || data == undefined) {
      Swal.fire({ title: this.lang?.Error, text: error })
      return true;
    } else {
      return false;
    }
  }

  onRelationshipChange(beneficiary: any) {
    if (beneficiary.relationship !== 'CHILD') {
      // If relationship is not CHILD, set isMinor to false and prevent setting it to true
      beneficiary.isMinor = false;
      beneficiary.trusteeDetails = { firstName: '', lastName: '' }
    }
  }

  addNewBeneficiary(beneficiary) {
    const obj = {
      "firstName": beneficiary.firstName,
      "lastName": beneficiary.lastName,
      "type": beneficiary.type,
      "customerType": beneficiary.customerType,
      "relationship": beneficiary.relationship != 'OTHERS' ? beneficiary.relationship : beneficiary.others,
      "dob": beneficiary.isMinor ? this.formatDate(beneficiary.dob) : '',
      "isMinor": beneficiary.isMinor,
      "percentage": beneficiary.percentage,
      "contactDetails": beneficiary.contactDetails == '' ? {} : beneficiary.contactDetails,
      "trusteeDetails": beneficiary.isMinor ? beneficiary.trusteeDetails : { firstName: '', lastName: '' }
    }
    if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
      return;
    }
    if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
      return;
    }
    if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
      return;
    }
    if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
      return;
    }
    if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
      return;
    }
    if (obj?.isMinor != true && obj?.isMinor != false) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
      return;
    }
    if (obj.isMinor == true) {
      if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
        return;
      }
      if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
        return;
      }
      if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
        return;
      }
    }
    if (obj?.isMinor != true && obj?.isMinor != false) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
      return;
    }
    if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
      return;
    }

    const customerId = this.getSession('customerId')
    let endPoint = `/customer/${customerId}/beneficiary`
    this.http.post(api.url + endPoint, obj, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log('beneficiary-add in db', obj)
        this.beneficiaryReload += 1;
        if (this.beneficiaryReload == this.beneficiaries.length) {
          Swal.fire({
            title: "Info",
            text: this.lang?.Beneficiaries_updated_successfully
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    })
  }

  updateBeneficiaries() {
    console.log(this.beneficiaries, this.beneficiaries1)
    const benf = this.beneficiaries1.filter(ben => ben?.id && !this.deleteBenfIds.includes(ben?.id))
    const benf1 = this.beneficiaries1.filter(ben => ben?._id && !this.deleteBenfIds1.includes(ben?._id))
    const benfs = [...benf, ...benf1]
    const allPercentages = benfs.map(ben => Number(ben.percentage));
    let totalPercentage = 0;
    for (let i = 0; i < allPercentages.length; i++) {
      totalPercentage += allPercentages[i];
    }
    console.log(totalPercentage, allPercentages)
    if (totalPercentage != 100) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Total_sum_percentages_are_not_equal_to_100 })
      return;
    }
    let reload = 0;
    for (let i = 0; i < benfs.length; i++) {
      let obj = benfs[i]
      if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
        reload++;
        return;
      }
      if (obj?.isMinor != true && obj?.isMinor != false) {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
        reload++;
        return;
      }
      if (obj.isMinor == true) {
        if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
          reload++;
          return;
        }
        if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
          reload++;
          return;
        }
        if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
          reload++;
          return;
        }
      }
      if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
        reload++;
        return;
      }
    }
    if (reload > 0) {
      return;
    }
    for (let i = 0; i < benfs.length; i++) {
      const beneficiary = benfs[i];
      const customerId = this.getSession('customerId')
      if (beneficiary.id) {
        let endPoint = `/customer/${customerId}/beneficiary/${beneficiary.id}`
        const obj = {
          "firstName": beneficiary.firstName,
          "lastName": beneficiary.lastName,
          "type": beneficiary.type,
          "customerType": beneficiary.customerType,
          "relationship": beneficiary.relationship != 'OTHERS' ? beneficiary.relationship : beneficiary.others,
          "dob": beneficiary.isMinor ? this.formatDate(beneficiary.dob) : '',
          "isMinor": beneficiary.isMinor,
          "percentage": beneficiary.percentage,
          "contactDetails": beneficiary.contactDetails,
          "trusteeDetails": beneficiary.isMinor && beneficiary.trusteeDetails.firstName != null ? beneficiary.trusteeDetails : { firstName: "", lastName: "" }
        }
        if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
          return;
        }
        if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
          return;
        }
        if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
          return;
        }
        if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
          return;
        }
        if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
          return;
        }
        if (obj?.isMinor != true && obj?.isMinor != false) {
          Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
          return;
        }
        if (obj.isMinor == true) {
          if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
            return;
          }
          if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
            return;
          }
          if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
            return;
          }
        }
        if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
          return;
        }
        this.http.put(api.url + endPoint, obj, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            console.log('beneficiary is updated in db', obj)
            this.beneficiaryReload += 1;
            if (this.beneficiaryReload == this.beneficiaries.length) {
              Swal.fire({
                title: "Info",
                text: this.lang?.Beneficiaries_updated_successfully
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                } else {
                  window.location.reload()
                }
              })
            }
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        })

      } else {
        this.addNewBeneficiary(beneficiary)
      }
    }
    for (let i = 0; i < this.beneficiaries1.length; i++) {
      if (this.deleteBenfIds.includes(this.beneficiaries1[i]?.id)) {
        const customerId = this.getSession('customerId')
        let endPoint = `/customer/${customerId}/beneficiary/${this.beneficiaries1[i].id}`
        this.http.delete(api.url + endPoint, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            console.log('beneficiary deleted in db', this.beneficiaries1[i])
            this.beneficiaryReload += 1;
            if (this.beneficiaryReload == this.beneficiaries.length) {
              Swal.fire({
                title: "Info",
                text: this.lang?.Beneficiaries_updated_successfully
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                } else {
                  window.location.reload()
                }
              })
            }
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        })
      } else {
      }
    }
  }

  deleteBeneficiary(beneficiary) {
    Swal.fire({
      title: this.lang?.Delete_Beneficiary,
      text: this.lang?.Do_you_want_to_delete_this_beneficiary,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: this.lang?.Cancel,
      denyButtonText: this.lang?.Delete,
    }).then((result) => {
      if (result.value) {
        this.deleteBenfIds = []
        this.deleteBenfIds1 = []
      } else {
        if (beneficiary.id) {
          this.deleteBenfIds = [...this.deleteBenfIds, beneficiary.id]
          this.beneficiaries = this.beneficiaries.filter(ben => ben.id != beneficiary.id)
        } else {
          this.deleteBenfIds1 = [...this.deleteBenfIds1, beneficiary._id]
          this.beneficiaries = this.beneficiaries.filter(ben => ben._id != beneficiary._id)
        }
      }
    })
  }

  getBankDetails() {
    let data = this.PADdetails;
    data['branchCode'] = this.PADdetails?.transitNumber;
    let accessToken = this.getSession('accessToken');
    const Endpoint = '/customer/bank/verify';
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bank = response?.data;
        this.address = this.bank?.address;
        this.bankinformation = response?.data?.bank?.name + "\n" + response?.data?.address?.split(",").join("\n");
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response?.message })

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        Cookies.set('Home_bank_verify_error_' + currentTimeStamp, 'Bank Verify error: ' + JSON.stringify(response));

        // create object for report log
        let log = { [`Bank Verify 400 ${currentTimeStamp}`]: response }
        let obj = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj);
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.message })

      let currentTimeStamp = this.apiCommonService.getTimeStamp();
      let err = error?.error?.error ?? error?.error ?? error;
      Cookies.set('Home_bank_verify_error_' + currentTimeStamp, 'Bank verify error: ' + JSON.stringify(err));

      // create object for report log
      let log = { [`Bank Verify error ${currentTimeStamp}`]: err }
      let obj = {
        customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
        browser: '',
        systemDetails: {},
        logs: JSON.stringify(log),
        sessionDetails: '{}'
      };
      this.apiCommonService.submitReportLog(obj);
    })
  }
  viewPlansLoading(e: any) {
    this.showViewPlansLoading = false;
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.totalPages = pdf.numPages;
    setTimeout(() => {
      this.showViewPlansLoading = false;
    }, 100)
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }

  previousPage() {
    if (this.page > 1) {
      this.page--;
    }
  }

  pdfLoaded(e: any) {
    this.loading = false;
  }

  public getLanguageTokens() {
    let body = {
      "project": "Member Portal",
      "url": "Overview"
    }
    this.http
      .post(api.lang + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.lang = {};
          this.selectedLanguage = this.getSession('language') || 'English'
          for (let token of response.strings) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          console.log(this.lang)
        }
      )
  }

  updateAddressForm() {

    this.invalidpostalcodeprivince = false
    this.provianceList?.forEach((element: any) => {
      if (element.name == this.customerData.province) {
        this.customerData.province = element.shortName
      }
    });

    this.addressform.patchValue(normalizeDateFields({ ...this.customerData, ...this.customerData?.homeProvinceDetails }));
    this.addressform.markAllAsTouched();

    if (this.isViking) {
      let parsedDateOfRetirement: Date | null = null;
      if (this.customerData?.additionalDetails?.dateOfRetirement) {
        parsedDateOfRetirement = parseDateOnly(this.customerData.additionalDetails.dateOfRetirement);
      }
      let pgc = this.customerData?.additionalDetails?.priorGroupCoverage ?? {};
      pgc = typeof pgc == 'string' ? JSON.parse(pgc) : pgc;
      let parsedLastDayOfGroupBenefits: Date | null = null;
      if (pgc.lastDayOfGroupBenefits) {
        parsedLastDayOfGroupBenefits = parseDateOnly(pgc.lastDayOfGroupBenefits);
      }
      this.addressform.patchValue({
        provinceHealthCareNumber: this.customerData?.additionalDetails?.provinceHealthCareNumber || '',
        initial: this.customerData?.additionalDetails?.initial || '',
        poBox: this.customerData?.additionalDetails?.poBoxAddress ?? this.customerData?.additionalDetails?.poBox ?? '',
        dateOfRetirement: parsedDateOfRetirement,
        previousEmployer: pgc.previousEmployer || '',
        employerPhoneOrEmail: pgc.employerPhoneOrEmail || '',
        lastDayOfGroupBenefits: parsedLastDayOfGroupBenefits,
        certificatePolicyNumber: pgc.certificatePolicyNumber || '',
        previousBenefitProvider: pgc.previousBenefitProvider || '',
      });

      // Capture old values for Viking change-tracking after all patches
      this.addressFormOldValues = { ...this.addressform.value };
      console.log('[updateAddressForm] Viking old values snapshot', this.addressFormOldValues);
    }
  }

  updateAddress() {

    if (this.addressform.invalid) {
      this.addressform.markAllAsTouched();
      return;
    }
    else if (this.isViking) {
      this.updateAddressViking();
    }
    else {
      if (this.addressform.value.secondaryPhone == this.addressform.value.primaryPhone) {
        this.secondaryphonecheck = true

      }
      else {
        this.secondaryphonecheck = false
        if (this.addressform.invalid) {
          this.addressform.markAllAsTouched();
          return;
        }
        else {
          const endPoint = '/customer/' + this.customerid + '/address';
          let data = this.addressform.value;
          data["street_address_line1"] = this.addressform.value.line1
          data["street_address_line2"] = this.addressform.value.line2
          if (data["street_address_line2"].value == '') {
            data["street_address_line2"] = ' ';
          }
          else {
            if (data["street_address_line2"].value == null) {
              data["street_address_line2"] = ' ';
            }
          }
          data["postal_code"] = this.addressform.value.postalCode
          data["dob"] = toLegacyUsDate(this.addressform.value.dob)
          data["code"] = this.valisignform.value.code
          if (this.addressForm['secondaryPhone'].value == null) {
            data['secondaryPhone'] = '';
          }
          if (this.addressform.valid && this.invalidpostalcodeprivince == false) {
            let headers = {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
            this.http.put(api.url + endPoint, data, {
              headers: headers
            }).subscribe((response: any) => {
              if (response.status == 200) {

                this.getCustomerData();
                this.closeAddressmodal.nativeElement.click();
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
              }
              else {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
              }
            }, (error) => {

              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

            });
          }
        }
      }
    }



  }

  private updateAddressViking() {
    console.log("called38e838", this.invalidpostalcodeprivince)
    if (this.invalidpostalcodeprivince != false) {
      return;
    }

    console.log(this.addressform)
    console.log(this.addressFormOldValues)

    const addressFieldId = this.customerData?.homeProvinceDetails?.id;
    const customerId = this.customerData?.id;
    const nv = this.addressform.value;
    const ov = this.addressFormOldValues;
    console.log('[updateAddressViking] old values', ov);
    console.log('[updateAddressViking] new values', nv);

    const changes: any[] = [];

    // Bundle all address fields into one "address" change object
    const buildAddressObj = (v: any) => ({
      line1: v.line1 || '',
      line2: v.line2 || '',
      city: v.city || '',
      state: v.province || '',
      postalCode: v.postalCode || '',
      primaryPhone: v.primaryPhone || '',
      secondaryPhone: v.secondaryPhone || '',
      primaryEmail: v.email || '',
      country: v.country || '',
    });
    const addressKeys = ['line1', 'line2', 'city', 'province', 'postalCode', 'primaryPhone', 'secondaryPhone', 'email', 'country'];
    const addressChanged = addressKeys.some(k => String(ov[k] ?? '') !== String(nv[k] ?? ''));
    if (addressChanged) {
      changes.push({
        key: 'address',
        label: 'Address',
        category: 'Personal Information - Address',
        categoryKey: 'personalInfoAddress',
        fieldId: addressFieldId,
        customerId,
        type: 'change',
        oldValue: JSON.stringify({ id: addressFieldId, ...buildAddressObj(ov) }),
        newValue: JSON.stringify(buildAddressObj(nv)),
      });
    }

    // Individual personal info fields
    const personalFields = [
      { key: 'firstName', label: 'First Name', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'lastName', label: 'Last Name', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'gender', label: 'Gender', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'dob', label: 'Date of Birth', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'initial', label: 'Initial', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'dateOfRetirement', label: 'Date of Retirement', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'provinceHealthCareNumber', label: 'Province Health Card Number', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'email', label: 'Primary Email', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
      { key: 'poBox', label: 'PO Box', category: 'Personal Information - Main', categoryKey: 'personalInfoMain' },
    ];
    const dateFields = new Set(['dob', 'dateOfRetirement']);
    const formatFieldValue = (key: string, val: any): string => {
      if (dateFields.has(key)) {
        if (!val) return '';
        return toApiDate(val) ?? '';
      }
      return String(val ?? '');
    };

    personalFields.forEach(field => {
      const oldVal = formatFieldValue(field.key, ov[field.key]);
      const newVal = formatFieldValue(field.key, nv[field.key]);
      if (oldVal !== newVal) {
        changes.push({
          key: field.key,
          label: field.label,
          category: field.category,
          categoryKey: field.categoryKey,
          fieldId: customerId,
          customerId,
          type: 'change',
          oldValue: oldVal,
          newValue: newVal,
        });
      }
    });

    // Bundle Prior Group Coverage Confirmation fields into one change object
    const pgcKeys = ['previousEmployer', 'employerPhoneOrEmail', 'lastDayOfGroupBenefits', 'certificatePolicyNumber', 'previousBenefitProvider'];
    const pgcChanged = pgcKeys.some(k => String(ov[k] ?? '') !== String(nv[k] ?? ''));
    if (pgcChanged) {
      const formatPgcDate = (val: any): string => {
        if (!val) return '';
        return toApiDate(val) ?? '';
      };
      const buildPgcObj = (v: any) => ({
        previousEmployer: v.previousEmployer || '',
        employerPhoneOrEmail: v.employerPhoneOrEmail || '',
        lastDayOfGroupBenefits: formatPgcDate(v.lastDayOfGroupBenefits),
        certificatePolicyNumber: v.certificatePolicyNumber || '',
        previousBenefitProvider: v.previousBenefitProvider || '',
      });
      changes.push({
        key: 'priorGroupCoverage',
        label: 'Prior Group Coverage Confirmation',
        category: 'personalInfoMain',
        categoryKey: 'personalInfoMain',
        fieldId: customerId,
        customerId,
        type: 'change',
        oldValue: JSON.stringify(buildPgcObj(ov)),
        newValue: JSON.stringify(buildPgcObj(nv)),
      });
    }

    console.log('[updateAddressViking] detected changes', changes);
    const endPoint = '/customer/' + this.customerid + '/importDetails/0';

    this.http.put(api.url + endPoint, { changes }, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.getCustomerData();
        this.closeAddressmodal.nativeElement.click();
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
      } else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.error?.message });
    });
  }

  updatePhoneNoForm() {
    this.phoneform.patchValue(this.customerData);
  }

  updatePhoneNo(value: any) {
    if (this.phoneform.invalid) {
      this.phoneform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/customer/' + this.customerid + '/address';
      let data = this.phoneform.value;
      if (this.phoneForm['secondaryPhone'].value == null) {
        data['secondaryPhone'] = '';
      }
      this.http.put(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.getCustomerData();
          this.closePhonemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });

    }

  }

  closePhoneModal() {
    this.phoneform.reset();
  }

  updateSpouseDetails() {

    console.log("data", this.updatespouseform)

    if (this.updatespouseform.invalid) {
      this.updatespouseform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/customer/' + this.customerid + '/customerRelative/' + this.spouseId + '/details';

      let data = this.updatespouseform.value;

      data["coverage"] = this.updatespouseform.value.healthPlan || "";
      data["carrierName"] = this.updatespouseform.value.insurer || "";
      data["relationType"] = "SPOUSE"
      if (this.updatespouseform.value.coveredByAnotherPlan === true) {
        data["coveredByAnotherPlan"] = true
      }
      else {
        data["coveredByAnotherPlan"] = false
      }

      data["dob"] = toLegacyUsDate(this.updatespouseform.value.dob)
      this.http.put(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.getCustomerData();
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }

  deleteSpouseDetails_1(children) {
    this.dependentTypeForm.reset()
    this.dependentType == "spouse"
    this.spouseCovered = children?.coveredByAnotherPlan;
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
  }

  deleteChildrenDetails_1(children) {
    this.dependentTypeForm.reset()
    this.dependentType == "dependent"
    this.childCovered = children?.coveredByAnotherPlan;
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
  }


  async handleDeleteDependent(depDetails: any) {
    this.removeSession("plansummarymain")
    this.removeSession("plansskumain");
    this.removeSession("plansummaryopt");
    this.removeSession("plansummary");
    this.removeSession("selectedPlans");
    this.removeSession("totalAmount");
    this.removeSession("totalAmountUI");
    console.log("called333");
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = depDetails.id;

    console.log(depDetails)
    this.selectedDependentDetails = depDetails;
    this.dependentType = depDetails.relationType == "child" ? "dependent" : "spouse"
    this.spouseCovered = depDetails.relationType == "child" ? false : depDetails?.coveredByAnotherPlan
    this.childCovered = depDetails.relationType == "spouse" ? false : depDetails?.coveredByAnotherPlan
    this.currentDeleteMember = depDetails.relationType == "child" ? "child" : "spouse"
    this.dependentTypeForm.reset()
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
    Swal.fire({
      allowOutsideClick: false,
      title: 'Info',
      text: 'Are you sure you want to Delete?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((res) => {
      if (res.isConfirmed) {
        // After SweetAlert confirmation, show the modal

      } else {
        $("#cancelButton22").click()
      }
    })
  }

  async handleConfirmDelete() {

    console.log("0hgggg")


    let selectedPlans: any = this.getSession("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }



    console.log('this.specialpackages', this.specialpackages)

    // 1st
    this.plansObj = []
    let phrPlanSelected = false;
    let isPhr = false;
    let oldPlans: any = []
    for (let pack of this.specialpackages) {
      let obj: any = {};
      let selected: any = {};

      if (pack.id == 10) isPhr = true;

      if (pack.selected) {
        if (pack.id == 10) phrPlanSelected = true;
        console.log("Package selected, checking groups...");  // Debugging package selection

        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    if (c.selected) {
                      selected = { ...c };
                      console.log("Selected addon:", selected);  // Debugging selected addon

                      for (let sc of selectedPlans) {
                        console.log("Comparing with selected plan:", sc);  // Debugging comparison with selected plans
                        if (c.planId == sc?.id && !sc?.products[0]?.selected) {
                          obj = {
                            ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                            newPlan: { ...sc },
                            ...(c.planCoverage != sc.coverage && c.selected && this.covergages.includes(c.planCoverage) && { coverageChange: true })
                          };
                          console.log("Plan comparison result obj:", obj);  // Debugging obj creation
                        } else {
                          this.unselected.forEach((ele) => {
                            if (ele.planId == c.planId) {
                              console.log("Unselected plans:", this.unselected);  // Debugging unselected plans
                              let obj1: any = {
                                ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                                newPlan: {},
                              };
                              oldPlans.push(obj1);
                              console.log("Added to oldPlans:", obj1);  // Debugging addition to oldPlans
                            }
                          });
                        }
                      }
                    }
                  }
                });
              }
            }
          }
        });

        if (obj && Object.keys(obj).length > 0 && ((obj.oldPlan && Object.keys(obj?.oldPlan).length > 0) || (obj.newPlan && Object.keys(obj?.newPlan).length > 0))) {
          console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
          this.plansObj.push(obj);
          obj = {};
        }
      }

      // when package selected but completely different plan with in same package
      if (pack.selected && selected) {
        console.log("Entered package with different plan selection");  // Debugging package with different plan selection
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (!plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    for (let sc of selectedPlans) {
                      console.log("=====")
                      console.log(plans, sc)
                      console.log("----")
                      console.log(c)
                      console.log("=====0")
                      if (plans.planLevel == sc.planLevel && c.planId == sc.id) {
                        obj = {
                          oldPlan: { ...selected },
                          newPlan: { ...sc },
                        };
                        console.log("Created obj for different plan selection:", obj);  // Debugging obj creation
                      }
                    }
                  }
                });

                if (Object.keys(obj).length > 0) {
                  this.unselected = this.unselected.filter((ele) => (
                    ele.planId != obj.oldPlan.planId
                  ));
                  oldPlans = oldPlans.filter(e => e.oldPlan.planId != obj.oldPlan.planId);
                  console.log("Updated unselected and oldPlans:", this.unselected, oldPlans);  // Debugging unselected and oldPlans after filtering
                  console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
                  this.plansObj.push(obj);
                  obj = {};
                }
              }
            }
          }
        });
      }

      //when package in not selected but completely diffrenet package selected
      if (!pack.selected) {
        console.log("Package not selected, checking for selected plans...");  // Debugging package not selected
        for (let sc of selectedPlans) {
          console.log("Checking if package matches:", sc.packageId == pack.id);  // Debugging package match check
          if (sc.packageId == pack.id) {
            obj = {
              newPlan: { ...sc },
              oldPlan: {}
            };
            console.log("Created obj for unselected package:", obj);  // Debugging obj creation for unselected package
          }
        }
        if (Object.keys(obj).length > 0) {
          console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
          this.plansObj.push(obj);
          obj = {};
        }
      }
    }

    //when plan selected and diselected
    if (oldPlans.length > 0) {
      const uniquePlanIds = new Set<number>();
      const filteredOldPlans = oldPlans.filter((plan) => {
        if (!uniquePlanIds.has(plan.oldPlan.planId)) {
          uniquePlanIds.add(plan.oldPlan.planId);
          return true;
        }
        return false;
      });

      if (filteredOldPlans.length > 0) {
        console.log("Pushing filteredOldPlans to plansObj:", filteredOldPlans);  // Debugging push of filtered old plans
        this.plansObj = [...this.plansObj, ...filteredOldPlans];
      }
    }

    //high cost drugs selected and all in selected
    let allinSelected = this.plansObj.some((plan) => { return plan.newPlan.planLevelParent == 6 });
    console.log("All-in selected:", allinSelected);  // Debugging all-in selected flag
    const allIndisallowed = [1, 10, 14, 24];
    if (allinSelected) {
      for (let pack of this.specialpackages) {
        if (pack.selected) {
          Object.keys(pack.groups).forEach((group: any) => {
            for (let plan of pack.groups[group]) {
              for (let plans of plan.plans) {
                if (plans.selected && allIndisallowed.includes(plans.planLevel)) {
                  Object.keys(plans.productAddonss).forEach((addon: any) => {
                    for (let c of plans.productAddonss[addon]) {
                      if (c.selected) {
                        console.log("High cost drug selected:", c.planId);  // Debugging high cost drug selection
                        this.plansObj.push({
                          oldPlan: { ...c },
                          newPlan: {}
                        });
                      }
                    }
                  });
                }
              }
            }
          });
        }
      }
    }

    //phr rules
    let healthAndDentalSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 1 });
    let phrSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 10 });
    console.log("Health and Dental selected:", healthAndDentalSelected);  // Debugging health and dental selection
    console.log("Phr selected:", phrSelected);  // Debugging phr selection

    if (healthAndDentalSelected && isPhr) {
      if (!phrSelected && !phrPlanSelected) {
        console.log("Error: PHR plan not selected with Health/Dental plan");  // Debugging PHR selection error
        Swal.fire({
          title: this.lang?.Error, text: this.lang?.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan
        });
        return;
      }
    }

    const notes = await this.handlePrepareNotes();



    let filteredPlans = this.plansObj.filter(plan =>
      Object.keys(plan.newPlan).length > 0 && Object.keys(plan.oldPlan).length > 0
    );


    console.log(this.dependentTypeForm1)
    let data: any = {}
    let slug = 'remove'

    let effDate = moment(this.dependentTypeForm1.value.effectiveDate).format('DD-MM-YYYY');
    if (this.dependentType == "spouse") {
      data = {
        "spouse": this.selectedDependentDetails,
        "dependent": [],
        "notes": this.handleGenerateNotes(filteredPlans, 'proceed', this.dependentType, slug, ''),
        "approvalStatus": "proceed",
        "coverageScenario": this.coverageChange,
        "isPlanChanges": filteredPlans.length > 0 ? true : false,
        "effectiveDate": effDate,
        "changedCoveragePlans": this.newlySelectedPlans,
        "removalDependents": [],
        "plans": filteredPlans,
        "reason": this.noReason
      }
    } else {
      data = {
        "spouse": {},
        "dependent": [this.selectedDependentDetails],
        "notes": this.handleGenerateNotes(filteredPlans, 'proceed', this.dependentType, slug, ''),
        "approvalStatus": "proceed",
        "coverageScenario": this.coverageChange,
        "isPlanChanges": filteredPlans.length > 0 ? true : false,
        "effectiveDate": effDate,
        "changedCoveragePlans": this.newlySelectedPlans,
        "removalDependents": [],
        "plans": filteredPlans,
        "reason": this.noReason
      }
    }


    console.log(data);




    // using for delete
    let endPoint = `/customer/v2/${this.customerid}/lifeChange/${this.dependentType}/${slug}/false`



    this.http.post(api.url + endPoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        if (this.selectedDependentDetails.relationType == 'spouse') {

          Swal.fire({ title: 'Info', text: 'Spouse deleted successfully. enrollment process is begin in the background.please check after some time.' }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })

        } else {
          Swal.fire({ title: 'Info', text: 'Dependent deleted successfully. enrollment process is begin in the background.please check after some time.' }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })
        }

      }
      else {
        Swal.fire({ title: 'Info', text: 'Something went wrong' }).then((result) => {
          if (result.isConfirmed) {
            $("#addDependent").hide();

            window.location.reload()
          } else {
            window.location.reload()
          }
        })
      }
    }, (error) => {
      Swal.fire({ title: 'Info', text: 'Something went wrong' }).then((result) => {
        if (result.isConfirmed) {
          $("#addDependent").hide();

          window.location.reload()
        } else {
          window.location.reload()
        }
      })
    });




  }

  openCoverage(value: any) {
    this.coverage = value;
    if (this.coverage === 'open') {
      this.spouseCoverage = true;
      this.spouseForm['insurer'].setValidators([Validators.required]);
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].setValidators([Validators.required]);
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
    else {
      this.spouseForm['insurer'].reset();
      this.spouseForm['healthPlan'].reset();
      this.spouseForm['insurer'].clearValidators();
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].clearValidators();
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
  }

  openDependentCoverage(value: any) {

    this.removeSession("plansummarymain")
    this.removeSession("plansskumain");
    this.removeSession("plansummaryopt");
    this.removeSession("plansummary");
    this.removeSession("selectedPlans");
    this.removeSession("totalAmount");
    this.removeSession("totalAmountUI");



    if (this.dependentTypeForm.invalid) {
      this.dependentTypeForm.markAllAsTouched()
      return;
    }

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }


    this.showSpouseInfo = true;
    this.showPlanDetails = true;
    this.dependentCoverage = value;
    console.log(this.dependentCoverage, 'depovver', this.dependentType)
    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
    if (this.dependentCoverage == 'open') {

      this.noReason = ''
      if (this.dependentType == 'spouse') {
        this.childCovered = false;
        this.spouseCovered = true;
        this.handleContinue()

      }
      if (this.dependentType == 'multiple') {
        //check childForm has true
        console.log(this.spouseform.value, this.dependentform.value)

        this.childCovered = false;
        this.spouseCovered = true;
        console.log('this.dependentCoverage', this.dependentCoverage)
        this.handleContinue()

      }
      if (this.dependentType == 'child') {
        this.childCovered = true;
        this.handleContinue()
      }
      if (this.dependentType == 'spouse' || this.dependentType == 'multiple') {
        this.spouseForm['insurer'].setValidators([Validators.required]);
        this.spouseForm['insurer'].updateValueAndValidity();
      }
      else {
        this.dependentForm['carrierName'].setValidators([Validators.required]);
        this.dependentForm['carrierName'].updateValueAndValidity();
      }


    }
    else {
      if (this.normalSpouseRegistration == false) {
        let reason;
        if (this.isCommonLaw) {
          reason = 'The date of marriage is more than 365 days and the spouse has not been covered by any other insurance carrier. The request is currently pending approval from our insurance carrier.'
        } else {
          reason = 'The date of marriage is more than 30 days and the spouse has not been covered by any other insurance carrier. The request is currently pending approval from our insurance carrier.'
        }
        this.noReason = reason
        Swal.fire('Info', reason).then(res => {
          if (res.isConfirmed) {
            this.spouseCovered = false;
            this.handleContinue()
            this.dependentForm['carrierName'].reset();
            this.dependentForm['carrierName'].clearValidators();
            this.dependentForm['carrierName'].updateValueAndValidity();
            this.spouseForm['healthPlan'].reset();
            this.spouseForm['healthPlan'].clearValidators();
            this.spouseForm['healthPlan'].updateValueAndValidity();
          }
        })
      } else {
        this.spouseCovered = false;
        this.handleContinue();
        this.dependentForm['carrierName'].reset();
        this.dependentForm['carrierName'].clearValidators();
        this.dependentForm['carrierName'].updateValueAndValidity();
        this.spouseForm['healthPlan'].reset();
        this.spouseForm['healthPlan'].clearValidators();
        this.spouseForm['healthPlan'].updateValueAndValidity();
      }



    }



    if (value == 'open') {
      Swal.fire({
        title: 'Info',
        text: 'Do you wish to change your coverage if applicable?',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel'
      }).then(res => {
        if (res.isConfirmed) {
          this.isUpgradeOrDowngrade = 'upgrade';
          this.handleUpgradeOrDowngrade('upgrade')
        } else {
          // remains same and make plan changes as false
          this.isUpgradeOrDowngrade = 'downgrade';
          this.handleUpgradeOrDowngrade('downgrade')
        }
      })
    }


    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
  }

  handleUpgradeOrDowngrade(value: any) {

    console.log(this.upgradeorDowngradeplans, value)
    if (value == 'upgrade') {
      const selectedPlans = this.upgradeorDowngradeplans.map(plan => {
        const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        return {
          planName: plan.name,
          addOn: plan.addon,
          action: selectedOption ? selectedOption.value : null,
          isBundle: plan.isBundle
        };
      });

      // Handle the selected plans and actions (Upgrade/Downgrade)
      selectedPlans.forEach((plan) => {
        console.log(plan, "....plan...")
        // we gonna click that element
        let element: any = plan.addOn
        if (plan.isBundle) {


          $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element, "elem677")
          if (element?.planCoverage && element?.planCoverage != '-') {
            console.log("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
            $("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          }
          else {
            console.log($("#plancheck" + element.planlevel.id))
            $("#plancheck" + element.planlevel.id).click()

          }
        }
        console.log(`Upgrading ${plan.planName}`);

      });
    } if (value == 'downgrade') {
      const selectedPlans = this.upgradeorDowngradeplansSelected.map(plan => {
        const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        return {
          planName: plan.name,
          addOn: plan.addon,
          action: selectedOption ? selectedOption.value : null,
          isBundle: plan.isBundle
        };
      });

      // Handle the selected plans and actions (Upgrade/Downgrade)
      selectedPlans.forEach((plan) => {
        console.log(plan, "....plan...")
        // we gonna click that element
        let element: any = plan.addOn
        if (plan.isBundle) {


          $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element, "elem677")
          if (element?.planCoverage && element?.planCoverage != '-') {
            console.log("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
            $("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          }
          else {
            console.log($("#plancheck" + element.planlevel.id))
            $("#plancheck" + element.planlevel.id).click()

          }
        }
        console.log(`Upgrading ${plan.planName}`);

      });
    }
  }

  openChildCoverage(value: any) {
    console.log(value, "valiiii", this.dependentTypeForm)
    this.showPlanDetails = true
    this.showSpouseInfo = true
    this.dependentChildCoverage = value;
    if (this.dependentChildCoverage === 'open') {
      this.childCoverage = true;
      this.dependentForm['carrierName'].setValidators([Validators.required]);
      this.dependentForm['carrierName'].updateValueAndValidity();

    }
  }

  updateDependentForm(i: any, msg: any) {
    console.log("iii", i, "data99", this.childrenInfo)
    let childId = i.id;
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.dependentform.patchValue(normalizeDateFields(i));
    this.childCoverage = i.coveredByAnotherPlan;
    this.specialNeeds = i.specialNeeds;
    this.postSecondaryStudent = i.postSecondaryStudent;
    this.dependentForm['effectiveDate'].clearValidators();
    this.dependentForm['effectiveDate'].updateValueAndValidity();
    if (this.childCoverage === false) {
      this.dependentForm['carrierName'].clearValidators();
      this.dependentForm['carrierName'].updateValueAndValidity();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    if (this.postSecondaryStudent === false) {
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }

  deleteDependentForm(i: any, children: any) {
    let childId = this.childrenInfo[i].id;
    this.dependentType = "dependent"
    console.log("called", this.dependentType)
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.currentDeleteMember = "child";
    this.deleteChildrenDetails_1(children)

  }

  updateDependent() {

    if (this.dependentform.invalid) {
      this.dependentform.markAllAsTouched();
      return;
    }
    else {
      console.log(this.dependentform)

      let depData: any = {
        firstName: this.dependentform.get('firstName')?.value,
        lastName: this.dependentform.get('lastName')?.value,
        gender: this.dependentform.get('gender')?.value,
        dob: toApiDate(this.dependentform.get('dob')?.value),
        age: this.dependentform.get('age')?.value,
        phoneNum: this.dependentform.get('phoneNum')?.value,
        coveredByAnotherPlan: this.dependentform.get('coveredByAnotherPlan')?.value,
        carrierName: this.dependentform.get('carrierName')?.value,
        specialNeeds: this.dependentform.get('specialNeeds')?.value,
        postSecondaryStudent: this.dependentform.get('postSecondaryStudent')?.value,
        effectiveDate: toApiDate(this.dependentform.get('effectiveDate')?.value),
      };



      let depType = depData.relationType == "CHILDREN" ? "dependent" : "spouse"

      if (depType == "dependent") {
        depData['insurer'] = depData.carrierName;
        delete depData['carrierName']
      }
      let childId = this.childrenId;
      let finalData: any = {};
      const endPoint = `/customer/v2/${this.customerid}/lifeChange/${depType}/update/false`

      console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
      console.log('this.spouseform.value.coveredByAnotherPlan', this.spouseform.value.coveredByAnotherPlan)
      let approvalStatus = this.normalSpouseRegistration ? "normal" : this.dependentform.get('coveredByAnotherPlan')?.value ? "proceed" : "pending"


      if (depType == "dependent") {
        finalData = {
          "spouse": {},
          "dependent": [depData],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "coverageScenario": this.coverageChange ?? "STC",
          "isPlanChanges": true,
          "effectiveDate": this.dependentform.get('effectiveDate')?.value,
          "changedCoveragePlans": [],
          "removalDependents": [],
          "plans": [],
          "reason": this.noReason ?? ""
        }
      }
      if (depType == "spouse") {

        finalData = {
          "spouse": depData,
          "dependent": [],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "coverageScenario": this.coverageChange ?? "STC",
          "isPlanChanges": true,
          "effectiveDate": this.dependentform.get('effectiveDate')?.value,
          "changedCoveragePlans": [],
          "removalDependents": [],
          "plans": [],
          "reason": this.noReason ?? ""
        }
      }



      let accessToken = this.getSession('accessToken');
      this.http.post(api.url + endPoint, finalData, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.getCustomerData();
          this.closeDependentmodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }

  openGraduationDate(value: any) {
    this.graduationDate = value.currentTarget.checked;
    this.postSecondaryStudent = value.currentTarget.checked;
    if (this.postSecondaryStudent) {
      this.dependentForm['graduationDate'].setValidators([Validators.required]);
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    else {
      this.dependentForm['graduationDate'].reset();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }

  closeDependentForm() {
    this.spouseform.reset();
    this.functionClearSettings()
    this.dependentTypeForm.reset();
    this.dependentType = ""
    this.dependentform.reset();
    this.graduationDate = true;
    this.dependentUpdate = false;
    this.dependentCoverage = 'close';
    this.removeSession("plansummarymain")
    this.removeSession("plansskumain");
    this.removeSession("plansummaryopt");
    this.removeSession("plansummary");
    this.removeSession("selectedPlans");
    this.removeSession("totalAmount");
    this.removeSession("totalAmountUI");
  }

  closeSpouseForm() {
    console.log("called")
    this.spouseCoverage = '';
    this.coverage = 'open'
    this.dependentUpdate = false;
    this.dependentTypeForm1.reset()
    this.specialpackages = []
  }

  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  tabData() {
    this.selectedTab = 'tab1';
  }

  hicDetails() {
    this.hicList = this.customerData.healthCards_v2.cards;
  }

  viewHealthCard(link: any) {
    this.src = link.link;
    this.healthCard = true;
    if (this.src == '') {
      this.card = true;
    }
  }

  clearpadsignature() {
    this.clearSignature()

  }
  closeHealthCard() {
    this.healthCard = false;
    this.displayStyle = "none";
    this.card = false;
  }

  closeDownloadBooklet() {
    this.hidebooklet = false;
  }

  downloadHic(value: any) {
    console.log("asdadhahhh")
    console.log(value)
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      }
    );
  }

  checkAllCheckBox(value: any) {
    this.hicList.forEach(hic => hic.checked = value.target.checked)
  }

  isAllCheckBoxChecked() {
    return this.hicList.every(hic => hic.checked);
  }

  checkAllBooklets(value: any) {
    this.bookletList.forEach(booklet => booklet.checked = value.target.checked)
  }

  isAllBookletsChecked() {
    return this.bookletList.every(booklet => booklet.checked);
  }

  downloadSelected() {
    this.bookletList1 = this.bookletList.filter((selected: any) => selected.checked).map((selected: any) => selected);
    if (this.bookletList1.length > 0) {
      for (let i = 0; i < this.bookletList1.length; i++) {
        this.http.get(this.bookletList1[i].link, { responseType: "arraybuffer" }).subscribe(
          pdf => {
            const blob = new Blob([pdf], { type: "application/pdf" });
            const fileName = this.bookletList1[i].name + ".pdf";
            saveAs(blob, fileName);
          },
          (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
          }
        );
      }
    }
    else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_booklets_Selected })
    }
  }

downloadForm(): void {
  console.log('downloadForm clicked, bookingInformation:', this.bookingInformation);
  if (!this.bookingInformation || this.bookingInformation.length === 0) {
    return;
  }
  this.bookingInformation.forEach((item, index) => {
    console.log('item', index, 'downloadLink:', item.downloadLink);
      // Replace 'formUrl' with the actual key in your data
      const url = item.downloadLink;

      if (url) {
        // Create a hidden anchor element and trigger download
        const link = document.createElement('a');
        link.href = url;

        // Optional: Set download name
        const fileName = `form-${index + 1}.pdf`; // or derive from item
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }

  downloadAllHpBooklets() {
    this.getHealthBooklets();
    Swal.fire({
      allowOutsideClick: false,
      title: 'Alert',
      text: 'Download all booklets?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Download',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.bookletList.length > 0) {
          for (let i = 0; i < this.bookletList.length; i++) {
            this.http.get(this.bookletList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.bookletList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Booklets_Found })
        }
        this.hicList = this.customerData.healthCards_v2.cards;
        if (this.hicList.length > 0) {
          for (let i = 0; i < this.hicList.length; i++) {
            this.http.get(this.hicList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.hicList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Health_Cards_Found })
        }
      }
      else {
      }
    });
  }

  downloadHpbooklet(value: any) {
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      }
    );
  }

  getRoe(roe: any) {
    setTimeout(() => {
      if (roe.link != "") {
        if (!hasWhiteSpace(roe.link)) {
          this.roe = roe.link;

          this.viewRoe = true;
        }
        else {
          this.viewRoe = false;
        }
      }
    }, 1000);
  }

  closeRoe() {
    this.viewRoe = true;
  }

  downloadRoe(roe: any) {
    console.log('triggered');
    this.getRoe(roe);
    this.http.get(this.roe, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const formattedDate = formatDate(roe.time, 'MMM d, y', 'en-US'); // "Jun 1, 2025"
        const fileName = `Record of Enrollment - ${formattedDate}.pdf`;

        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    this.openRoe.nativeElement.click();
  }

  openPaymentDetails(value: any) {
    this.openUpdatePaymentForm = value;
    if (value == 'close') {
      Object.keys(this.paymentMethodControls).forEach(controlName => {
        if (controlName !== 'paymentmethod') {
          const control = this.paymentMethodControls[controlName];
          control.reset();
        }
      });
      this.bankDetails = false;
      this.resetButton = false;
      this.uploadCheque = false;
      setTimeout(() => {
        this.closePaymenttoPAD.nativeElement.click();
      }, 1000);
    }
  }

  public provincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });
    if (this.addressform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.addressform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.addressForm['postalCode'].markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
      }
      if (this.addressform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
  }

  changeTextToUppercase(event: any) {
    const inputValue = this.addressform.get('postalCode')?.value;
    this.addressform.get('postalCode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    this.postalvalue = event.target.value;
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
      this.addressForm['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  upperCase(event: any) {
    const inputValue = event?.data;
    if (inputValue != null) {
      this.paymentform.get('postalcode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    }
  }

phoneFormat(event: any) {
  this.secondaryphonecheck = false;
  const controlName = event.target.id;
  if (controlName === 'primaryPhone' || controlName === 'secondaryPhone') {
    const inputValue = this.addressform.get(controlName)?.value;
    let digitsOnly = inputValue ? inputValue.replace(/\D/g, '') : '';
    // Always remove leading "1" country code if present
    if (digitsOnly.startsWith('1')) {
      digitsOnly = digitsOnly.substring(1);
    }
    const formatted = this.phoneNoFormat.transform(digitsOnly.substring(0, 10));
    this.addressform.get(controlName)?.setValue(formatted, { emitEvent: true });
    this.addressform.get(controlName)?.markAsTouched();
    this.addressform.get(controlName)?.updateValueAndValidity();
  }
}

  getBankInfo() {
    if (this.paymentMethodForm.invalid) {
      this.paymentMethodForm.markAllAsTouched();
      return
    }
    else {
      let data = this.paymentMethodForm.value;
      let accessToken = this.getSession('accessToken');
      const Endpoint = '/customer/bank/verify';
      this.http.post(api.url + Endpoint, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.bankDetails = true;
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.Bank_Details_verified_successfully })

        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })

          let currentTimeStamp = this.apiCommonService.getTimeStamp();
          Cookies.set('Home_bank_verify_error_400_' + currentTimeStamp, 'Bank verify error: ' + JSON.stringify(response));

          // create object for report log
          let log = { [`Bank Verify 400 ${currentTimeStamp}`]: response }
          let obj = {
            customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
            browser: '',
            systemDetails: {},
            logs: JSON.stringify(log),
            sessionDetails: '{}'
          };
          this.apiCommonService.submitReportLog(obj);
        }
        this.bankInfo = response?.data;
        this.address = this.bankInfo.address;
        this.bankAddress = this.bankInfo.address.split(', ');
        this.resetButton = true;
        this.uploadCheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        let err = error?.error?.error ?? error?.error ?? error
        Cookies.set('Home_bank_verify_error_' + currentTimeStamp, 'Session storage error: ' + JSON.stringify(err));

        // create object for report log
        let log = { [`Bank Verify error ${currentTimeStamp}`]: err }
        let obj = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj);
      });
    }
  }

  openpad() {
    this.openUpdatePaymentForm = 'close';
  }

  closeChangeToPad() {
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.previewbutton = false;
    this.paymentMethodForm.get('files')?.setValue('');
  }

  closepadinfo() {
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.paymentMethodForm.get('files')?.setValue('');
    console.log('PADdetails', this.PADdetails)
    this.voidCheckFileType = this.PADdetails?.voidCheckFileType;
  }

  updateBankInfo() {
    if (this.padform.invalid) {
      this.padform.markAllAsTouched();
      return
    }
    else {
      let data = this.padform.value;
      data['branchCode'] = this.padform.value.transitNumber
      data['accountNumber'] = this.padform.value.accountNo
      data['bankCode'] = this.padform.value.bankcode
      let accessToken = this.getSession('accessToken');

      const Endpoint = '/customer/bank/verify';
      this.http.post(api.url + Endpoint, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.banknameres = response?.data.bank.name + "\n" + response?.data.address.split(",").join("\n");
          this.bankinfo = true;
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })

          let currentTimeStamp = this.apiCommonService.getTimeStamp();
          Cookies.set('Home_bank_verify_error_400_' + currentTimeStamp, 'Bank verify error: ' + JSON.stringify(response));

          // create object for report log
          let log = { [`Bank Verify 400 ${currentTimeStamp}`]: response }
          let obj = {
            customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
            browser: '',
            systemDetails: {},
            logs: JSON.stringify(log),
            sessionDetails: '{}'
          };
          this.apiCommonService.submitReportLog(obj);
        }
        this.bank = response?.data;
        this.address = this.bank.address;
        this.bankAddress = this.bank.address.split(', ');
        this.resetbutton = true;
        this.cheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        let err = error?.error?.error ?? error?.error ?? error;
        Cookies.set('Home_bank_verify_error_' + currentTimeStamp, 'Bank verify error: ' + JSON.stringify(err));

        // create object for report log
        let log = { [`Bank Verify error ${currentTimeStamp}`]: err }
        let obj = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj);
      });
    }
  }

  updateBankDetails(event) {
    this.banknameres = event.target.value;
  }

  closeValisign() {
    clearInterval(this.startTimer);
  }

  getHealthBooklets() {
    let Endpoint = '/customer/v3/' + this.customerid + '/booklets/false/false';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bookletList = response?.data;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  viewinvoices(value: any) {
    this.page = 1
    setTimeout(() => {
      this.invoiceslink = value;
    }, 1000);
  }

  downloadinvoices(invoice: any) {
    console.log(invoice);
    this.http.get(invoice.file ?? invoice.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = (invoice?.customer?.firstName ?? this.customerData.firstName ?? "Invoice") +
          (invoice?.customer?.lastName ?? this.customerData.lastName ?? "") + "_" +
          (invoice.month ?? moment.parseZone(invoice.dueDate).format('MMM-YYYY')) + ".pdf";
        console.log(fileName)
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }

  getInvoices() {
    let fusebillId = this.customerData.id;
    let Endpoint = '/customer/' + fusebillId + '/invoices/list';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        this.customerInvoices = response?.data

        this.customerFinalInvoices = response?.data;
        this.customerFinalInvoicesIGBMS = response?.data;

        this.customerFinalInvoices.reverse()
        this.customerFinalInvoicesIGBMS.reverse()

        this.allCustomerFinalInvoices = this.customerFinalInvoices;
        this.allCustomerFinalInvoicesIGBMS = this.customerFinalInvoicesIGBMS;

      }
      else {
      }
    }, (error) => {
    });
  }
customerAdhocInvoices: any[] = [];

getAdhocInvoices() {
  let customerId = this.customerData.id;
  let Endpoint = '/customer/' + customerId + '/adhoc-invoices/list';
  this.http.get(api.url + Endpoint, {
    headers: {
      Authorization: 'Bearer ' + this.accessToken,
      'Content-Type': 'application/json',
    }
  }).subscribe((response: any) => {
    console.log('Adhoc invoices response:', response);
    if (response.status == 200) {
      this.customerAdhocInvoices = response?.data ?? [];
    }
  });
}

getAdhocPlanName(invoice: any): string {
  try {
    const items = JSON.parse(invoice.lineItems);
    const fullName = items?.[0]?.planName ?? 'Adhoc Charge';
    return fullName.split(' - ')[0];
  } catch {
    return 'Adhoc Charge';
  }
}
  getCreditcard() {
    let Endpoint = '/customer/' + this.customerid + '/creditCards';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.setSession('defaultCreditCard', JSON.stringify([]))
        this.setSession('existingCreditCards', JSON.stringify({}))
        if (response?.data[0]) {
          const data = response.data;
          let defaultCard = data?.filter((card) => card.defaultCard == true)?.[0] ?? {}
          let nonDefaultCards = data?.filter((card) => card.defaultCard != true)
          this.setSession('defaultCreditCard', JSON.stringify(defaultCard || []))
          this.setSession('existingCreditCards', JSON.stringify(nonDefaultCards || {}))
          this.ccDetails = response?.data[0];

          // get color for expiry date
          this.expire = this.ccDetails?.expirationMonth + '/' + this.ccDetails?.expirationYear;
          this.updateExpiryStatus(this.expire)

          // updation of expire - required for authorize
          const year = this.ccDetails?.expirationYear;
          const formattedYear = year?.length === 2 ? '20' + year : year;
          this.expire = this.ccDetails?.expirationMonth + '/' + formattedYear;

          this.publicapikey = response?.data[0].publicKey;
          this.creditCardNo = response?.data[0].maskedCardNumber;
          this.fullName = this.customerData.firstName + ' ' + this.customerData.lastName;




          //   response?.data[0].firstName =  this.customerData.firstName
          // }else{
          //   response?.data[0].firstName =  response?.data[0].firstName


          this.expire = response?.data[0].expirationMonth + '/' + response?.data[0].expirationYear;
        }
      }
      else {
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  viewBooklet(value: any) {
    this.page = 1
    setTimeout(() => {
      this.bookletLink = value;
    }, 1000);
    this.hidebooklet = true;
  }

  closeBooklet() {
    this.hidebooklet = false;
    this.displayBooklet = "none";
  }

  resetPaymentForm() {
    this.paymentMethodControls['bankCode'].reset();
    this.paymentMethodControls['branchCode'].reset();
    this.paymentMethodControls['accountNumber'].reset();
    this.paymentMethodControls['files'].reset();
    this.bankDetails = false;
    this.uploadCheque = false;
    this.resetButton = false;
  }

  resetPadForm() {
    this.bankinfo = false;
    this.cheque = false;
    this.resetbutton = false;
    this.padForm['bankcode'].reset();
    this.padForm['transitNumber'].reset();
    this.padForm['accountNo'].reset();
    this.padForm['file'].reset();
    this.existVoid = false;
  }

  onFileSelect(event: any) {
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);

    this.fileExtension = "." + event.target.files[0].name.split(".").pop();

    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';
    } else {
      this.voidCheckFileType = 'image/jpeg';
    }

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      console.log(api)
      console.log(api.fileSize)
      console.log(this.paymentVoidCheque)
      let fileSize = this.getSession("fileSize");
      if (this.paymentVoidCheque.size <= 1000 * (Number(fileSize) ?? 5) * 1024) {
        error = false;
      } else {
        error = true;
        console.log('file size', this.paymentVoidCheque.size)
        message = `File size is too large, maximum file size is ${fileSize}MB`;
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.previewbutton = true;
      };
    }
  }

  fileSelect(event: any) {
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();

    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';
    } else {
      this.voidCheckFileType = 'image/jpeg';
    }
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    let fileSize = this.getSession("fileSize");
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      if (this.paymentVoidCheque.size <= 1000 * (Number(fileSize) ?? 5) * 1024) {
        error = false;
      } else {
        error = true;
        message = 'File size is too large, maximum file size is 5MB';
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "30%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {

        this.imagedisplay = reader.result;
        this.updatepreviewbutton = true;
        if (this.padform.get('file')?.value != '') {
          this.review = false;
        }
      };
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      if (event.target?.result) {
        result.next(btoa(event.target.result.toString()));
      }
    }
    return result;
  }

  generateCorporatePAD() {

    let inputData1 = {
      bankCode: this.paymentMethodForm.get("bankCode")?.value,
      branchCode: this.paymentMethodForm.get("branchCode")?.value,
      accountNumber: this.paymentMethodForm.get("accountNumber")?.value,
    };
    let bankAddress = this.address;
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bankInfo.bank.name,
      address: this.bankInfo.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    formData.append(
      "files",
      this.paymentVoidCheque,
      "void_cheque_" + Date.now() + fileExtension.toLowerCase()
    );

    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/customer/' + this.customerid + '/generatePAD';
    this.http.post(api.url + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        let act: any = this.buildActivityLogObject({}, false);
        this.commonSerivce.padPaymentActivityLogStep1(act, (api.url + Endpoint), this.formDataToJSON(formData), response, true, api.commonLoginApiUrl, api.signIn);
        this.pad = response?.data.url;
        this.filename = response?.data.filename;
        this.padfilename = response?.data.padfilename;
        this.ext = response?.data.ext;
        this.mimetype = response?.data.mimetype;
      }
      else {
        let act: any = this.buildActivityLogObject({}, false);
        this.commonSerivce.padPaymentActivityLogStep1(act, (api.url + Endpoint), this.formDataToJSON(formData), response, false, api.commonLoginApiUrl, api.signIn);
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        Cookies.set('Home_generate_pad_error_' + currentTimeStamp, 'Generate Pad Error: ' + JSON.stringify(response));

        // create object for report log
        let log = { [`Generate PAD 400 ${currentTimeStamp}`]: response }
        let obj = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...formData }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj);
      }
    }, (error) => {
      let act: any = this.buildActivityLogObject({}, false);
      this.commonSerivce.padPaymentActivityLogStep1(act, (api.url + Endpoint), this.formDataToJSON(formData), error, false, api.commonLoginApiUrl, api.signIn);
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

      let currentTimeStamp = this.apiCommonService.getTimeStamp();
      Cookies.set('Home_generate_pad_error_' + currentTimeStamp, 'Generate Pad Error: ' + JSON.stringify(error?.error?.error ?? error?.error ?? error));

      // create object for report log
      let obj = {
        customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...formData }),
        browser: '',
        systemDetails: {},
        logs: `Generate PAD error ${currentTimeStamp}:` + JSON.stringify(error?.error?.error ?? error?.error ?? error),
        sessionDetails: '{}'
      };
      this.apiCommonService.submitReportLog(obj);
    });
  }

  updateCorporatePAD() {

    let inputData1 = {
      bankCode: this.padform.get("bankcode")?.value,
      branchCode: this.padform.get("transitNumber")?.value,
      accountNumber: this.padform.get("accountNo")?.value,
      amount: this.PADdetails.nextBillingPrice,
      customerId: this.customerid
    };


    let bankAddress;
    if (this.address == null) {
      bankAddress = this.bankinformation;
    }
    else {
      bankAddress = this.address;
    }
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bank.bank.name,
      address: this.bank.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    if (!this.paymentVoidCheque) {
      this.paymentVoidCheque = this.voidCheckPdf;
    }
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    formData.append(

      "files",

      this.paymentVoidCheque,

      "void_cheque_" + Date.now() + fileExtension.toLowerCase()

    );
    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/customer/' + this.customerid + '/generatePAD';
    this.http.post(api.url + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        let act: any = this.buildActivityLogObject({}, false);
        this.commonSerivce.padPaymentActivityLogStep1(act, (api.url + Endpoint), this.formDataToJSON(formData), response, true, api.commonLoginApiUrl, api.signIn);

        this.pad = response?.data.url;
        this.filename = response?.data.filename;
        this.padfilename = response?.data.padfilename;
        this.ext = response?.data.ext;
        this.mimetype = response?.data.mimetype;
      }
      else {
        let act: any = this.buildActivityLogObject({}, false);
        this.commonSerivce.padPaymentActivityLogStep1(act, (api.url + Endpoint), this.formDataToJSON(formData), response, false, api.commonLoginApiUrl, api.signIn);
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        Cookies.set('Home_generate_pad_error_' + currentTimeStamp, 'Generate Pad Error: ' + JSON.stringify(response));

        // create object for report log
        let log = { [`Generate PAD 400 ${currentTimeStamp}`]: response }
        let obj = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...formData }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj);
      }
    }, (error) => {
      let act: any = this.buildActivityLogObject({}, false);
      this.commonSerivce.padPaymentActivityLogStep1(act, (api.url + Endpoint), this.formDataToJSON(formData), error, false, api.commonLoginApiUrl, api.signIn);
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

      let currentTimeStamp = this.apiCommonService.getTimeStamp();
      Cookies.set('Home_generate_pad_error_' + currentTimeStamp, 'Generate Pad Error: ' + JSON.stringify(error?.error?.error ?? error?.error ?? error));

      // create object for report log
      let obj = {
        customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...formData }),
        browser: '',
        systemDetails: {},
        logs: `Generate PAD error ${currentTimeStamp}:` + JSON.stringify(error?.error?.error ?? error?.error ?? error),
        sessionDetails: '{}'
      };
      this.apiCommonService.submitReportLog(obj);
    });
  }

  closeAgreement() {

  }

drawComplete() {
  this.showconfirm = false
  this.showupdatesignatue = false;
  this.signaturePadIsEmpty = false;

  console.log('showupdatesignatue', this.showupdatesignatue)
}

drawStart() {
  console.log("draw");
  this.showupdatesignatue = false;
  this.signaturePadIsEmpty = false;

  console.log('showupdatesignatue', this.showupdatesignatue)
}
  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.isDrawing = false;
  }

  onMouseDown(e: any) {
    this.isDrawing = true;
    console.log('signatureOrCanvas', this.signatureOrCanvas, this.signatureOrCanvas == 'canvas')
    if (this.signatureOrCanvas == 'canvas') {
      const coords = this.relativeCoords(e);
      this.context.moveTo(coords.x, coords.y);
    } else {
      this.showupdatesignatue = false;
    }

    console.log('showupdatesignatue', this.showupdatesignatue)
  }

  onMouseMove(e: any) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.signaturecheckvalue1cc = true;
      this.context.stroke();
      this.showupdatesignatue = false;
    }
  }


  clearCreditCardSignature() {
    this.context.clearRect(
      0,
      0,
      this.sigPadElement.width,
      this.sigPadElement.height
    );
    this.context.beginPath();
    this.signaturecheckvalue1cc = false;
    this.removeSession("signature");
    this.signaturemessagecc = true;
    this.signaturecheckcc = true;
  }

  private relativeCoords(event: any) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }
clearSignature() {
  console.log('signaturePad', this.signaturePad)
  if (this.signatureOrCanvas == 'canvas') {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
    this.showupdatesignatue = true;
  } else {
    this.showupdatesignatue = true;
    this.signaturePad.clear();
  }
  this.signaturePadIsEmpty = true;
}


  savePad() {
  if (this.signatureOrCanvas != 'canvas' && this.signaturePad?.isEmpty()) {
    Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: 'Please provide a signature before confirming.' });
    return;
  }

// Close current modal, open signedPad — only reached if validation passed
const currentModalEl = document.getElementById('signaturepad');
const nextModalEl = document.getElementById('signedPad');

if ((window as any).bootstrap) {
  (window as any).bootstrap.Modal.getInstance(currentModalEl)?.hide();
  new (window as any).bootstrap.Modal(nextModalEl).show();
} else {
  ($(currentModalEl as any) as any)?.modal('hide');
  ($(nextModalEl as any) as any)?.modal('show');
}
    let base64Data: any;
    if (this.signatureOrCanvas == 'canvas') {
      base64Data = this.sigPadElement.toDataURL();
    } else {
      let signatureNeeded = this.signaturePad.isEmpty();
      if (signatureNeeded == false) {
        base64Data = this.signaturePad.toDataURL();
      }
    }
    console.log('pad agreement signature', base64Data);
    this.signatureImg = base64Data;
    let Endpoint = '/customer/' + this.customerid + '/updatePAD';
    let data = {
      url: this.pad,
      signature: this.signatureImg,
      session: this.encBank,
      filename: this.filename,
      padfilename: this.padfilename,
      ext: this.ext,
      mimetype: this.mimetype,
      adminName: 'sai',
    }
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        let act: any = this.buildActivityLogObject({}, false);
        this.commonSerivce.padPaymentActivityLogStep2(act, (api.url + Endpoint), data, response, true, api.commonLoginApiUrl, api.signIn);
        this.signedPad = response?.data.url;
      }
      else {
        let act: any = this.buildActivityLogObject({}, false);
        this.commonSerivce.padPaymentActivityLogStep2(act, (api.url + Endpoint), data, response, false, api.commonLoginApiUrl, api.signIn);
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        Cookies.set('Home_update_pad_error_' + currentTimeStamp, 'Bank verify error: ' + JSON.stringify(response));

        // create object for report log
        let log = { [`Update PAD 400 ${currentTimeStamp}`]: response }
        let obj = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj);
      }
    }, (error) => {
      let act: any = this.buildActivityLogObject({}, false);
      this.commonSerivce.padPaymentActivityLogStep2(act, (api.url + Endpoint), data, error, false, api.commonLoginApiUrl, api.signIn);
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

      let currentTimeStamp = this.apiCommonService.getTimeStamp();
      let err = error?.error?.error ?? error?.error ?? error;
      Cookies.set('Home_update_pad_error_' + currentTimeStamp, 'Update Pad error: ' + JSON.stringify(err));

      // create object for report log
      let log = { [`Update Pad error ${currentTimeStamp}`]: error }
      let obj = {
        customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...data }),
        browser: '',
        systemDetails: {},
        logs: `Update Pad error ${currentTimeStamp}:` + JSON.stringify(error?.error?.error ?? error?.error ?? error),
        sessionDetails: '{}'
      };
      this.apiCommonService.submitReportLog(obj);
    });
  }

  closeSignaturePad() {
    this.closePaymentmodal.nativeElement.click();
  }


  addSpouse() {
    this.spouseUpdate = false;
    if (JSON.stringify(this.spouseInfo) === '{}') {
      this.spouseStatus = true;
      this.spouseForm['martialStatus'].clearValidators();
      this.spouseForm['martialStatus'].updateValueAndValidity();
      this.spouseForm['effectiveDate'].clearValidators();
      this.spouseForm['effectiveDate'].updateValueAndValidity();
    }
    else {
      this.spouseStatus = false;
    }
    this.spouseform.reset();
  }

  addSpouseData() {

    if (this.spouseStatus) {

      if (this.spouseform.invalid) {
        this.spouseform.markAllAsTouched();
        return;
      }
      else {
        const endPoint = '/customer/' + this.customerid + '/lifeChanges/spouse/add/true';
        this.spouseData = this.spouseform.value;
        if (this.spouseform.value.coveredByAnotherPlan != true) {
          this.spouseData["coverage"] = ""
          this.spouseData["carrierName"] = ""
        }
        else {
          this.spouseData["coverage"] = this.spouseform.value.healthPlan
          this.spouseData["carrierName"] = this.spouseform.value.insurer
        }
        if (this.spouseform.value.email == null) {
          this.spouseData["email"] = ""
        }
        this.spouseData["dob"] = toLegacyUsDate(this.spouseform.value.dob)
        this.spouseData["relationType"] = "SPOUSE"

        let data: any;
        data = {
          'spouse': this.spouseData,
          'dependent': []
        }

        this.http.post(api.url + endPoint, data, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
      }
    }
    else {
      if (this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {

        this.spouseform.markAllAsTouched();
        return;
      }
      else {

        console.log(this.spouseform.value, 'asdsad')
        let spouseData = this.childrenInfo;
        let spouseData_: any = {}

        let data = this.spouseform.value;

        for (let spouse of spouseData) {
          if (spouse["relationType"] == "spouse") {
            spouseData_["firstName"] = spouse.firstName;
            spouseData_["lastName"] = spouse.lastName;
            spouseData_["dob"] = spouse.dob;
            spouseData_["gender"] = spouse.gender;
            spouseData_["email"] = spouse.email || "";
            spouseData_["coverage"] = spouse.healthPlan;
            spouseData_["carrierName"] = spouse.insurer;
            spouseData_["healthPlan"] = spouse.healthPlan;
            spouseData_["insurer"] = spouse.insurer;
            spouseData_["id"] = spouse.id
          }

        }

        console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
        console.log('this.spouseform.value.coveredByAnotherPlan', this.spouseform.value.coveredByAnotherPlan)
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"



        let finalData: any = {
          "spouse": spouseData_,
          "dependent": [],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
          "effectiveDate": this.spouseForm['effectiveDate'].value,
          "changedCoveragePlans": this.newlySelectedPlans,
          "removalDependents": [],
        }


        if (this.spouseform.value.coveredByAnotherPlan === true) {
          data["coveredByAnotherPlan"] = true
        }
        else {
          data["coveredByAnotherPlan"] = false
        }

        data = {
          'spouse': data,
          'dependent': []
        }
        const endPoint = `/customer/'+this.customerid+'/lifeChanges/${this.dependentType}/remove/false`;






        for (const key in spouseData) {
          if (spouseData[key] === null) {
            spouseData[key] = "";
          }
        }

        // data["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')
        this.http.post(api.url + endPoint, finalData, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            this.getCustomerData();
            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
      }
    }


  }

  addDependent() {
    this.dependentform.reset();
    this.dependentUpdate = false;
    this.postSecondaryStudent = false;
    this.dependentStatus = true;
    this.dependentForm['graduationDate'].clearValidators();
    this.dependentForm['graduationDate'].updateValueAndValidity();
    this.dependentData = [];
  }

  addAnotherDependent() {
    if (this.dependentform.valid) {
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }
      this.dependentData.push(this.dependentform.value);
      this.dependentform.reset();
    }
    else {
      this.dependentform.markAllAsTouched();
    }

  }

  addDependentData() {
    if (this.dependentform.valid) {
      let data: any;
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }

      this.dependentData.push(this.dependentform.value);
      if (this.dependentData['graduationDate']) {
        this.dependentData['graduationDate'] = toLegacyUsDate(this.dependentform.value.graduationDate)

      }
      else {
        this.dependentData['graduationDate'] = ""

      }
      this.dependentData['dob'] = toLegacyUsDate(this.dependentform.value.dob)
      data = {
        'spouse': {},
        'dependent': this.dependentData
      }
      const endPoint = '/customer/' + this.customerid + '/lifeChanges/dependent/add/true';
      this.http.post(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
      this.closeDependentmodal.nativeElement.click();
    }
    else {
      this.dependentform.markAllAsTouched();
    }
  }

  reAuthorize() {
    const paymentDetails = this.customerData?.latestPaymentDetails;
    const payload = {
      customerProfileId: paymentDetails?.customerProfileId,
      paymentProfileId: paymentDetails?.paymentProfileId,
      amount: paymentDetails?.amount
    }
    console.log(payload);
    fetch(`${api.authorizeApiUrl}/api/authorize-net/authorize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const reason = await res.text();
          console.error('Payment authorization failed:', reason);

          // Call backend to update status as failed
          this.authorizeNetService.updatePaymentStatus({
            id: paymentDetails?.id,
            status: 'Failed',
          }).subscribe();

          return;
        }

        const json = await res.json();

        // Update status as Authorized
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Authorized',
          authTransId: json.transactionId,
        }).subscribe();

        console.log('Payment authorized:', json);
      })
      .catch((err) => {
        console.error('Error during authorization:', err);

        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Failed',
        }).subscribe();
      });

  }


  retryPayment() {
    const paymentDetails = this.customerData?.latestPaymentDetails;
    const today = new Date();
    const payload = {
      customerProfileId: paymentDetails?.customerProfileId,
      paymentProfileId: paymentDetails?.paymentProfileId,
      amount: paymentDetails?.amount
    }
    console.log(payload);
    fetch(`${api.authorizeApiUrl}/api/authorize-net/charge-now`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const reason = await res.text();
          console.error('Payment failed:', reason);

          // Call backend to update status as failed
          this.authorizeNetService.updatePaymentStatus({
            id: paymentDetails?.id,
            status: 'Failed',
            retryCount: (paymentDetails.retryCount ?? 0) + 1,
            lastRetryAttempt: today.toISOString(),
          }).subscribe();

          return;
        }

        const json = await res.json();

        // Update status as Authorized
        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Captured',
          captureTransId: json.transactionId,
        }).subscribe();

        console.log('Payment Captured:', json);
      })
      .catch((err) => {
        console.error('Error during authorization:', err);

        this.authorizeNetService.updatePaymentStatus({
          id: paymentDetails?.id,
          status: 'Failed',
          retryCount: (paymentDetails.retryCount ?? 0) + 1,
          lastRetryAttempt: today.toISOString(),
        }).subscribe();
      });

  }

  getMonth(event: any) {
    this.expireMonth = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  getYear(event: any) {
    this.expireYear = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  validateExpire(year: any, month: any) {
    let date = 31
    if (month == 4 || month == 6 || month == 9 || month == 11) {
      date = 30
    }
    else if (month == 2) {
      if ((year % 4 == 0 && year % 100 !== 0) || (year % 400 == 0)) {
        date = 29;
      }
      else {
        date = 28;
      }
    }
    if (year != null && month != null) {
      const expiry = new Date(parseInt("20" + year), month - 1, date);
      const current = new Date();
      if (expiry.getTime() < current.getTime()) {
        this.invalidExpiration = true;
      }
      else {
        this.invalidExpiration = false;
      }
    }
  }

  closePaymentInfo() {
    this.paymentform.reset();
    this.paymentform.get('expireMonth')?.setValue('');
    this.paymentform.get('expireYear')?.setValue('');
  }

  closeCcInfo() {
    this.ccform.reset();
    this.ccform.get('expireMonth')?.setValue('');
    this.ccform.get('expireYear')?.setValue('');
  }


  changeToCC() {
    this.getCreditcard();
  }


  getGroups(data): any[] {
    return Array.isArray(data?.value) ? data.value : Object.values(data?.value ?? {});
  }

  saveCcPayment(value: any, value1: any) {
    if (this.paymentform.invalid) {
      this.paymentform.markAllAsTouched();
      return;
    }
    else {
      var accessToken = this.getSession('accessToken');
      var headers = {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      };

      setTimeout(() => {
        console.log('this.migratingFromStaxbill', this.migratingFromStaxbill)
        if (this.migratingFromStaxbill) {
          // expire staxbill plans

          // create profile in authorize net
          this.AuthorizeProfileCreation2(
            {},
            true,
            this.paymentform,
            this.enrollmentdate,
            'AuthorizeNet',
            this.customerData.primaryPhone ?? '',
            this.customerData.email,
            '/home',
            true,
            true,
            this.customerData.authorizenetCustomerId
          )
        } else {

          let act = this.buildActivityLogObject({}, false);
          this.commonSerivce.ccPaymentActivityLogStep1(act, {}, this.customerData?.id, api.commonLoginApiUrl, api.signIn)

          new Promise(resolve => setTimeout(resolve, 1000))
            .then(() => {
              act = this.buildActivityLogObject({}, false);
              this.commonSerivce.ccPaymentActivityLogStep2(act, this.customerData.authorizenetCustomerId, true, {}, true, api.commonLoginApiUrl, api.signIn)

              // create profile in authorize net
              this.UpdateAuthorizeProfileCreation(
                {},
                true,
                this.paymentform,
                this.enrollmentdate,
                'AuthorizeNet',
                this.customerData.primaryPhone ?? '',
                this.customerData.email,
                '/home',
                this.customerData.authorizenetCustomerId
              )
            })

        }
      }, 100)
    }
  }

  updateCcInfo(value: any, value1: any) {
    if (this.ccform.invalid) {
      this.ccform.markAllAsTouched();
      return;
    }
    else {
      let activity: any = {};
      activity.action = 'Payment method update triggered to Credit Card - 1/7';
      activity.requestBody = this.paymentForm;
      activity.requestBody = {};
      activity.status = 'SUCCESS';
      activity.responseSummary = 'Payment method update triggered successfully';
      let act = this.buildActivityLogObject(activity, false);
      this.commonSerivce.ccPaymentActivityLogStep1(act, this.ccform?.value, this.customerData.id, api.commonLoginApiUrl, api.signIn)

      console.log(this.ccform)
      console.log("called998888")
      const cardNumber = this.ccform.get('CardNumber')?.value;
      const expirationMonth = this.ccform.get('ExpirationMonth')?.value;
      const expirationYear = this.ccform.get('ExpirationYear')?.value;
      console.log('expirationYear', expirationYear)

      let newCardDetails = {
        expiry: expirationMonth + '/' + expirationYear,
        endingNumber: "XXXX" + cardNumber.slice(-4) // format for authorize net
      }


      localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))


      console.log(this.ccform)

      setTimeout(() => {
        console.log('this.migratingFromStaxbill', this.migratingFromStaxbill)

        if (this.migratingFromStaxbill) {
          // expire staxbill plans

          // create profile in authorize net
          this.AuthorizeProfileCreation2(
            {},
            true,
            this.ccform,
            this.enrollmentdate,
            'AuthorizeNet',
            this.customerData.primaryPhone ?? '',
            this.customerData.email,
            '/home',
            true,
            true,
            this.customerData.authorizenetCustomerId
          )
        } else {
          act = this.buildActivityLogObject({}, false);
          this.commonSerivce.ccPaymentActivityLogStep2(act, this.customerData.authorizenetCustomerId, true, {}, true, api.commonLoginApiUrl, api.signIn)

          // create profile in authorize net
          this.UpdateAuthorizeProfileCreation(
            {},
            true,
            this.ccform,
            this.enrollmentdate,
            'AuthorizeNet',
            this.customerData.primaryPhone ?? '',
            this.customerData.email,
            '/home',
            this.customerData.authorizenetCustomerId
          )
        }
      }, 100)
      if(this.currClient){
        this.router.navigate([`${this.currClient}/home`]);
      }else{
        this.router.navigate(['home']);
      }
    }
  }

  padUpdate() {
    this.padform.patchValue({});
    this.padform.get('branchCode')?.setValue('')
    this.padform.get('accountNo')?.setValue('')
    this.padform.get('bankcode')?.setValue('')
    this.padform.get('bankdetails')?.setValue('')
    this.banknameres = '';
    this.bankinfo = true;
    this.resetbutton = true;
    this.resetPadForm();
  }

  checkFirstCharacter(event: any, form: any) {
    if (event.target.value.startsWith(' ')) {
      event.target.value = event.target.value.trimStart();
    }
  }


  public formatCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      inputVal = inputVal.match(/.{1,4}/g).join(' ');


    }
    this.ccform.get('CardNumber')?.setValue(inputVal);
    this.paymentform.get('CardNumber')?.setValue(inputVal);

  }
  public formatAmericaCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {

      inputVal = inputVal.replace(/(\d{4})(\d{1,6})?(\d{1,5})?/, function (match, p1, p2, p3) {
        return p1 + (p2 ? ' ' + p2 : '') + (p3 ? ' ' + p3 : '');
      });
    }
    this.ccform.get('CardNumber')?.setValue(inputVal);
    this.paymentform.get('CardNumber')?.setValue(inputVal);
  }
  public isValidAmexCard(cardNumber) {
    // Remove any non-digit characters
    const cleanedCardNumber = cardNumber.replace(/\D/g, '');

    // Check if the card number has 15 digits and starts with 34 or 37
    const isAmex = /^3[47]\d{13}$/.test(cleanedCardNumber);

    return isAmex;
  }
  public isValidAmexCardNumber(val) {
    // Define the regex pattern for formatted Amex card number
    const amexPattern = /^3[47][0-9]{2} [0-9]{6} [0-9]{5}$/;
    console.log(amexPattern)
    return amexPattern.test(val.replaceAll(' ', ''));


  }
  public creditcardlblurmethod(event) {
    this.validateCreditCardNumber(event)


    let val = event.target.value;


    console.log(val.slice(0, 2))


    if (val.slice(0, 2) == 34 || val.slice(0, 2) == 37) {
      this.creditcardvalidationAmerica(val)
      this.formatAmericaCreditCardNumber(event)
    }
    else {
      this.creditcardvalidation(val)
      this.formatCreditCardNumber(event)


    }

    val = val.replaceAll(' ', '')
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2
    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }
      // Add the units element to the checksum total
      checksum = checksum + calc;
      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    if (checksum % 10 == 0) {
      this.invalidcreditcard = false;
    } else {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length < 13) {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length == 0) {
      this.invalidcreditcard = false;
    }
  }
  validateCreditCardNumber(val) {
    const cardImage = document.getElementById('card-image');

    console.log(val.target.value)
    const visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    const mastPattern = /^(?:5[1-5][0-9]{14})$/;
    const amexPattern = /^(?:3[47][0-9]{13})$/;
    const discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

    const ccNum: string = val.target.value.replaceAll(' ', '')

    const isVisa = visaPattern.test(ccNum) === true;
    const isMast = mastPattern.test(ccNum) === true;
    const isAmex = amexPattern.test(ccNum) === true;
    const isDisc = discPattern.test(ccNum) === true;

    if (isVisa || isMast || isAmex || isDisc) {
      // at least one regex matches, so the card number is valid.
      if (isVisa) {
        this.cardType = 'Visa card'
        // Visa-specific logic goes here
      }
      else if (isMast) {
        this.cardType = 'Master card'
        // Mastercard-specific logic goes here
      }
      else if (isAmex) {
        this.cardType = 'Amex card';
      }
      else if (isDisc) {
        this.cardType = 'Discover card'
        // Discover-specific logic goes here
      }
    }
    else {
      this.cardType = '';
    }
  }

  creditcardvalidation(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{19,19}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true

      console.log("test")

    } else {
      this.invalidcreditcarddetails = false

    }
  }
  creditcardvalidationAmerica(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{17,17}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true
    } else {
      this.invalidcreditcarddetails = false

    }
  }



  changepad() {
    this.changetopad = true;
    setTimeout(() => {
      this.voidCheque1 = this.imagedisplay;
    }, 1000);
  }

  updatePadpreview() {
    this.changetopad = false;
    setTimeout(() => {
      this.voidCheque2 = this.imagedisplay;
      this.voidCheckImage = this.imagedisplay;
    }, 1000);
  }

  uploadNewVoid() {
    this.bankinfo = true;
    this.cheque = true;
    this.resetbutton = true;
    this.existVoid = false;
    if (this.padform.get('file')?.value == null) {
      this.review = false;
    }
  }

  existingVoidCheque() {
    setTimeout(() => {
      if (this.voidCheckFileType == 'application/pdf') {
        this.voidCheque2 = this.voidCheckImage;
      }
    }, 1000);
  }

  viewPadAgreement() {
    this.padView = this.padAgreement
  }

  downloadPAD(data) {
    this.http.get(data, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "PAD"
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
  }

  padformValid() {
    if (this.padform.invalid) {
      this.resetbutton = false;
      this.bankinfo = false;
      this.cheque = false;
      return
    }
  }

  paymentMethodFormValid() {
    if (this.paymentMethodForm.invalid) {
      this.resetButton = false;
      this.bankDetails = false;
      this.uploadCheque = false;
      return
    }
  }

  ccUpdate() {

    if (this.ccDetails?.firstName == "Rakesh") {
      this.ccform.get('FirstName')?.setValue(this.customerData.firstName);
    }
    else {
      this.ccform.get('FirstName')?.setValue(this.ccDetails?.firstName ?? this.customerData?.firstName);
    }
    if (this.ccDetails?.lastName == "Test") {
      this.ccform.get('LastName')?.setValue(this.customerData?.lastName);
    }
    else {
      this.ccform.get('LastName')?.setValue(this.ccDetails?.lastName ?? this.customerData?.lastName);
    }

    let oldCardDetails = {
      expiry: this.expire,
      endingNumber: 'XXXX' + (this.creditCardNo)?.toString()?.slice(-4)
    }
    // store the existing card details in the local storage
    localStorage.setItem("oldCardDetails", JSON.stringify(oldCardDetails))

  }

  changeToPAD() {
    setTimeout(() => {
      if (this.migratingFromStaxbill) {
        // expire staxbill plans

        // create profile in authorize net
        this.AuthorizeProfileCreationForPAD(
          {},
          true,
          this.ccform,
          this.enrollmentdate,
          'AuthorizeNet',
          this.customerData.primaryPhone ?? '',
          this.customerData.email,
          '/home',
          true
        )
      } else {
        // create profile in authorize net
        this.AuthorizeProfileCreationForPAD(
          {},
          false,
          this.ccform,
          this.enrollmentdate,
          'AuthorizeNet',
          this.customerData.primaryPhone ?? '',
          this.customerData.email,
          '/home',
        )
      }
    }, 100)

    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  resolved(captchaResponse: any) {
    this.recaptchaResponse = captchaResponse;
  }

  dependentnextcard() {
    this.currentIndex = (this.currentIndex + 1) % this.childrenInfo.length;
  }

  dependentpreviouscard() {
    this.currentIndex = (this.currentIndex - 1 + this.childrenInfo.length) % this.childrenInfo.length;
  }

  getindex(i: any) {
  }

  buildLifeGroupedPlans() {
    this.lifeGroupedPlans = {
      LIFE: [],
      AUPE: []
    };

    this.additionalDetails?.forEach(detail => {
      const name = detail?.name?.toLowerCase() || '';

      if (name.includes('aupe')) {
        this.lifeGroupedPlans.AUPE.push(detail);
      }
      else if (
        name.includes('life insurance') ||
        name.includes('critical illness')
      ) {
        this.lifeGroupedPlans.LIFE.push(detail);
      }
    });

    console.log('Life group:', this.lifeGroupedPlans.LIFE);
    console.log('AUPE group:', this.lifeGroupedPlans.AUPE);

    if (this.lifeGroupedPlans?.LIFE?.length > 0) {
      this.groupedPlansArray.push('LIFE');
    }
    if (this.lifeGroupedPlans?.AUPE?.length > 0) {
      this.groupedPlansArray.push('AUPE');
    }
    console.log('this.groupedPlansArray', this.groupedPlansArray);
  }


  getPlanes() {
    let accessToken = this.getSession('accessToken');
    let customerId = this.getSession('customerId');
    let customerEndpoint = `/customer/v3/${customerId}/plans/false`;
    this.http.get(api.url + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.plans = response?.data.plans;
        console.log("plans", this.plans);

        // life plans
        this.lifePlansData = []
        this.iafgLifePlansData = []
        this.aupeLifePlansData = []

        // loop plans for life plans
        this.plans.forEach(element => {



          if (element.insuranceType == "LIFE") {
            if (element.name.toLowerCase().includes('aupe')) {
              this.aupeLifePlansData.push(element);
              // Push AUPE group only once
              if (!this.lifePlansData.some(x => x.groupKey === "AUPE")) {
                this.lifePlansData.push({ name: "AUPE Optional Life", groupKey: "AUPE" });
              }
            } else if (element.name.toLowerCase().includes('all-state')) {
              this.iafgLifePlansData.push(element);
              // Push all state group only once
              if (!this.lifePlansData.some(x => x.groupKey === "LIFE")) {
                this.lifePlansData.push({ name: "All-State Critical Illness", groupKey: "LIFE" });
              }
            } else {
              this.iafgLifePlansData.push(element);
              // Push LIFE group only once - covers Life Insurance AND Critical Illness
              if (!this.lifePlansData.some(x => x.groupKey === "LIFE")) {
                this.lifePlansData.push({ name: "Life Insurance", groupKey: "LIFE" });
              }
            }
          }

          if (element?.content?.length > 0) {
            const filtered = element.content.filter(item => item.planLevelId === 18);
            if (filtered.length > 0) {
              this.planLevelId = 18
            }

          }
        })


        if (this.lifePlansData.length > 0) {
          this.showIAFG = true
        }
        else {
          this.showIAFG = false
        }
        console.log('lifePlansData', this.lifePlansData);

        // remove duplicate plans
        this.filteredPlans = this.removeDuplicatePlans(this.plans);

        console.log('filteredPlans', this.filteredPlans)

        this.additionalDetails = this.plans.map(plan => {
          const details = JSON.parse(plan.additionalDetails);
          this.buildLifeGroupedPlans();


          // Base member object with defaultUnits
          const member = {
            ...details?.member,
            defaultUnits: (
              (details?.member?.maximumCoverageWithoutEvidence >= details?.member?.coverageValue)
                ? details?.member?.coverageValue
                : details?.member?.maximumCoverageWithoutEvidence
            )
          };

          // Spouse object, add defaultUnits only if spouse exists
          let spouse = details?.spouse ? { ...details.spouse } : undefined;

          if (spouse) {
            spouse.defaultUnits = (
              (spouse.maximumCoverageWithoutEvidence >= spouse.coverageValue)
                ? spouse.coverageValue
                : spouse.maximumCoverageWithoutEvidence
            );
          }

          return {
            name: details?.name,
            member,
            status: plan?.status,
            selectedDetails: details?.selectedDetails,
            ...(spouse && { spouse })  // only add spouse if it exists
          };
        }).filter(item =>
          item?.name?.includes("Life Insurance") ||
          item?.name?.includes("All-State Critical Illness") ||
          item?.name?.includes("Critical Illness Insurance") ||
          item.name?.toLowerCase().includes('aupe')
        ).sort((a, b) => {
          if (a.name.toLowerCase().includes('aupe')) {
            return 2;
          }
          if (a.name.includes("Life Insurance") && !b.name.includes("Life Insurance")) {
            return -1;
          }
          if (!a.name.includes("Life Insurance") && b.name.includes("Life Insurance")) {
            return 1;
          }
          return 0;
        });

        console.log('this.additionalDetails', this.additionalDetails)

        this.buildLifeGroups();

        setTimeout(() => {
          this.getcoverflow()
        }, 1000);
        const hasLifeCiTile =
  this.lifePlansData.some(lp =>
    lp.name.toLowerCase().includes('life') &&
    this.getMatchingPlans(lp).length > 0
  );

// store flag for sidebar
if (hasLifeCiTile) {
  sessionStorage.setItem('hideLifeCiMenus', 'true');
  sessionStorage.setItem('hideProvidersNearMe', 'true');
}


console.log('hideLifeCiMenus set to:', hasLifeCiTile);
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  upgradeIafgPlans() {
    this.router.navigate(['upgrade-plans'])
  }

  hasMemberData(member: any): boolean {
    if(Object.keys(member)?.length == 1 && Object.keys(member).includes('defaultUnits')){
      return false;
    }
    return member && Object.keys(member).length > 0;
  }

  hasSpouseData(spouse: any): boolean {
    if(Object.keys(spouse)?.length == 1 && Object.keys(spouse).includes('defaultUnits')){
      return false;
    }
    return spouse && Object.keys(spouse).length > 0;
  }

  formatNumber(number) {
    return number?.toLocaleString() ?? number;
  }

  getbenefits() {
    let accessToken = this.getSession('accessToken');
    let customerId = this.getSession('customerId');
    let customerEndpoint = `/customer/v3/${customerId}/planBenefits/false`;
    this.http.get(api.url + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        let planbenefits = response?.data.plansBenefits;
        this.benefits = [];
        for (let benefit of planbenefits) {
          if (benefit.content.includes('{{booklet_link}}')) {
            this.headerName = benefit.name;
            benefit.content = benefit.content.replace('{{booklet_link}}', benefit.bookletLink)
          }
          console.log('this.hicList', this.hicList);
          if (this.hicList && this.hicList.length > 0) {
            if (benefit.content.includes('{{health_card_link}}')) {
              if (benefit.name.toLowerCase().includes("equitable")) {
                let validHicList = this.hicList.find((item: any) => item.name.toLowerCase() == "equitable");
                const originalFileName = validHicList ? validHicList.link : this.hicList[0].link;
                benefit.content = benefit.content.replace('{{health_card_link}}', originalFileName);
              } else {
                benefit.content = benefit.content.replace('{{health_card_link}}', this.hicList[0].link);
              }
            }
          } else {
            console.log('no download card avaiable')
            if (benefit.content.includes('{{health_card_link}}')) {
              benefit.content = benefit.content.replace('{{health_card_link}}', '');
            }
          }
          benefit.content = this.addColorStyleToHtml(benefit.content, benefit.color || '#000000');
          this.benefits.push(benefit)
          console.log('this.benefits', this.benefits);
          if (this.benefits.length > 0) {
            // Remove "Download Card" from the content string
            console.log('this.benefits[0]', this.benefits[0].content);
            if (this.benefits[0].content) {
              this.benefits[0].content = this.benefits[0].content.replace(/<li><a class="healthcard".*?<\/li>​/s, '');
            }
            this.benefits.forEach(resource => {
              if (resource.content) {
                resource.content = resource.content.replace(/\u200B/g, '');
              }
            });
          }
          setTimeout(() => {
            this.getcoverflow()
          }, 1000);
        }
        console.log('this.benefits', this.benefits)
      }

      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  isInitialLoad = true;


  filterEmptyListItems(description: string): string {
    // Create a temporary div to manipulate the HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = description;

    // Select all li elements and filter out empty ones
    const listItems = tempDiv.querySelectorAll('li');
    listItems.forEach((li) => {
      if (!li.textContent?.trim()) {
        li.remove(); // Remove empty <li> tags
      }
    });

    // Return the modified HTML content
    return tempDiv.innerHTML;
  }

  openVideoPopup() {
    let el: HTMLElement = this.openPopup.nativeElement;
    el.click();
  }

  openiframePopup() {
    let el: HTMLElement = this.openiframe.nativeElement;
    el.click();
  }

  openequitablePopup() {
    let el: HTMLElement = this.openequitable.nativeElement;
    el.click();
  }

  openSupportPopup() {
    let el: HTMLElement = this.opensupport.nativeElement;
    el.click();
  }

  downloadCard() {
    if (!!this.health_card) {
      console.log('download card health_card', this.health_card);
      this.health_card = this.health_card.replace('{{health_card_link}}', this.hicList[0].link);

      const cleanedFileName = this.health_card.includes("MemberCard_")
        ? this.health_card.substring(this.health_card.indexOf("MemberCard_"))
        : this.health_card;

      this.http.get(this.health_card, { responseType: "arraybuffer" }).subscribe(
        pdf => {
          const blob = new Blob([pdf], { type: "application/pdf" });
          const fileName = cleanedFileName.includes('pdf') ? cleanedFileName : cleanedFileName + ".pdf";
          saveAs(blob, fileName);
        },
        (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
    } else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.Membership_cards_are_not_available ?? 'Membership cards are not available' })
    }
  }

  onSlideChangeDependents(event: any) {
    this.currentIndexOfSwipperDependents = event[0].realIndex + 1;
    if (this.childrenInfo[event[0].realIndex].relationType == "spouse") {
      this.editSpouse = true;
      this.editChild = false;
    } else if (this.childrenInfo[event[0].realIndex].relationType == "child") {
      this.editSpouse = false;
      this.editChild = true;
    }
  }

  onSlideChangeDownload(event: any) {
    this.currentIndexOfSwipperDownload = event[0].realIndex + 1;
  }

  onSlideChangePlan(event: any) {
    this.currentIndexOfSwipperPlan = event[0].realIndex + 1;
  }

  onSlideChangeBenifuts(event: any) {
    this.currentIndexOfSwipperBenifits = event[0].realIndex + 1;
  }

  setlanguage(event: any) {
    this.getFormConfiguration(event);
  }

  filterInvoices() {
    console.log('Selected filter:', this.filterInvoice);
    console.log('customerFinalInvoices:', this.customerFinalInvoices);


    if (this.filterInvoice === 'All') {
      this.http.get(api.url + `/customer/${this.customerData?.id}/invoices/listAll`).subscribe((response: any) => {
        this.customerFinalInvoices = response?.data;
      })
    } else {
      const date = this.filterInvoice;
      this.http.get(api.url + `/customer/${this.customerData?.id}/invoices/listAllDated?from=${date}-01-01&to=${date}-12-01`).subscribe((response: any) => {
        this.customerFinalInvoices = response?.data;
      })
    }

    console.log('Filtered invoices:', this.filteredInvoices);
  }

  CustomInvoiceFilter() {
    console.log('this.filterDateSelection', this.filterDateSelection);
    if (this.filterDateSelection) {
      this.updateCustomRange();
    } else {
      console.log('No date selected');
    }
  }

  updateCustomRange() {
    const [startDate, endDate] = this.filterDateSelection.map(date => new Date(date));

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    if (isNaN(startDate) || isNaN(endDate)) {
      console.log('Invalid start or end date');
      return;
    }

    console.log('Custom date range:', startDate, 'to', endDate);

    // Filter invoices within the date range
    this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
      const invoiceDate = new Date(invoice?.invoiceDate ?? invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    $('#dropdownMenuButton').click()
  }

  onCustomClick(event: MouseEvent) {
    event.stopPropagation();
    this.filterInvoice = 'Custom';
  }

  // pagination for tiles 
getcoverflow() {
  // Destroy existing swipers first
  const existingSliders = document.querySelectorAll('.tranding-slider:not(.order-services-slider)');
  const existingOrderSlider = document.querySelector('.order-services-slider');
  
  if ((existingSliders[0] as any)?.swiper) {
    (existingSliders[0] as any).swiper.destroy(true, true);
  }
  if ((existingOrderSlider as any)?.swiper) {
    (existingOrderSlider as any).swiper.destroy(true, true);
  }

  // All other sliders
  new Swiper('.tranding-slider:not(.order-services-slider)', {
    effect: 'slide',
    centeredSlides: true,
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    preventClicks: false,
    preventClicksPropagation: false,
    touchStartPreventDefault: false,
    simulateTouch: false,
    coverflowEffect: { rotate: 0, stretch: 0, depth: 100, modifier: 2.5 },
    pagination: { el: '.swiper-pagination', type: 'fraction' },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
  });

  // Order Services slider only
const orderServicesSwiper = new Swiper('.order-services-slider', {
  effect: 'coverflow',
  centeredSlides: true,
  loop: false,
  slidesPerView: 'auto',
  allowTouchMove: false,
  preventClicks: false,
  preventClicksPropagation: false,
  touchStartPreventDefault: false,
  simulateTouch: false,
  observer: true,
  observeParents: true,
  coverflowEffect: { rotate: 0, stretch: 0, depth: 100, modifier: 2.5 },
  pagination: { el: '.order-services-slider .swiper-pagination', type: 'fraction' },
  navigation: {
    nextEl: '.order-services-slider .swiper-button-next',
    prevEl: '.order-services-slider .swiper-button-prev',
  },
});

orderServicesSwiper.on('reachBeginning', () => {
  // no-op placeholder, wraparound handled by custom click handlers below
});

const prevBtn = document.querySelector('.order-services-slider .swiper-button-prev');
const nextBtn = document.querySelector('.order-services-slider .swiper-button-next');

if (prevBtn) {
  prevBtn.addEventListener('click', (e) => {
    if (orderServicesSwiper.isBeginning) {
      e.stopPropagation();
      e.preventDefault();
      orderServicesSwiper.slideTo(orderServicesSwiper.slides.length - 1);
    }
  }, true);
}

if (nextBtn) {
  nextBtn.addEventListener('click', (e) => {
    if (orderServicesSwiper.isEnd) {
      e.stopPropagation();
      e.preventDefault();
      orderServicesSwiper.slideTo(0);
    }
  }, true);
}
  setTimeout(() => {
    const wrapper = document.querySelector('.order-services-slider .swiper-wrapper') as HTMLElement;
    const slides = document.querySelectorAll('.order-services-slider .swiper-slide');
    if (wrapper) {
      wrapper.style.setProperty('transform-style', 'flat', 'important');
      wrapper.style.setProperty('transform', 'translateX(0px)', 'important');
    }
    slides.forEach((slide: any) => {
      slide.style.setProperty('transform-style', 'flat', 'important');
      slide.style.setProperty('transform', 'none', 'important');
    });
  }, 500);
}

  public capitalize(str: String) {
    if (str) {
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }

  public checkDateOfBirth(event: any) {
    // Format-agnostic on purpose: this used to test /^\d{2}-\d{2}-\d{4}/, which
    // stopped matching once the pickers moved to MMM-DD-YYYY and then threw on
    // the null match. Anything the shared parser cannot read is not a date.
    const raw = event?.target?.value ?? '';
    if (raw && parseDateOnly(raw)) {
      return;
    }
    this.addressform.get('dob')?.reset();
    this.addressform.get('dob')?.markAsTouched();
  }

  updateExpiryStatus(cardExpiry) {
    // current date
    const currentDate = new Date();

    // split expiry month and year
    const expiryParts = cardExpiry.split('/');
    const expiryMonth = parseInt(expiryParts[0], 10);
    const expiryYear = parseInt('20' + expiryParts[1], 10);

    // get formated expiry date
    const expiryDate = new Date(expiryYear, expiryMonth - 1);

    // get the difference between current date and expiry date
    const monthDiff = (expiryDate.getFullYear() - currentDate.getFullYear()) * 12 + expiryDate.getMonth() - currentDate.getMonth();

    if (monthDiff <= 0) {
      // expired
      this.ccExpiryTitle = 'Expired'
      this.ccExpiryColor = 'red'
    } else if (monthDiff === 1) {
      // expires in 1 month
      this.ccExpiryTitle = 'Expires next month'
      this.ccExpiryColor = 'darkorange'
    } else if (monthDiff === 2) {
      // expires in 2 months
      this.ccExpiryTitle = 'Expires in couple of months'
      this.ccExpiryColor = 'orange'
    } else if (monthDiff === 3) {
      // expires in 3 months
      this.ccExpiryTitle = 'Expires in 3 months'
      this.ccExpiryColor = '#dcbd15'
    } else if (monthDiff > 3) {
      // expires in more than 3 months
      this.ccExpiryTitle = ''
      this.ccExpiryColor = 'green'
    }
  }

  addColorStyleToHtml(html: string, color: string): string {
    if (!html) return html;

    // Add style="color: ..." to every tag
    return html.replace(/<([a-zA-Z0-9]+)([^>]*)>/g, (match, tag, attrs) => {
      // Avoid adding style to tags that already have it
      if (attrs.includes('style=')) {
        // Append color only if color isn't already set
        return `<${tag}${attrs.replace(/style="(.*?)"/, (m, s) => `style="${s}; color: ${color} !important;"`)}>`;
      } else {
        return `<${tag}${attrs} style="color: ${color} !important;">`;
      }
    });
  }




  async AuthorizeProfileCreation2(value1: any, createpayment: any, creditCardForm: any, enrollmentdate: any, paymentPlatform: any, phoneNum: any, loginEmail: any, reload: any = '', expireStaxPLans: any = false, createNewProfile: any = false, customerProfileId: any = '') {
    creditCardForm = creditCardForm.value;
    console.log('creditCardForm', creditCardForm)
    const formData = creditCardForm;

    const cardNum = creditCardForm?.CardNumber?.replace(/\s+/g, '');

    // structure cardData - required for creating payment profile
    const cardData = {
      cardNumber: cardNum,
      month: creditCardForm?.ExpirationMonth,
      year: (creditCardForm?.ExpirationYear % 100).toString(),
    };

    // structure new credit card details - required for '/change' api - for mail
    let newCardDetails = {
      expiry: cardData.month + '/' + creditCardForm?.ExpirationYear,
      endingNumber: "XXXX" + cardData.cardNumber.slice(-4)
    }
    localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))

    const profileInfo = { email: loginEmail, customerId: this.customerData.id };
    if (api.authorizeNet === true) {
      if (createNewProfile) {
        // create authorize profile
        console.log('create authorize profle');
        this.createAuthorizeProfile(profileInfo, createpayment, value1, formData, enrollmentdate, phoneNum, paymentPlatform, reload, creditCardForm, expireStaxPLans, cardData);
      } else {
        // create payment profile
        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep2(act, customerProfileId, true, { customerProfileId }, true, api.commonLoginApiUrl, api.signIn)
        if (createpayment) {
          this.paymentProfileCreation(value1, cardData, formData, customerProfileId, enrollmentdate, phoneNum, paymentPlatform, reload, creditCardForm)
        } else {
          // add pament details to database
          let customerId = this.getSession('customerId');
          await this.addPaymentDetails(customerId, cardData);

          // update payment method - '/change' api
          this.updatePaymentMethod(false, customerProfileId, paymentPlatform, '');
        }
      }
    } else {
      // stax bill api call - currently deprecated because always authrize net is true
      value1.submit();
    }
  }

  createAuthorizeProfile(profileInfo: any, createpayment: any, value1: any, formData: any, enrollmentdate: any, phoneNum: any, paymentPlatform: any, reload: any, creditCardForm: any, expireStaxPLans: any, cardData: any) {
    this.http.post(api.authorizeApiUrl + 'api/authorize-net/create-profile', profileInfo).subscribe(async (res1: any) => {
      console.log("New Profile created: ", res1);
      // checked if their already exists customer created in authorize site
      if (res1.status == 'BAD_REQUEST' || res1.statusCode == 400) {
        let profileId = res1?.message?.split("duplicate record with ID ")?.[1]?.replaceAll(" already exists.", "");
        res1.customerProfileId = profileId;
      }
      if (!res1.customerProfileId) {
        console.log('trouble creating customerProfileId', res1);
        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep2(act, res1.customerProfileId, false, res1, false, api.commonLoginApiUrl, api.signIn)
      }

      // if payment is cc - creating profile
      if (createpayment) {
        this.paymentProfileCreation(value1, cardData, formData, res1.customerProfileId, enrollmentdate, phoneNum, paymentPlatform, reload, creditCardForm, expireStaxPLans)
      } else {
        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep2(act, res1.customerProfileId, false, res1, true, api.commonLoginApiUrl, api.signIn)
        // add credit card details in database
        let customerId = this.getSession('customerId');
        await this.addPaymentDetails(customerId, cardData);

        // update payment method - '/change' api
        this.updatePaymentMethod(false, res1.customerProfileId, paymentPlatform, '', false, expireStaxPLans);
      }
    }, async (err) => {
      console.error("authorizeProfileCreation failed", err)
      const url = window.location.origin;

      let profileId = err?.error?.message.split("duplicate record with ID ")?.[1]?.replaceAll(" already exists.", "");
      console.log('profileId', profileId)
      let authorizeId = profileId ?? this.authorizenetCustomerId
      if (authorizeId) {
        console.log('BRANCH 2 HIT');
        let res1: any = {};
        res1.customerProfileId = authorizeId
        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep2(act, res1.customerProfileId, false, res1, true, api.commonLoginApiUrl, api.signIn)

        // if payment is cc - creating profile
        if (createpayment) {
          this.paymentProfileCreation(value1, cardData, formData, res1.customerProfileId, enrollmentdate, phoneNum, paymentPlatform, reload, creditCardForm, expireStaxPLans)
        } else {
          // add credit card details in database
          let customerId = this.getSession('customerId');
          await this.addPaymentDetails(customerId, cardData);

          // update payment method - '/change' api
          this.updatePaymentMethod(false, res1.customerProfileId, paymentPlatform, '', false, expireStaxPLans);
        }
      } else {
        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep2(act, '', false, err, false, api.commonLoginApiUrl, api.signIn)
      }
    });
  }

  AuthorizeProfileCreationForPAD(value1: any, createpayment: any, creditCardForm: any, enrollmentdate: any, paymentPlatform: any, phoneNum: any, loginEmail: any, reload: any = '', expireStaxPLans: any = false) {

    if (api.authorizeNet == true) {

      const profileInfo = { email: loginEmail, customerId: this.customerData.id };

      if (createpayment) {
        this.http.post(api.authorizeApiUrl + 'api/authorize-net/create-profile', profileInfo).subscribe((res1: any) => {
          console.log("New Profile created: ", res1);
          if (res1.status == 'BAD_REQUEST' || res1.statusCode == 400) {
            let profileId = res1?.message.split("duplicate record with ID ")?.[1]?.replaceAll(" already exists.", "");
            res1.customerProfileId = profileId
            let act = this.buildActivityLogObject({}, false);
            this.commonSerivce.padPaymentActivityLogStep5(act, profileId, false, res1, true, api.commonLoginApiUrl, api.signIn);
          }
          this.updatePaymentMethod(true, res1.customerProfileId, paymentPlatform ?? 'Staxbill', '', false, expireStaxPLans);
        }, (err) => {
          console.error("authorizeProfileCreation failed", err)
          const url = window.location.origin;
          let profileId = err?.error?.message.split("duplicate record with ID ")?.[1]?.replaceAll(" already exists.", "");
          console.log('profileId', profileId)
          let authorizeId = profileId ?? this.authorizenetCustomerId
          if (authorizeId) {
            console.log('BRANCH 3 HIT');
            let act = this.buildActivityLogObject({}, false);
            this.commonSerivce.padPaymentActivityLogStep5(act, authorizeId, false, err, true, api.commonLoginApiUrl, api.signIn);

            let res1: any = {};
            res1.customerProfileId = authorizeId
            if (createpayment) {
              this.updatePaymentMethod(true, res1.customerProfileId, paymentPlatform ?? 'Staxbill', '', false, expireStaxPLans);
            }
          }

        });
      } else {
        this.updatePaymentMethod(true, this.customerData.authorizenetCustomerId, paymentPlatform, '', false, expireStaxPLans);
      }
    } else {
      value1.submit();
    }
  }


  async UpdateAuthorizeProfileCreation(value1: any, createpayment: any, creditCardForm: any, enrollmentdate: any, paymentPlatform: any, phoneNum: any, loginEmail: any, reload: any = '', customerProfileId: any = null) {
    creditCardForm = creditCardForm.value;
    console.log('creditCardForm', creditCardForm);

    const formData = creditCardForm;
    const cardNum = creditCardForm?.CardNumber?.replace(/\s+/g, '');
    const cardData = {
      cardNumber: cardNum,
      month: creditCardForm?.ExpirationMonth,
      year: (creditCardForm?.ExpirationYear % 100).toString(),
    };
    let newCardDetails = {
      expiry: creditCardForm?.ExpirationMonth + '/' + creditCardForm?.ExpirationYear,
      endingNumber: "XXXX" + cardData.cardNumber.slice(-4)
    }
    localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))

    if (api.authorizeNet == true) {
      if (createpayment) {
        this.paymentProfileCreation(value1, cardData, formData, customerProfileId, enrollmentdate, phoneNum, paymentPlatform, reload, creditCardForm)
      } else {
        let customerId = this.getSession('customerId');
        await this.addPaymentDetails(customerId, cardData);

        this.updatePaymentMethod(false, customerProfileId, paymentPlatform, '');
      }
    } else {
      value1.submit();
    }
  }

  async updatePaymentMethod(input: any, customerId: any, paymentPlatform: any, customerPaymentProfileId: any = '', reload: any = false, expireStaxPLans: any = false) {
    console.log('expireStaxPLans', expireStaxPLans);
    console.log("this is the payload data: ", { input, customerId, paymentPlatform, customerPaymentProfileId, reload });

    let paymentMethod: any;
    if (input == true) {
      paymentMethod = 'ACH'
    } else {
      paymentMethod = 'CREDIT_CARD'
    }
    var endPoint = '/customer/v2/' + this.customerData.id + '/paymentType/' + paymentMethod + '/change';
    var accessToken = this.getSession('accessToken');
    //Added by sudeep.k on Apr 03 2024, for paymentMethodId going as null in payload fix
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paymentMethodId = urlParams.get('paymentMethodId');
    let paymentPlatform1 = 'AuthorizeNet'

    let oldCardDetails = JSON.parse(localStorage.getItem("oldCardDetails") ?? "{}")
    let newCardDetails = JSON.parse(localStorage.getItem("newCardDetails") ?? "{}")

    let cardDetails: any = {
      old: this.paymentMethod != 'CREDIT_CARD' && paymentMethod == 'CREDIT_CARD' ? {} : oldCardDetails,
      new: newCardDetails
    }

    var obj = {
      "pad": input == true ? true : false,
      "cc": input == true ? false : true,
      cardDetails: input == true ? {} : cardDetails ?? {},
      "paymentMethodId": input == true ? "" : customerPaymentProfileId ?? paymentMethodId ?? "",
      "paymentPlatform": paymentPlatform1 ?? paymentPlatform ?? 'Staxbill',
      "authorizenetCustomerId": customerId
    };

    let paymentMethod1 = this.transformText(this.paymentMethod ?? '')?.trim();

    let act = this.buildActivityLogObject({}, false);
    if (paymentMethod == 'CREDIT_CARD') {
      this.commonSerivce.ccPaymentActivityLogStep6_1(act, (api.url + endPoint), obj, paymentMethod1, api.commonLoginApiUrl, api.signIn, (input == true ? 'PAD' : 'Credit card'))
    }

    if (input == true && (customerId == null || customerId == undefined || customerId == '')) {
      const email = this.getSession('loginEmail');
      const profileInfo = { email: email, customerId: this.customerData.id };

      console.log('expireStaxPLans', expireStaxPLans);
      // Step 1: Create Profile
      this.http.post(api.authorizeApiUrl + 'api/authorize-net/create-profile', profileInfo).subscribe(async (res1: any) => {
        console.log("New Profile created: ", res1);
        if (res1.status == 'BAD_REQUEST' || res1.statusCode == 400) {
          let profileId = res1?.message.split("duplicate record with ID ")?.[1]?.replaceAll(" already exists.", "");
          res1.customerProfileId = profileId
        }
        if (res1.ok) {
          const updateResponse: any = await this.http
            .post(api.url + endPoint, obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-type': 'application/json',
              },
            }).toPromise();
          if (updateResponse?.status == 200) {
            this.commonSerivce.padPaymentActivityLogStep3(act, this.customerid, api.commonLoginApiUrl, api.signIn)

            new Promise(resolve => setTimeout(resolve, 1000))
              .then(() => {
                this.commonSerivce.padPaymentActivityLogStep5(act, res1.customerProfileId, false, res1, true, api.commonLoginApiUrl, api.signIn)
              })
            console.log("corporatePaymentMethod: update" + JSON.stringify(updateResponse));

            // add activity of successful payment update
            let activity: any = {};
            activity.customerId = this.customerData.id;
            activity.role = 'Customer';
            activity.portal = CONSTANTS.PORTAL;
            activity.url = api.url + endPoint;
            activity.action = 'Payment update in Member portal';
            activity.requestMethod = 'POST';
            activity.requestBody = JSON.stringify(obj);
            activity.status = CONSTANTS.SUCCESS;
            activity.response = JSON.stringify(updateResponse);
            activity.responseSummary = 'Successfully payment has been updated';

            this.apiCommonService.submitActivitytLog(activity);

            if (paymentPlatform1 == 'AuthorizeNet' || paymentPlatform == 'AuthorizeNet') {
              let loginEmail = this?.customerData?.primaryEmail ?? "";
              let customer = this.getSession('customerId') ?? ''
              if (expireStaxPLans) {
                this.http.post(api.url + `/customer/expire-plans-in-stax/${customer}`, {},
                  {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-type': 'application/json',
                    }
                  }
                ).subscribe((response: any) => {
                  let act = this.buildActivityLogObject({}, false);
                  if (response.status == 200) {
                    this.commonSerivce.ccPaymentActivityLogStep7_1(act, (api.url + `/customer/expire-plans-in-stax/${customer}`), api.commonLoginApiUrl, api.signIn)
                  } else {
                    this.commonSerivce.ccPaymentActivityLogStep7_2(act, (api.url + `/customer/expire-plans-in-stax/${customer}`), response, 'success', api.commonLoginApiUrl, api.signIn)
                    Swal.fire({ title: 'Info', text: response.message })
                  }
                  if (reload) {
                    localStorage.removeItem("oldCardDetails")
                    localStorage.removeItem("newCardDetails")
                  }
                })
              } else {
                if (reload) {
                  localStorage.removeItem("oldCardDetails")
                  localStorage.removeItem("newCardDetails")
                }
              }
            }

            Swal.fire({ title: 'Info', text: updateResponse.message }).then((res) => {
              if (res.isConfirmed) {
                window.location.reload()
              }
            })
          } else {
            Swal.fire({ title: 'Error', text: updateResponse.message });

            let currentTimeStamp = this.apiCommonService.getTimeStamp();
            Cookies.set('Home_payment_change_error_' + currentTimeStamp, 'Bank verify error: ' + JSON.stringify(updateResponse));

            // create object for report log
            let log = { [`Payment Change 400 ${currentTimeStamp}`]: updateResponse }
            let obj1 = {
              customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...obj }),
              browser: '',
              systemDetails: {},
              logs: JSON.stringify(log),
              sessionDetails: '{}'
            };
            this.apiCommonService.submitReportLog(obj1);
          }
        }
      }, (err) => {
        console.error("authorizeProfileCreation failed", err)
        let profileId = err?.error?.message.split("duplicate record with ID ")?.[1]?.replaceAll(" already exists.", "");
        console.log('profileId', profileId)
        let authorizeId = profileId ?? this.authorizenetCustomerId
        if (authorizeId) {
          console.log('BRANCH 4 HIT');
          let act: any = this.buildActivityLogObject({}, false)
          this.commonSerivce.padPaymentActivityLogStep5(act, profileId, false, err, true, api.commonLoginApiUrl, api.signIn);
          let res1: any = {};
          res1.customerProfileId = authorizeId
          if (paymentPlatform1 == 'AuthorizeNet' || paymentPlatform == 'AuthorizeNet') {
            let loginEmail = this?.customerData?.primaryEmail ?? "";
            let customer = this.getSession('customerId') ?? ''
            console.log('expireStaxPLans', expireStaxPLans);
            if (expireStaxPLans) {
              this.http.post(api.url + `/customer/expire-plans-in-stax/${customer}`, {},
                {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-type': 'application/json',
                  }
                }
              ).subscribe((response: any) => {
                if (response.status == 200) {
                } else {
                  Swal.fire({ title: 'Info', text: response.message })

                  let currentTimeStamp = this.apiCommonService.getTimeStamp();
                  Cookies.set('Home_expire_plans_error_' + currentTimeStamp, 'Expire plans error: ' + JSON.stringify(response));

                  // create object for report log
                  let log = { [`Expire plans 400 ${currentTimeStamp}`]: response }
                  let obj = {
                    customerDetails: JSON.stringify({ customerId: customer, email: this.customerData.primaryEmail, }),
                    browser: '',
                    systemDetails: {},
                    logs: JSON.stringify(log),
                    sessionDetails: '{}'
                  };
                  this.apiCommonService.submitReportLog(obj);
                }
                if (reload) {
                  localStorage.removeItem("oldCardDetails")
                  localStorage.removeItem("newCardDetails")
                }
              })
            } else {
              if (reload) {
                localStorage.removeItem("oldCardDetails")
                localStorage.removeItem("newCardDetails")
              }
            }
          }
        }
      });
    } else if (customerId != null && customerId != undefined && customerId != '' && customerId != '0') {
      const updateResponse: any = await this.http
        .post(api.url + endPoint, obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-type': 'application/json',
          },
        }).toPromise();
      if (updateResponse?.status == 200) {
        let act = this.buildActivityLogObject({}, false);
        if (input == true) {
          this.commonSerivce.padPaymentActivityLogStep3(act, this.customerid, api.commonLoginApiUrl, api.signIn)

          this.commonSerivce.padPaymentActivityLogStep4(act, (api.url + endPoint), obj, updateResponse, true, api.commonLoginApiUrl, api.signIn)

          this.commonSerivce.padPaymentActivityLogStep5(act, customerId, true, {}, true, api.commonLoginApiUrl, api.signIn)

          this.commonSerivce.padPaymentActivityLogStep6_1(act, (api.url + endPoint), obj, paymentMethod1, api.commonLoginApiUrl, api.signIn)
        }
        let filteredPaymentMethod: any = this.getFilteredPaymentMethod(paymentMethod1)
        this.commonSerivce.ccPaymentActivityLogStep6_2(act, (api.url + endPoint), obj, updateResponse, true, ((filteredPaymentMethod == 'ach' || filteredPaymentMethod == 'pad') ? 'PAD' : 'Credit Card'), api.commonLoginApiUrl, api.signIn, input == true ? 'PAD' : 'Credit Card');
        console.log("corporatePaymentMethod: update" + JSON.stringify(updateResponse));
        if (paymentPlatform1 == 'AuthorizeNet' || paymentPlatform == 'AuthorizeNet') {
          let loginEmail = this?.customerData?.primaryEmail ?? "";
          let customer = this.getSession('customerId') ?? ''
          console.log('expireStaxPLans', expireStaxPLans);

          let existingCreditCards = JSON.parse(this.getSession('existingCreditCards') || '')
          console.log('existingCreditCards', existingCreditCards);
          if (existingCreditCards) {
            for (let i = 0; i < existingCreditCards.length; i++) {
              this.http.delete(api.signIn + `common/customer/${this.customerid}/Staxbill/payment/${this.paymentMethod == 'ACH' ? 'pad' : 'cc'}/${existingCreditCards[i]?.id}/remove`)
                .subscribe((response: any) => {
                  if (response.status != 200) {
                  }
                })
            }
            this.removeSession('existingCreditCards')
          }
          if (this.paymentPlatform == 'AuthorizeNet' && this.customerData?.authorizenetPaymentId) {
            this.http.delete(api.signIn + `common/customer/${this.customerid}/AuthorizeNet/payment/${this.paymentMethod == 'ACH' ? 'pad' : 'cc'}/${this.customerData?.authorizenetPaymentId}/remove`)
              .subscribe((response: any) => {
                if (response.status != 200) {
                }
              })
          }

          let act = this.buildActivityLogObject({}, false);
          this.commonSerivce.ccPaymentActivityLogStep7_1(act, (api.url + `/customer/expire-plans-in-stax/${customer}`), api.commonLoginApiUrl, api.signIn)
          if (expireStaxPLans) {
            this.http.post(api.url + `/customer/expire-plans-in-stax/${customer}`, {},
              {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-type': 'application/json',
                }
              }
            ).subscribe((response: any) => {
              if (response.status == 200) {
                this.commonSerivce.ccPaymentActivityLogStep7_2(act, (api.url + `/customer/expire-plans-in-stax/${customer}`), response, 'success', api.commonLoginApiUrl, api.signIn)
              } else {
                this.commonSerivce.ccPaymentActivityLogStep7_2(act, (api.url + `/customer/expire-plans-in-stax/${customer}`), response, 'failure', api.commonLoginApiUrl, api.signIn)
                Swal.fire({ title: 'Info', text: response.message })

                let currentTimeStamp = this.apiCommonService.getTimeStamp();
                Cookies.set('Home_expire_plans_error_' + currentTimeStamp, 'Expire plans error: ' + JSON.stringify(response));

                // create object for report log
                let log = { [`Expire plans 400 ${currentTimeStamp}`]: response }
                let obj = {
                  customerDetails: JSON.stringify({ customerId: customer, email: this.customerData.primaryEmail, }),
                  browser: '',
                  systemDetails: {},
                  logs: JSON.stringify(log),
                  sessionDetails: '{}'
                };
                this.apiCommonService.submitReportLog(obj);
              }
              if (reload) {
              }
            })
          } else {
            this.commonSerivce.ccPaymentActivityLogStep7_2(act, (api.url + `/customer/expire-plans-in-stax/${customer}`), {}, 'expired', api.commonLoginApiUrl, api.signIn)
            if (reload) {
            }
          }
        }

        Swal.fire({ title: 'Info', text: updateResponse.message }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload()
          }
        })
      } else {
        let filteredPaymentMethod: any = this.getFilteredPaymentMethod(paymentMethod1)
        this.commonSerivce.ccPaymentActivityLogStep6_2(act, (api.url + endPoint), obj, updateResponse, false, ((filteredPaymentMethod == 'ach' || filteredPaymentMethod == 'pad') ? 'PAD' : 'Credit Card'), api.commonLoginApiUrl, api.signIn, input == true ? 'PAD' : 'Credit Card')
        Swal.fire({ title: 'Error', text: updateResponse.message });

        let currentTimeStamp = this.apiCommonService.getTimeStamp();
        Cookies.set('Home_payment_change_error_' + currentTimeStamp, 'Expire plans error: ' + JSON.stringify(updateResponse));

        // create object for report log
        let log = { [`Payment Change error ${currentTimeStamp}`]: updateResponse }
        let obj1 = {
          customerDetails: JSON.stringify({ customerId: this.customerData.id, email: this.customerData.primaryEmail, ...obj }),
          browser: '',
          systemDetails: {},
          logs: JSON.stringify(log),
          sessionDetails: '{}'
        };
        this.apiCommonService.submitReportLog(obj1);
      }
    }

  }

  paymentProfileCreation(value1: any = {}, cardData: any, formData: any, customerProfileId: any, enrollmentdate: any, phoneNum: any, paymentPlatform, reload, creditCardForm, expireStaxPLans: any = false) {
    console.log('creditCardForm', creditCardForm);
    console.log('formData', formData);
    console.log('res1', customerProfileId);
    console.log('expireStaxPLans', expireStaxPLans);
    console.log('cardData', cardData);

    // create an object with authorize user keys
    const authData = {
      clientKey: api.clientKey,
      apiLoginID: api.apiLoginID
    };
    const secureData = { cardData, authData };

    // submit creditcard to authorize site - with customerProfileId
    Accept.dispatchData(secureData, (response: any) => {
      console.log(cardData, authData, response);

      if (response.messages.resultCode !== "Ok") {
        console.error("Accept.js dispatch failed:", response.messages.message?.[0]?.text ?? response.messages.message);
        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep3(act, secureData, response, false, api.commonLoginApiUrl, api.signIn)
        return;
      }

      if (response.messages.resultCode === "Ok") {
        const opaqueData = response.opaqueData;
        const formData: any = JSON.parse(this.getSession('formData') ?? '{}');
        const paymentInfo = {
          opaqueDataDescriptor: opaqueData?.dataDescriptor ?? '',
          opaqueDataValue: opaqueData?.dataValue ?? '',
          firstName: creditCardForm?.FirstName,
          lastName: creditCardForm?.LastName,
          address: this.customerData?.line1 + ' ' + this.customerData?.line2,
          city: this.customerData?.city ?? formData?.city,
          state: this.customerData?.province ?? formData?.province,
          zip: this.customerData?.postalCode ?? formData?.postalcode,
          country: "Canada",
          customerProfileId: !!customerProfileId ? customerProfileId : this.customerData?.authorizenetCustomerId,
          phoneNumber: phoneNum ?? '',
        };

        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep3(act, secureData, response, true, api.commonLoginApiUrl, api.signIn)

        // Step 2: Create Payment Profile
        this.http.post(api.authorizeApiUrl + 'api/authorize-net/add-payment-profile', paymentInfo).subscribe(async (res2: any) => {

          // add customerId and paymentId to sessionStorage
          this.setSession('authorizenetCustomerId', res2.customerProfileId)
          this.setSession('authorizenetPaymentId', res2.customerPaymentProfileId)
          this.setSession('payment', "CC")

          let act = this.buildActivityLogObject({}, false);
          this.commonSerivce.ccPaymentActivityLogStep4(
            act,
            (api.authorizeApiUrl + 'api/authorize-net/add-payment-profile'),
            paymentInfo,
            res2,
            res2.customerPaymentProfileId,
            true,
            api.commonLoginApiUrl,
            api.signIn
          )

          // get customerId - which we got from details api 
          let customerId = this.getSession('customerId');

          // add payment details to database
          await this.addPaymentDetails(customerId, cardData);
          console.log('expireStaxPLans', expireStaxPLans);

          // update payment method - '/change' api call
          this.updatePaymentMethod(
            false,
            res2.customerProfileId,
            paymentPlatform ?? 'Staxbill',
            res2.customerPaymentProfileId,
            false,
            expireStaxPLans
          ); // in parameter one - false will make it as credit card
}, (err) => {
  const isDuplicateCard = err?.error?.message?.includes('duplicate customer payment profile') ||
    err?.message?.includes('duplicate customer payment profile');

const existingPaymentProfileId = sessionStorage.getItem('authorizenetPaymentId');

if (isDuplicateCard && this.paymentPlatform == 'AuthorizeNet') {
  this.http.get(api.url + `/customer/${this.customerid}/currentPaymentProfileId`, {
    headers: { Authorization: 'Bearer ' + this.accessToken }
  }).subscribe((profileResponse: any) => {
    const existingPaymentProfileId = profileResponse?.data?.paymentProfileId;

    if (!existingPaymentProfileId) {
      Swal.fire({ title: 'Info', text: 'Unable to find existing payment profile to update.' });
      return;
    }

    this.http.delete(api.signIn + `common/customer/${this.customerid}/AuthorizeNet/payment/${this.paymentMethod == 'ACH' ? 'pad' : 'cc'}/${existingPaymentProfileId}/remove`)
      .subscribe((removeResponse: any) => {
        if (removeResponse.status == 200) {
          setTimeout(() => {
            const authData = { clientKey: api.clientKey, apiLoginID: api.apiLoginID };
            const secureData = { cardData, authData };
            Accept.dispatchData(secureData, (retryResponse: any) => {
              if (retryResponse.messages.resultCode !== "Ok") {
                Swal.fire({ title: 'Info', text: retryResponse.messages?.message?.[0]?.text ?? 'Trouble updating payment profile, try again.' });
                return;
              }
              const opaqueData = retryResponse.opaqueData;
              const freshPaymentInfo = {
                ...paymentInfo,
                opaqueDataDescriptor: opaqueData.dataDescriptor,
                opaqueDataValue: opaqueData.dataValue,
              };
              this.http.post(api.authorizeApiUrl + 'api/authorize-net/add-payment-profile', freshPaymentInfo).subscribe(async (res2: any) => {
                this.setSession('authorizenetCustomerId', res2.customerProfileId)
                this.setSession('authorizenetPaymentId', res2.customerPaymentProfileId)
                this.setSession('payment', "CC")
                let customerId = this.getSession('customerId');
                await this.addPaymentDetails(customerId, cardData);
                this.updatePaymentMethod(false, res2.customerProfileId, paymentPlatform ?? 'Staxbill',  res2.customerPaymentProfileId, false, expireStaxPLans);
              }, (retryErr) => {
                Swal.fire({ title: 'Info', text: retryErr?.error?.message ?? 'Trouble updating payment profile, try again.' });
              });
            });
          }, 2000);
        } else {
          Swal.fire({ title: 'Info', text: 'Trouble removing old payment profile, try again.' });
        }
      }, (removeErr) => {
        Swal.fire({ title: 'Info', text: 'Trouble removing old payment profile, try again.' });
      });
  }, (profileErr) => {
    Swal.fire({ title: 'Info', text: 'Unable to check existing payment profile.' });
  });
  return;
}

  Swal.fire({ title: 'Info', text: err.message }).then((res: any) => {
    this.commonSerivce.ccPaymentActivityLogStep4(
      act,
      (api.authorizeApiUrl + 'api/authorize-net/add-payment-profile'),
      paymentInfo,
      err,
      undefined,
      false,
      api.commonLoginApiUrl,
      api.signIn
    )
    if (res.isConfirmed) {
      console.error("authorize payment profile creation failed", err)
      const url = window.location.origin;
      window.location.href = url + reload + `?customerId=0&paymentMethodId=0&success=False`
    }
  })
});
      }
    })
  }

  async addPaymentDetails(customerId: any, cardData: any) {
    let inputData = {
      customerId: Number(customerId ?? '0') ?? 0,
      cc: (cardData.cardNumber)?.toString()?.slice(-4),
      timestamp: Date.now()?.toString(),
      expiry: cardData.month?.toString() + '/20' + cardData.year?.toString(),
    };

    let ccSessionDetails: any = btoa(JSON.stringify(inputData));
    console.log('inputData', inputData);
    console.log('ccSessionDetails', ccSessionDetails);
    let accessToken = this.getSession('accessToken');

    try {
      const response: any = await this.http.post(
        api.url + '/api/authorizenet-payment/details',
        {
          customerId: Number(customerId ?? '0') ?? 0,
          session: ccSessionDetails,
        },
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-type': 'application/json',
          },
        }
      ).toPromise();  // convert observable to promise

      if (response && response.status == 200) {
        console.log(response);

        let act = this.buildActivityLogObject({}, false);
        this.commonSerivce.ccPaymentActivityLogStep5(
          act,
          (api.url + '/api/authorizenet-payment/details'),
          {
            customerId: Number(customerId ?? '0') ?? 0,
            session: ccSessionDetails,
          },
          response, true, api.commonLoginApiUrl, api.signIn)
      }
    } catch (error) {
      console.log('error updating database', error);
      let act = this.buildActivityLogObject({}, false);
      this.commonSerivce.ccPaymentActivityLogStep5(
        act,
        (api.url + '/api/authorizenet-payment/details'),
        {
          customerId: Number(customerId ?? '0') ?? 0,
          session: ccSessionDetails,
        },
        error, false, api.commonLoginApiUrl, api.signIn
      )
    }
  }

  removeDuplicatePlans(plans: any[]): any[] {
    const uniquePlansMap = new Map<string, any>();

    for (const plan of plans) {
      // Create a unique key based on name + activationDate
      const key = `${plan.name}`;
      if (!uniquePlansMap.has(key)) {
        uniquePlansMap.set(key, plan);
      }
    }

    return Array.from(uniquePlansMap.values());
  }

  openUpdatePaymentMethodPAD() {
    let updatePaymentMethodPAD: any = document.getElementById('updatePaymentMethodPAD');

    console.log('updatePaymentMethodPAD', updatePaymentMethodPAD);
  }

  getMatchingPlans(lifePlan: any): any[] {
    const isAupe = lifePlan.groupKey === "AUPE" || lifePlan.name?.toLowerCase().includes('aupe');

    return this.additionalDetails.filter((detail) => {
      const status = detail.status?.toLowerCase();
      const isValidStatus = ['active', 'provisioning'].includes(status);
      const detailName = detail.name?.toLowerCase();

      if (isAupe) {
        return detailName.includes('aupe') && isValidStatus;
      } else {
        // LIFE group matches both "life insurance" and "critical illness"
        return (detailName.includes('life insurance') || detailName.includes('critical illness')) && isValidStatus;
      }
    });
  }

  buildActivityLogObject(obj: any, submit: boolean = false) {
    let activity: any = {};
    activity.portal = obj?.portal ?? 'MEMBER';

    activity.effectedUserType = 'CUSTOMER';
    activity.effectedUserId = obj?.effectedUserId ?? this.getSession('customerId') ?? this.customerid;


    activity.url = obj?.url ?? undefined;
    activity.action = obj?.action ?? undefined;
    activity.requestMethod = obj?.requestMethod;
    activity.requestBody = JSON.stringify(obj?.requestBody ?? {});
    activity.status = obj?.status ?? undefined;
    activity.response = JSON.stringify(obj?.response ?? {});
    activity.responseSummary = obj?.responseSummary ?? undefined;

    if (submit) {
      this.commonSerivce.submitActivityLog(api?.commonLoginApiUrl, activity, api?.signIn);
    } else {
      return activity;
    }
  }

  transformText(text: any) {
    text = text?.toString()?.trim() ?? '';

    text = text.replace(/[_-]/g, ' ');

    return text
      .split(/\s+/)
      .map(
        (word: string) =>
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');
  }

  formDataToJSON(formData: any) {
    const obj = {};
    formData.forEach((value, key) => {
      // Handle multiple values (e.g., checkboxes)
      if (obj[key]) {
        if (!Array.isArray(obj[key])) obj[key] = [obj[key]];
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    });
    return obj;
  }

  buildLifeGroups() {
    this.lifeGroupedPlans = {
      LIFE: [],
      AUPE: []
    };

    this.additionalDetails.forEach((detail: any) => {
      const name = detail.name?.toLowerCase() || '';

      if (name.includes('aupe')) {
        this.lifeGroupedPlans.AUPE.push(detail);
      }
      else if (
        name.includes('life insurance') ||
        name.includes('critical illness')
      ) {
        this.lifeGroupedPlans.LIFE.push(detail);
      }
    });

    console.log('Life group:', this.lifeGroupedPlans.LIFE);
    console.log('AUPE group:', this.lifeGroupedPlans.AUPE);

    if (this.lifeGroupedPlans?.LIFE?.length > 0) {
      this.groupedPlansArray.push('LIFE');
    }
    if (this.lifeGroupedPlans?.AUPE?.length > 0) {
      this.groupedPlansArray.push('AUPE');
    }
    console.log('this.groupedPlansArray', this.groupedPlansArray);
  }


  getFilteredPaymentMethod(method: any) {
    return method?.toLowerCase().trim();
  }

  handleContentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.classList.contains('contact')) {
      const text = target.innerText.trim();
      this.copyToClipboard(text);

      // show feedback
      this.copiedText = text;

      setTimeout(() => {
        this.copiedText = null;
      }, 1500); // disappears after 1.5s
    }
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).catch(err => {
      console.error('Copy failed', err);
    });
  }

  setSession(key: string, value: any): void {
    const val = typeof value === 'string' ? value : JSON.stringify(value);
    try {
      sessionStorage.setItem(key, val);
      this.session[key] = val; // fallback
    } catch {
      this.session[key] = val; // fallback
    }
  }

  getSession(key: string): any {
    try {
      const val = sessionStorage.getItem(key);
      if (val != null) return val;
    } catch { }

    const val = this.session[key];
    if (val != null) return val;

    return undefined;
  }

  removeSession(key: string): void {
    try { sessionStorage.removeItem(key); } catch { }
    delete this.session[key];
  }

   isExternalForm(item: any): boolean {
  const type = item.typeOfForm?.toLowerCase() || '';
  return type.includes('msk 360') || 
         type.includes('msk360') || 
         type.includes('nutrition & diabetes') ||
         type.includes('nutrition and diabetes');
}
redirectToExternalForm(item: any) {
  const type = item.typeOfForm?.toLowerCase() || '';
  
  let url = '';
  
  if (type.includes('msk') || type.includes('msk 360')) {
    url = 'https://www.phzio.com/start/groupbenefitz';
  } else if (type.includes('nutrition') || type.includes('diabetes')) {
    url = 'https://rxfood.com/register/groupbenefitz-en';
  }

  if (url) {
    window.open(url, '_blank');
  } else {
    this.showInfoPopup('External link not available. Please contact admin@groupbenefitz.ca');
  }
}
canCancelBooking(item: any): boolean {
  const key = item.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key];
  
  // Only EHA supports cancellation
  if (!key.includes('executive health assessment')) return false;
  
  // Check if within 7 day cancel window
  return e?.self?.canCancel === true || 
         e?.spouse?.canCancel === true ||
         e?.both?.canCancel === true;
}
openEhaOrderPopup(item: any) {
    if (!this.hasEligibilityDataLoaded(item)) {
      this.showInfoPopup('Please wait a moment while we load your eligibility information, then try again.');
      return;
    }
    if (this.isBlockedDueToArrears()) {
    const message = this.isCorporateAccount
      ? 'Your request cannot be completed at this time. Please ask your company plan administrator to contact admin@groupbenefitz.ca.'
      : 'Your premiums must be paid before any services can be booked.';
    this.showInfoPopup(message);
    return;
  }
  if (this.isBothEhaOrdered(item)) {
    this.showInfoPopup('Next eligible date is September 1, 2026.');
    return;
  }

  const hasSpouse = this.hasSpouseInfo();
  if (!hasSpouse) {
    this.openResourceModal(item, 'self');
    return;
  }

  const selfDisabled = this.eligibilityMap?.['executive health assessment']?.['self']?.canOrder === false;
  const spouseDisabled = this.eligibilityMap?.['executive health assessment']?.['spouse']?.canOrder === false;

  // If both disabled
  if (selfDisabled && spouseDisabled) {
    this.showInfoPopup('Next eligible date is September 1, 2026.');
    return;
  }

  Swal.fire({
    title: 'Assessment Request',
    html: `
      <div style="display:flex; flex-direction:column; gap:10px; margin-top:10px; align-items:center;">
        <button id="eha-self-btn" class="swal2-confirm swal2-styled" 
          style="background:${selfDisabled ? '#aaa' : '#1a2e4a'}; width:100px; ${selfDisabled ? 'cursor:not-allowed;' : ''}"
          ${selfDisabled ? 'disabled' : ''}>
          ${selfDisabled ? 'Self' : 'Self'}
        </button>
        <button id="eha-spouse-btn" class="swal2-confirm swal2-styled"
          style="background:${spouseDisabled ? '#aaa' : '#1a2e4a'}; width:100px; ${spouseDisabled ? 'cursor:not-allowed;' : ''}"
          ${spouseDisabled ? 'disabled' : ''}>
          ${spouseDisabled ? 'Spouse' : 'Spouse'}
        </button>
${!selfDisabled && !spouseDisabled ? `
        <button id="eha-both-btn" class="swal2-confirm swal2-styled"
          style="background:#1a2e4a; width:100px;">
          Both
        </button>` : ''}
      </div>
    `,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    didOpen: () => {
      const selfBtn = document.getElementById('eha-self-btn');
      const spouseBtn = document.getElementById('eha-spouse-btn');
      const bothBtn = document.getElementById('eha-both-btn');

      if (selfBtn && !selfDisabled) {
        selfBtn.addEventListener('click', () => {
          Swal.close();
          this.openResourceModal(item, 'self');
        });
      }
      if (spouseBtn && !spouseDisabled) {
        spouseBtn.addEventListener('click', () => {
          Swal.close();
          this.openResourceModal(item, 'spouse');
        });
      }
      if (bothBtn) {
        bothBtn.addEventListener('click', () => {
          Swal.close();
          this.openResourceModal(item, 'both');
        });
      }
    }
  });
}
isBothEhaOrdered(item: any): boolean {
  const key = item.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key];
  if (!e) return false;

  const selfOrdered = !!e.self?.orderDate;
  const hasSpouse = this.hasSpouseInfo();

  if (hasSpouse) {
    return selfOrdered && !!e.spouse?.orderDate;
  }
  return selfOrdered;
}
openReginaLifeFlow(item: any) {
  if (this.isBlockedDueToArrears()) {
    const message = this.isCorporateAccount
      ? 'Your request cannot be completed at this time. Please ask your company plan administrator to contact admin@groupbenefitz.ca.'
      : 'Your premiums must be paid before any services can be booked.';
    this.showInfoPopup(message);
    return;
  }

  if (!this.bookingComp) return;

  // Open booking modal to get option selection first
  this.bookingComp.isReginaLifeMode = true;
  this.bookingComp.openResourceModal(item, 'self');
}
orderMedcanGalleriStandalone() {
  if (!this.bookingComp) {
    console.error('bookingComp is undefined');
    return;
  }
  this.http.get(api.url + '/billing-options/medcan-galleri').subscribe({
    next: (config: any) => {
      if (!config || !config.options?.length) return;
      this.bookingComp!.openGenericBillingPopup(config);   
    },
    error: (err) => {
      console.log('Failed to load billing options:', err);
    },
  });
}
loadMedcanEligibility() {
  if (!this.customerData?.id) return;
  this.http.get(`${api.url}/customer/v3/${this.customerData.id}/plans/false`, {
    headers: {
      Authorization: 'Bearer ' + this.accessToken,
      'Content-Type': 'application/json',
    },
  }).subscribe({
    next: (res: any) => {
      this.hasMedcanMembership = res?.data?.hasMedcanMembership ?? false;
      this.cdr?.detectChanges();
    },
    error: (err) => {
      console.log('hasMedcanMembership error:', err);
    },
  });
}
hasEligibilityDataLoaded(item: any): boolean {
  const key = item.typeOfForm?.trim().toLowerCase();
  return !!this.eligibilityMap?.[key];
}
getEhaRows(item: any): { label: string; coverage: 'self' | 'spouse' | 'both'; orderDate: Date | null; nextEligible: Date | null; canCancel: boolean }[] {
  const key = item.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key];
  if (!e) return [];

  const rows: any[] = [];
  const selfEntry = e['self'];
  const spouseEntry = e['spouse'];
  const bothEntry = e['both'];

 // If BOTH self AND spouse are active — means ordered as Both
  const bothOrdered = selfEntry?.canCancel && spouseEntry?.canCancel && this.hasSpouseInfo();

// Check if ordered as Both — same orderDate for self and spouse (ordered together)
const selfOrderDate = selfEntry?.orderDate;
const spouseOrderDate = spouseEntry?.orderDate;
const orderedTogether = selfEntry?.canCancel && spouseEntry?.canCancel && 
  selfOrderDate && spouseOrderDate &&
  Math.abs(new Date(selfOrderDate).getTime() - new Date(spouseOrderDate).getTime()) < 5000; // within 5 seconds

if (orderedTogether && this.hasSpouseInfo()) {
  rows.push({
    label: 'Both',
    coverage: 'both',
    orderDate: selfEntry.orderDate ? new Date(selfEntry.orderDate) : null,
    nextEligible: selfEntry.nextAvailableDate ?? null,
    canCancel: true,
  });
  return rows;
}

  // Self only
  if (selfEntry && (selfEntry.orderDate || selfEntry.canCancel)) {
    rows.push({
      label: 'Member',
      coverage: 'self',
      orderDate: selfEntry.orderDate ? new Date(selfEntry.orderDate) : null,
      nextEligible: selfEntry.nextAvailableDate ?? null,
      canCancel: !!selfEntry.canCancel,
    });
  }

  // Spouse only
  if (spouseEntry && (spouseEntry.orderDate || spouseEntry.canCancel) && this.hasSpouseInfo()) {
    rows.push({
      label: 'Spouse',
      coverage: 'spouse',
      orderDate: spouseEntry.orderDate ? new Date(spouseEntry.orderDate) : null,
      nextEligible: spouseEntry.nextAvailableDate ?? null,
      canCancel: !!spouseEntry.canCancel,
    });
  }
  return rows;
}
getgutChekRows(item: any): { label: string; orderDate: Date | null; nextEligible: Date | null }[] {
  const key = item.typeOfForm?.trim().toLowerCase();
  const e = this.eligibilityMap?.[key];
  if (!e) return [];

  const rows: any[] = [];
  const selfEntry = e['self'];
  const spouseEntry = e['spouse'];

  const selfOrderDate = selfEntry?.orderDate;
  const spouseOrderDate = spouseEntry?.orderDate;
  const orderedTogether = selfEntry?.orderDate && spouseEntry?.orderDate &&
    Math.abs(new Date(selfOrderDate).getTime() - new Date(spouseOrderDate).getTime()) < 5000;

  if (orderedTogether && this.hasSpouseInfo()) {
    rows.push({
      label: 'Both',
      orderDate: new Date(selfEntry.orderDate),
      nextEligible: selfEntry.nextAvailableDate ?? null,
    });
  } else {
    if (selfEntry?.orderDate) {
      rows.push({ label: 'Member', orderDate: new Date(selfEntry.orderDate), nextEligible: selfEntry.nextAvailableDate ?? null });
    }
    if (spouseEntry?.orderDate && this.hasSpouseInfo()) {
      rows.push({ label: 'Spouse', orderDate: new Date(spouseEntry.orderDate), nextEligible: spouseEntry.nextAvailableDate ?? null });
    }
  }

  const children = this.customerData?.dependents?.childrens ?? [];
  children.forEach((child: any, index: number) => {
    const childKey = `child_${child.id ?? index}`;
    const childEntry = e[childKey];
    if (childEntry?.orderDate) {
      rows.push({
       label: `Child ${index + 1}`,
        orderDate: new Date(childEntry.orderDate),
        nextEligible: childEntry.nextAvailableDate ?? null,
      });
    }
  });

  return rows;
}
isWithin7Days(orderDate: Date | null): boolean {
  if (!orderDate) return true;
  const diff = (new Date().getTime() - new Date(orderDate).getTime()) / (1000 * 60 * 60 * 24);
  return diff <= 7;
}
opengutChekOrderPopup(item: any) {
  console.log('maritalStatus:', this.customerData?.maritalStatus);
  console.log('isFamilyPlan:', this.isFamilyPlan());
  console.log('childrens:', this.customerData?.dependents?.childrens);
  console.log('eligibleChildren:', this.getEligibleChildrenForBooking());
  if (this.isBlockedDueToArrears()) {
    const message = this.isCorporateAccount
      ? 'Your request cannot be completed at this time. Please ask your company plan administrator to contact admin@groupbenefitz.ca.'
      : 'Your premiums must be paid before any services can be booked.';
    this.showInfoPopup(message);
    return;
  }

const key = item.typeOfForm?.trim().toLowerCase();
const e = this.eligibilityMap?.[key];
const hasSpouse = this.hasSpouseInfo();
const isgutChekForm = key.includes('food sensitivity');
const isFamily = this.isFamilyPlan();
const eligibleChildren = (isFamily && isgutChekForm) ? this.getEligibleChildrenForBooking() : [];

  if (!hasSpouse && eligibleChildren.length === 0) {
    this.openResourceModal(item, 'self');
    return;
  }

  const selfDisabled = e?.['self']?.canOrder === false;
  const spouseDisabled = e?.['spouse']?.canOrder === false;

  const childDisabledFlags = eligibleChildren.map((child: any, index: number) => {
    const childKey = `child_${child.id ?? index}`;
    return e?.[childKey]?.canOrder === false;
  });

  const allChildrenDisabled = eligibleChildren.length > 0 && childDisabledFlags.every(d => d);

  if (selfDisabled && spouseDisabled && (eligibleChildren.length === 0 || allChildrenDisabled)) {
    const entry = e?.['self'] || e?.['spouse'];
    this.showInfoPopup(entry?.message || 'Not eligible to order at this time.');
    return;
  }

  const childButtonsHtml = eligibleChildren.map((child: any, index: number) => {
    const disabled = childDisabledFlags[index];
    return `
      <button id="gc-child-btn-${index}" class="swal2-confirm swal2-styled"
        style="background:${disabled ? '#aaa' : '#1a2e4a'}; width:100px; ${disabled ? 'cursor:not-allowed;' : ''}"
        ${disabled ? 'disabled' : ''}>
        Child ${index + 1}
      </button>`;
  }).join('');

  Swal.fire({
    title: 'Assessment Request',
    html: `
      <div style="display:flex; flex-direction:column; gap:10px; margin-top:10px; align-items:center;">
        <button id="gc-self-btn" class="swal2-confirm swal2-styled"
          style="background:${selfDisabled ? '#aaa' : '#1a2e4a'}; width:100px; ${selfDisabled ? 'cursor:not-allowed;' : ''}"
          ${selfDisabled ? 'disabled' : ''}>
          Self
        </button>
        ${hasSpouse ? `
        <button id="gc-spouse-btn" class="swal2-confirm swal2-styled"
          style="background:${spouseDisabled ? '#aaa' : '#1a2e4a'}; width:100px; ${spouseDisabled ? 'cursor:not-allowed;' : ''}"
          ${spouseDisabled ? 'disabled' : ''}>
          Spouse
        </button>` : ''}
        ${hasSpouse && !selfDisabled && !spouseDisabled ? `
        <button id="gc-both-btn" class="swal2-confirm swal2-styled"
          style="background:#1a2e4a; width:100px;">
          Both
        </button>` : ''}
        ${childButtonsHtml}
      </div>
    `,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    allowOutsideClick: false,
    didOpen: () => {
      const selfBtn = document.getElementById('gc-self-btn');
      const spouseBtn = document.getElementById('gc-spouse-btn');
      const bothBtn = document.getElementById('gc-both-btn');

      if (selfBtn && !selfDisabled) {
        selfBtn.addEventListener('click', () => {
          Swal.close();
          this.openResourceModal(item, 'self');
        });
      }
      if (spouseBtn && !spouseDisabled) {
        spouseBtn.addEventListener('click', () => {
          Swal.close();
          this.openResourceModal(item, 'spouse');
        });
      }
      if (bothBtn) {
        bothBtn.addEventListener('click', () => {
          Swal.close();
          this.openResourceModal(item, 'both');
        });
      }

      eligibleChildren.forEach((child: any, index: number) => {
        if (!childDisabledFlags[index]) {
          const childBtn = document.getElementById(`gc-child-btn-${index}`);
          childBtn?.addEventListener('click', () => {
            Swal.close();
            this.openResourceModal(item, `child_${child.id ?? index}` as any);
          });
        }
      });
    }
  });
}
isReorderBlockedUntilSep2026(item: any, coverage: 'self' | 'spouse' | 'both'): boolean {
  const key = item.typeOfForm?.trim().toLowerCase();
  const entry = this.eligibilityMap?.[key]?.[coverage];
  if (!entry?.nextAvailableDate) return false;
  const sep2026 = parseDateOnly('2026-09-01')!;
  const next = parseDateOnly(entry.nextAvailableDate);
  return !!next && next >= sep2026;
}
showBillableCharge = false;
  billableChargeBillingKey = '';

openMedcanCharge() {
  console.log('openMedcanCharge clicked, setting showBillableCharge = true');
  this.billableChargeBillingKey = 'medcan-galleri';
  this.showBillableCharge = true;
}



}

export function postalcodeValidator(control: FormControl): { [key: string]: any } | null {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null
}

function hasWhiteSpace(s: any) {
  return /\s/g.test(s);
}

